// source: base.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var google_protobuf_duration_pb = require('google-protobuf/google/protobuf/duration_pb.js');
goog.object.extend(proto, google_protobuf_duration_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var google_protobuf_any_pb = require('google-protobuf/google/protobuf/any_pb.js');
goog.object.extend(proto, google_protobuf_any_pb);
goog.exportSymbol('proto.base.v1.Achievement', null, global);
goog.exportSymbol('proto.base.v1.ActMgtControlPoint', null, global);
goog.exportSymbol('proto.base.v1.ActMgtCourseInfo', null, global);
goog.exportSymbol('proto.base.v1.ActMgtUserInGameInfo', null, global);
goog.exportSymbol('proto.base.v1.ActivityIdRequest', null, global);
goog.exportSymbol('proto.base.v1.AnswerDetailInfo', null, global);
goog.exportSymbol('proto.base.v1.AnswerHistoryInfo', null, global);
goog.exportSymbol('proto.base.v1.BackGroundColor', null, global);
goog.exportSymbol('proto.base.v1.BaseMapInfo', null, global);
goog.exportSymbol('proto.base.v1.BinaryPart', null, global);
goog.exportSymbol('proto.base.v1.BinaryPartV2', null, global);
goog.exportSymbol('proto.base.v1.CState', null, global);
goog.exportSymbol('proto.base.v1.CType', null, global);
goog.exportSymbol('proto.base.v1.ControlInfoList', null, global);
goog.exportSymbol('proto.base.v1.ControlPoint', null, global);
goog.exportSymbol('proto.base.v1.ControlPointDisplayCapture', null, global);
goog.exportSymbol('proto.base.v1.ControlPointDisplayHtml', null, global);
goog.exportSymbol('proto.base.v1.ControlPointDisplayInfoSingleChoice', null, global);
goog.exportSymbol('proto.base.v1.ControlPointDisplayString', null, global);
goog.exportSymbol('proto.base.v1.ControlPointGameInfo', null, global);
goog.exportSymbol('proto.base.v1.ControlPointInfo', null, global);
goog.exportSymbol('proto.base.v1.ControlPointSimple', null, global);
goog.exportSymbol('proto.base.v1.ControlPointTaskString', null, global);
goog.exportSymbol('proto.base.v1.CourseBase', null, global);
goog.exportSymbol('proto.base.v1.CourseBaseInfo', null, global);
goog.exportSymbol('proto.base.v1.CourseInfo', null, global);
goog.exportSymbol('proto.base.v1.CriterionType', null, global);
goog.exportSymbol('proto.base.v1.DefaultReply', null, global);
goog.exportSymbol('proto.base.v1.DefaultRequest', null, global);
goog.exportSymbol('proto.base.v1.ErrorCode', null, global);
goog.exportSymbol('proto.base.v1.GameArriveControlPoint', null, global);
goog.exportSymbol('proto.base.v1.GameDetailV2Reply', null, global);
goog.exportSymbol('proto.base.v1.GameGpsInfo', null, global);
goog.exportSymbol('proto.base.v1.GameHistorySource', null, global);
goog.exportSymbol('proto.base.v1.GameState', null, global);
goog.exportSymbol('proto.base.v1.GetQiNiuUpTokenReply', null, global);
goog.exportSymbol('proto.base.v1.GetServerTimeRp', null, global);
goog.exportSymbol('proto.base.v1.GetSmsSendLeftTimeReply', null, global);
goog.exportSymbol('proto.base.v1.GetSmsSendLeftTimeRequest', null, global);
goog.exportSymbol('proto.base.v1.HeartRate', null, global);
goog.exportSymbol('proto.base.v1.HrBandType', null, global);
goog.exportSymbol('proto.base.v1.IdArrRequest', null, global);
goog.exportSymbol('proto.base.v1.IdRequest', null, global);
goog.exportSymbol('proto.base.v1.Image', null, global);
goog.exportSymbol('proto.base.v1.LoginSource', null, global);
goog.exportSymbol('proto.base.v1.MapListRequestV2', null, global);
goog.exportSymbol('proto.base.v1.MapRoute', null, global);
goog.exportSymbol('proto.base.v1.NetImage', null, global);
goog.exportSymbol('proto.base.v1.OrienteerBaseInfo', null, global);
goog.exportSymbol('proto.base.v1.OrienteerBodyInfo', null, global);
goog.exportSymbol('proto.base.v1.OrienteerGameSaveControlPoint', null, global);
goog.exportSymbol('proto.base.v1.OrienteerGameSaveInfo', null, global);
goog.exportSymbol('proto.base.v1.OrienteerGpsInfo', null, global);
goog.exportSymbol('proto.base.v1.OrienteerHrInfo', null, global);
goog.exportSymbol('proto.base.v1.OrienteerOtherInfo', null, global);
goog.exportSymbol('proto.base.v1.Position', null, global);
goog.exportSymbol('proto.base.v1.ProjectContentType', null, global);
goog.exportSymbol('proto.base.v1.QrCodeInfo', null, global);
goog.exportSymbol('proto.base.v1.Region', null, global);
goog.exportSymbol('proto.base.v1.ShopList', null, global);
goog.exportSymbol('proto.base.v1.ShopType', null, global);
goog.exportSymbol('proto.base.v1.SignInReply', null, global);
goog.exportSymbol('proto.base.v1.SmsType', null, global);
goog.exportSymbol('proto.base.v1.StatusEditRequest', null, global);
goog.exportSymbol('proto.base.v1.StatusType', null, global);
goog.exportSymbol('proto.base.v1.ToActInfoSelect', null, global);
goog.exportSymbol('proto.base.v1.ToActionBasicInfo', null, global);
goog.exportSymbol('proto.base.v1.ToActionDetailReply', null, global);
goog.exportSymbol('proto.base.v1.ToActionInfo', null, global);
goog.exportSymbol('proto.base.v1.ToActionListReply', null, global);
goog.exportSymbol('proto.base.v1.ToActionRankInfo', null, global);
goog.exportSymbol('proto.base.v1.ToActionSimple', null, global);
goog.exportSymbol('proto.base.v1.ToActionUsersDetailReply', null, global);
goog.exportSymbol('proto.base.v1.ToActivityRegusterEditRequest', null, global);
goog.exportSymbol('proto.base.v1.ToActivityRegusterInfo', null, global);
goog.exportSymbol('proto.base.v1.ToActivityRegusterListReply', null, global);
goog.exportSymbol('proto.base.v1.ToActivityRegusterListRequest', null, global);
goog.exportSymbol('proto.base.v1.ToControlPoint', null, global);
goog.exportSymbol('proto.base.v1.ToCourseInfoSelect', null, global);
goog.exportSymbol('proto.base.v1.ToGameDetailReply', null, global);
goog.exportSymbol('proto.base.v1.ToGameRankingReply', null, global);
goog.exportSymbol('proto.base.v1.ToGameRankingRequest', null, global);
goog.exportSymbol('proto.base.v1.ToGetBinaryByMd5Request', null, global);
goog.exportSymbol('proto.base.v1.ToGetUpdateVersionReply', null, global);
goog.exportSymbol('proto.base.v1.ToGetUpdateVersionRequest', null, global);
goog.exportSymbol('proto.base.v1.ToHisUserBasic', null, global);
goog.exportSymbol('proto.base.v1.ToHisUserInfo', null, global);
goog.exportSymbol('proto.base.v1.ToHisUserListQueryReply', null, global);
goog.exportSymbol('proto.base.v1.ToMapDetailReply', null, global);
goog.exportSymbol('proto.base.v1.ToMapInfo', null, global);
goog.exportSymbol('proto.base.v1.ToMapInfoV2', null, global);
goog.exportSymbol('proto.base.v1.ToMapListReply', null, global);
goog.exportSymbol('proto.base.v1.ToMapListReplyV2', null, global);
goog.exportSymbol('proto.base.v1.ToMapSimple', null, global);
goog.exportSymbol('proto.base.v1.ToMapSimpleV2', null, global);
goog.exportSymbol('proto.base.v1.ToNextControlPointInGameReply', null, global);
goog.exportSymbol('proto.base.v1.ToOrienteerInGameInfo', null, global);
goog.exportSymbol('proto.base.v1.ToOrienteerRankInfo', null, global);
goog.exportSymbol('proto.base.v1.ToSendCodeToPhoneRequestV2', null, global);
goog.exportSymbol('proto.base.v1.ToSignInRequestV2', null, global);
goog.exportSymbol('proto.base.v1.ToUserDetailQueryReplyV2', null, global);
goog.exportSymbol('proto.base.v1.ToUserDetailQueryRequestV2', null, global);
goog.exportSymbol('proto.base.v1.ToUserGpsQueryReply', null, global);
goog.exportSymbol('proto.base.v1.ToUserInActionBasicInfo', null, global);
goog.exportSymbol('proto.base.v1.ToUserInActionBasicQueryRequest', null, global);
goog.exportSymbol('proto.base.v1.ToUserInActionBasicQueryV2Request', null, global);
goog.exportSymbol('proto.base.v1.User', null, global);
goog.exportSymbol('proto.base.v1.User.Sex', null, global);
goog.exportSymbol('proto.base.v1.UserArriveControlPoint', null, global);
goog.exportSymbol('proto.base.v1.UserGpsInfo', null, global);
goog.exportSymbol('proto.base.v1.UserInGameInfo', null, global);
goog.exportSymbol('proto.base.v1.UserType', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.NetImage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.base.v1.NetImage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.NetImage.displayName = 'proto.base.v1.NetImage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.User = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.base.v1.User, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.User.displayName = 'proto.base.v1.User';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.GameGpsInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.base.v1.GameGpsInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.GameGpsInfo.displayName = 'proto.base.v1.GameGpsInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.HeartRate = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.base.v1.HeartRate, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.HeartRate.displayName = 'proto.base.v1.HeartRate';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.SignInReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.base.v1.SignInReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.SignInReply.displayName = 'proto.base.v1.SignInReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.GetQiNiuUpTokenReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.base.v1.GetQiNiuUpTokenReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.GetQiNiuUpTokenReply.displayName = 'proto.base.v1.GetQiNiuUpTokenReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.GameArriveControlPoint = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.base.v1.GameArriveControlPoint, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.GameArriveControlPoint.displayName = 'proto.base.v1.GameArriveControlPoint';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.ActivityIdRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.base.v1.ActivityIdRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.ActivityIdRequest.displayName = 'proto.base.v1.ActivityIdRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.MapRoute = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.base.v1.MapRoute, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.MapRoute.displayName = 'proto.base.v1.MapRoute';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.IdArrRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.base.v1.IdArrRequest.repeatedFields_, null);
};
goog.inherits(proto.base.v1.IdArrRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.IdArrRequest.displayName = 'proto.base.v1.IdArrRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.BaseMapInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.base.v1.BaseMapInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.BaseMapInfo.displayName = 'proto.base.v1.BaseMapInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.Region = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.base.v1.Region, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.Region.displayName = 'proto.base.v1.Region';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.ShopList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.base.v1.ShopList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.ShopList.displayName = 'proto.base.v1.ShopList';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.GetSmsSendLeftTimeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.base.v1.GetSmsSendLeftTimeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.GetSmsSendLeftTimeRequest.displayName = 'proto.base.v1.GetSmsSendLeftTimeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.GetSmsSendLeftTimeReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.base.v1.GetSmsSendLeftTimeReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.GetSmsSendLeftTimeReply.displayName = 'proto.base.v1.GetSmsSendLeftTimeReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.ControlInfoList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.base.v1.ControlInfoList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.ControlInfoList.displayName = 'proto.base.v1.ControlInfoList';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.DefaultReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.base.v1.DefaultReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.DefaultReply.displayName = 'proto.base.v1.DefaultReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.IdRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.base.v1.IdRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.IdRequest.displayName = 'proto.base.v1.IdRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.DefaultRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.base.v1.DefaultRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.DefaultRequest.displayName = 'proto.base.v1.DefaultRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.Position = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.base.v1.Position, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.Position.displayName = 'proto.base.v1.Position';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.BinaryPart = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.base.v1.BinaryPart, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.BinaryPart.displayName = 'proto.base.v1.BinaryPart';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.BinaryPartV2 = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.base.v1.BinaryPartV2, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.BinaryPartV2.displayName = 'proto.base.v1.BinaryPartV2';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.Image = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.base.v1.Image, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.Image.displayName = 'proto.base.v1.Image';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.StatusEditRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.base.v1.StatusEditRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.StatusEditRequest.displayName = 'proto.base.v1.StatusEditRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.CourseInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.base.v1.CourseInfo.repeatedFields_, null);
};
goog.inherits(proto.base.v1.CourseInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.CourseInfo.displayName = 'proto.base.v1.CourseInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.QrCodeInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.base.v1.QrCodeInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.QrCodeInfo.displayName = 'proto.base.v1.QrCodeInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.ControlPointInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.base.v1.ControlPointInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.ControlPointInfo.displayName = 'proto.base.v1.ControlPointInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.ControlPointDisplayInfoSingleChoice = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.base.v1.ControlPointDisplayInfoSingleChoice.repeatedFields_, null);
};
goog.inherits(proto.base.v1.ControlPointDisplayInfoSingleChoice, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.ControlPointDisplayInfoSingleChoice.displayName = 'proto.base.v1.ControlPointDisplayInfoSingleChoice';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.ControlPointDisplayCapture = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.base.v1.ControlPointDisplayCapture, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.ControlPointDisplayCapture.displayName = 'proto.base.v1.ControlPointDisplayCapture';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.ControlPointDisplayString = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.base.v1.ControlPointDisplayString, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.ControlPointDisplayString.displayName = 'proto.base.v1.ControlPointDisplayString';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.ControlPointTaskString = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.base.v1.ControlPointTaskString, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.ControlPointTaskString.displayName = 'proto.base.v1.ControlPointTaskString';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.ControlPointDisplayHtml = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.base.v1.ControlPointDisplayHtml, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.ControlPointDisplayHtml.displayName = 'proto.base.v1.ControlPointDisplayHtml';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.ControlPoint = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.base.v1.ControlPoint.repeatedFields_, null);
};
goog.inherits(proto.base.v1.ControlPoint, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.ControlPoint.displayName = 'proto.base.v1.ControlPoint';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.ControlPointSimple = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.base.v1.ControlPointSimple.repeatedFields_, null);
};
goog.inherits(proto.base.v1.ControlPointSimple, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.ControlPointSimple.displayName = 'proto.base.v1.ControlPointSimple';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.GameDetailV2Reply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.base.v1.GameDetailV2Reply.repeatedFields_, null);
};
goog.inherits(proto.base.v1.GameDetailV2Reply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.GameDetailV2Reply.displayName = 'proto.base.v1.GameDetailV2Reply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.OrienteerBodyInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.base.v1.OrienteerBodyInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.OrienteerBodyInfo.displayName = 'proto.base.v1.OrienteerBodyInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.ControlPointGameInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.base.v1.ControlPointGameInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.ControlPointGameInfo.displayName = 'proto.base.v1.ControlPointGameInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.AnswerHistoryInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.base.v1.AnswerHistoryInfo.repeatedFields_, null);
};
goog.inherits(proto.base.v1.AnswerHistoryInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.AnswerHistoryInfo.displayName = 'proto.base.v1.AnswerHistoryInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.AnswerDetailInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.base.v1.AnswerDetailInfo.repeatedFields_, null);
};
goog.inherits(proto.base.v1.AnswerDetailInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.AnswerDetailInfo.displayName = 'proto.base.v1.AnswerDetailInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.ToActivityRegusterEditRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.base.v1.ToActivityRegusterEditRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.ToActivityRegusterEditRequest.displayName = 'proto.base.v1.ToActivityRegusterEditRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.ToActivityRegusterListRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.base.v1.ToActivityRegusterListRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.ToActivityRegusterListRequest.displayName = 'proto.base.v1.ToActivityRegusterListRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.ToActivityRegusterListReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.base.v1.ToActivityRegusterListReply.repeatedFields_, null);
};
goog.inherits(proto.base.v1.ToActivityRegusterListReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.ToActivityRegusterListReply.displayName = 'proto.base.v1.ToActivityRegusterListReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.ToActivityRegusterInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.base.v1.ToActivityRegusterInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.ToActivityRegusterInfo.displayName = 'proto.base.v1.ToActivityRegusterInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.ToGameRankingRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.base.v1.ToGameRankingRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.ToGameRankingRequest.displayName = 'proto.base.v1.ToGameRankingRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.ToGameRankingReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.base.v1.ToGameRankingReply.repeatedFields_, null);
};
goog.inherits(proto.base.v1.ToGameRankingReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.ToGameRankingReply.displayName = 'proto.base.v1.ToGameRankingReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.ToActionRankInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.base.v1.ToActionRankInfo.repeatedFields_, null);
};
goog.inherits(proto.base.v1.ToActionRankInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.ToActionRankInfo.displayName = 'proto.base.v1.ToActionRankInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.ToOrienteerRankInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.base.v1.ToOrienteerRankInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.ToOrienteerRankInfo.displayName = 'proto.base.v1.ToOrienteerRankInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.ToGetUpdateVersionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.base.v1.ToGetUpdateVersionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.ToGetUpdateVersionRequest.displayName = 'proto.base.v1.ToGetUpdateVersionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.ToGetUpdateVersionReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.base.v1.ToGetUpdateVersionReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.ToGetUpdateVersionReply.displayName = 'proto.base.v1.ToGetUpdateVersionReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.ToGameDetailReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.base.v1.ToGameDetailReply.repeatedFields_, null);
};
goog.inherits(proto.base.v1.ToGameDetailReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.ToGameDetailReply.displayName = 'proto.base.v1.ToGameDetailReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.ToHisUserListQueryReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.base.v1.ToHisUserListQueryReply.repeatedFields_, null);
};
goog.inherits(proto.base.v1.ToHisUserListQueryReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.ToHisUserListQueryReply.displayName = 'proto.base.v1.ToHisUserListQueryReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.ToHisUserBasic = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.base.v1.ToHisUserBasic.repeatedFields_, null);
};
goog.inherits(proto.base.v1.ToHisUserBasic, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.ToHisUserBasic.displayName = 'proto.base.v1.ToHisUserBasic';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.ToHisUserInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.base.v1.ToHisUserInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.ToHisUserInfo.displayName = 'proto.base.v1.ToHisUserInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.ToUserInActionBasicQueryRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.base.v1.ToUserInActionBasicQueryRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.ToUserInActionBasicQueryRequest.displayName = 'proto.base.v1.ToUserInActionBasicQueryRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.ToUserInActionBasicQueryV2Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.base.v1.ToUserInActionBasicQueryV2Request.repeatedFields_, null);
};
goog.inherits(proto.base.v1.ToUserInActionBasicQueryV2Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.ToUserInActionBasicQueryV2Request.displayName = 'proto.base.v1.ToUserInActionBasicQueryV2Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.ToGetBinaryByMd5Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.base.v1.ToGetBinaryByMd5Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.ToGetBinaryByMd5Request.displayName = 'proto.base.v1.ToGetBinaryByMd5Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.GetServerTimeRp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.base.v1.GetServerTimeRp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.GetServerTimeRp.displayName = 'proto.base.v1.GetServerTimeRp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.ToSendCodeToPhoneRequestV2 = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.base.v1.ToSendCodeToPhoneRequestV2, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.ToSendCodeToPhoneRequestV2.displayName = 'proto.base.v1.ToSendCodeToPhoneRequestV2';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.ToSignInRequestV2 = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.base.v1.ToSignInRequestV2, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.ToSignInRequestV2.displayName = 'proto.base.v1.ToSignInRequestV2';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.MapListRequestV2 = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.base.v1.MapListRequestV2, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.MapListRequestV2.displayName = 'proto.base.v1.MapListRequestV2';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.ToMapListReplyV2 = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.base.v1.ToMapListReplyV2.repeatedFields_, null);
};
goog.inherits(proto.base.v1.ToMapListReplyV2, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.ToMapListReplyV2.displayName = 'proto.base.v1.ToMapListReplyV2';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.ToMapSimpleV2 = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.base.v1.ToMapSimpleV2, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.ToMapSimpleV2.displayName = 'proto.base.v1.ToMapSimpleV2';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.ToMapInfoV2 = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.base.v1.ToMapInfoV2, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.ToMapInfoV2.displayName = 'proto.base.v1.ToMapInfoV2';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.ToUserDetailQueryRequestV2 = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.base.v1.ToUserDetailQueryRequestV2, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.ToUserDetailQueryRequestV2.displayName = 'proto.base.v1.ToUserDetailQueryRequestV2';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.ToUserDetailQueryReplyV2 = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.base.v1.ToUserDetailQueryReplyV2.repeatedFields_, null);
};
goog.inherits(proto.base.v1.ToUserDetailQueryReplyV2, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.ToUserDetailQueryReplyV2.displayName = 'proto.base.v1.ToUserDetailQueryReplyV2';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.ToActionInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.base.v1.ToActionInfo.repeatedFields_, null);
};
goog.inherits(proto.base.v1.ToActionInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.ToActionInfo.displayName = 'proto.base.v1.ToActionInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.ToActionBasicInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.base.v1.ToActionBasicInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.ToActionBasicInfo.displayName = 'proto.base.v1.ToActionBasicInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.ToOrienteerInGameInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.base.v1.ToOrienteerInGameInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.ToOrienteerInGameInfo.displayName = 'proto.base.v1.ToOrienteerInGameInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.ToUserInActionBasicInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.base.v1.ToUserInActionBasicInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.ToUserInActionBasicInfo.displayName = 'proto.base.v1.ToUserInActionBasicInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.OrienteerBaseInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.base.v1.OrienteerBaseInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.OrienteerBaseInfo.displayName = 'proto.base.v1.OrienteerBaseInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.OrienteerGpsInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.base.v1.OrienteerGpsInfo.repeatedFields_, null);
};
goog.inherits(proto.base.v1.OrienteerGpsInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.OrienteerGpsInfo.displayName = 'proto.base.v1.OrienteerGpsInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.OrienteerHrInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.base.v1.OrienteerHrInfo.repeatedFields_, null);
};
goog.inherits(proto.base.v1.OrienteerHrInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.OrienteerHrInfo.displayName = 'proto.base.v1.OrienteerHrInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.OrienteerOtherInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.base.v1.OrienteerOtherInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.OrienteerOtherInfo.displayName = 'proto.base.v1.OrienteerOtherInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.CourseBaseInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.base.v1.CourseBaseInfo.repeatedFields_, null);
};
goog.inherits(proto.base.v1.CourseBaseInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.CourseBaseInfo.displayName = 'proto.base.v1.CourseBaseInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.CourseBase = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.base.v1.CourseBase, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.CourseBase.displayName = 'proto.base.v1.CourseBase';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.ToControlPoint = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.base.v1.ToControlPoint, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.ToControlPoint.displayName = 'proto.base.v1.ToControlPoint';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.OrienteerGameSaveInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.base.v1.OrienteerGameSaveInfo.repeatedFields_, null);
};
goog.inherits(proto.base.v1.OrienteerGameSaveInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.OrienteerGameSaveInfo.displayName = 'proto.base.v1.OrienteerGameSaveInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.OrienteerGameSaveControlPoint = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.base.v1.OrienteerGameSaveControlPoint, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.OrienteerGameSaveControlPoint.displayName = 'proto.base.v1.OrienteerGameSaveControlPoint';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.Achievement = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.base.v1.Achievement, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.Achievement.displayName = 'proto.base.v1.Achievement';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.ToMapListReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.base.v1.ToMapListReply.repeatedFields_, null);
};
goog.inherits(proto.base.v1.ToMapListReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.ToMapListReply.displayName = 'proto.base.v1.ToMapListReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.ToMapSimple = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.base.v1.ToMapSimple, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.ToMapSimple.displayName = 'proto.base.v1.ToMapSimple';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.ToMapDetailReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.base.v1.ToMapDetailReply.repeatedFields_, null);
};
goog.inherits(proto.base.v1.ToMapDetailReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.ToMapDetailReply.displayName = 'proto.base.v1.ToMapDetailReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.ToActInfoSelect = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.base.v1.ToActInfoSelect.repeatedFields_, null);
};
goog.inherits(proto.base.v1.ToActInfoSelect, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.ToActInfoSelect.displayName = 'proto.base.v1.ToActInfoSelect';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.ToCourseInfoSelect = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.base.v1.ToCourseInfoSelect, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.ToCourseInfoSelect.displayName = 'proto.base.v1.ToCourseInfoSelect';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.ToActionListReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.base.v1.ToActionListReply.repeatedFields_, null);
};
goog.inherits(proto.base.v1.ToActionListReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.ToActionListReply.displayName = 'proto.base.v1.ToActionListReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.ToActionSimple = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.base.v1.ToActionSimple, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.ToActionSimple.displayName = 'proto.base.v1.ToActionSimple';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.ToActionDetailReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.base.v1.ToActionDetailReply.repeatedFields_, null);
};
goog.inherits(proto.base.v1.ToActionDetailReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.ToActionDetailReply.displayName = 'proto.base.v1.ToActionDetailReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.ToActionUsersDetailReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.base.v1.ToActionUsersDetailReply.repeatedFields_, null);
};
goog.inherits(proto.base.v1.ToActionUsersDetailReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.ToActionUsersDetailReply.displayName = 'proto.base.v1.ToActionUsersDetailReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.UserInGameInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.base.v1.UserInGameInfo.repeatedFields_, null);
};
goog.inherits(proto.base.v1.UserInGameInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.UserInGameInfo.displayName = 'proto.base.v1.UserInGameInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.UserArriveControlPoint = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.base.v1.UserArriveControlPoint, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.UserArriveControlPoint.displayName = 'proto.base.v1.UserArriveControlPoint';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.ToNextControlPointInGameReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.base.v1.ToNextControlPointInGameReply.repeatedFields_, null);
};
goog.inherits(proto.base.v1.ToNextControlPointInGameReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.ToNextControlPointInGameReply.displayName = 'proto.base.v1.ToNextControlPointInGameReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.ToUserGpsQueryReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.base.v1.ToUserGpsQueryReply.repeatedFields_, null);
};
goog.inherits(proto.base.v1.ToUserGpsQueryReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.ToUserGpsQueryReply.displayName = 'proto.base.v1.ToUserGpsQueryReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.UserGpsInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.base.v1.UserGpsInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.UserGpsInfo.displayName = 'proto.base.v1.UserGpsInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.ToMapInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.base.v1.ToMapInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.ToMapInfo.displayName = 'proto.base.v1.ToMapInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.ActMgtCourseInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.base.v1.ActMgtCourseInfo.repeatedFields_, null);
};
goog.inherits(proto.base.v1.ActMgtCourseInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.ActMgtCourseInfo.displayName = 'proto.base.v1.ActMgtCourseInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.ActMgtControlPoint = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.base.v1.ActMgtControlPoint, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.ActMgtControlPoint.displayName = 'proto.base.v1.ActMgtControlPoint';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.base.v1.ActMgtUserInGameInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.base.v1.ActMgtUserInGameInfo.repeatedFields_, null);
};
goog.inherits(proto.base.v1.ActMgtUserInGameInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.base.v1.ActMgtUserInGameInfo.displayName = 'proto.base.v1.ActMgtUserInGameInfo';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.NetImage.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.NetImage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.NetImage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.NetImage.toObject = function(includeInstance, msg) {
  var f, obj = {
url: jspb.Message.getFieldWithDefault(msg, 1, ""),
md5: msg.getMd5_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.NetImage}
 */
proto.base.v1.NetImage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.NetImage;
  return proto.base.v1.NetImage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.NetImage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.NetImage}
 */
proto.base.v1.NetImage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    case 2:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setMd5(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.NetImage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.NetImage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.NetImage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.NetImage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMd5_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      2,
      f
    );
  }
};


/**
 * optional string url = 1;
 * @return {string}
 */
proto.base.v1.NetImage.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.v1.NetImage} returns this
 */
proto.base.v1.NetImage.prototype.setUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bytes md5 = 2;
 * @return {string}
 */
proto.base.v1.NetImage.prototype.getMd5 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * optional bytes md5 = 2;
 * This is a type-conversion wrapper around `getMd5()`
 * @return {string}
 */
proto.base.v1.NetImage.prototype.getMd5_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getMd5()));
};


/**
 * optional bytes md5 = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getMd5()`
 * @return {!Uint8Array}
 */
proto.base.v1.NetImage.prototype.getMd5_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getMd5()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.base.v1.NetImage} returns this
 */
proto.base.v1.NetImage.prototype.setMd5 = function(value) {
  return jspb.Message.setProto3BytesField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.User.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.User.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.User} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.User.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.User}
 */
proto.base.v1.User.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.User;
  return proto.base.v1.User.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.User} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.User}
 */
proto.base.v1.User.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.User.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.User.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.User} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.User.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.base.v1.User.Sex = {
  UNDEFINE: 0,
  MALE: 1,
  FEMALE: 2
};




if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.GameGpsInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.GameGpsInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.GameGpsInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.GameGpsInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
gpstime: (f = msg.getGpstime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
longitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
latitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
directionradian: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
altitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.GameGpsInfo}
 */
proto.base.v1.GameGpsInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.GameGpsInfo;
  return proto.base.v1.GameGpsInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.GameGpsInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.GameGpsInfo}
 */
proto.base.v1.GameGpsInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setGpstime(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLongitude(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLatitude(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setDirectionradian(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAltitude(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.GameGpsInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.GameGpsInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.GameGpsInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.GameGpsInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGpstime();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getLongitude();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getLatitude();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getDirectionradian();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getAltitude();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
};


/**
 * optional google.protobuf.Timestamp gpsTime = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.base.v1.GameGpsInfo.prototype.getGpstime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.base.v1.GameGpsInfo} returns this
*/
proto.base.v1.GameGpsInfo.prototype.setGpstime = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.base.v1.GameGpsInfo} returns this
 */
proto.base.v1.GameGpsInfo.prototype.clearGpstime = function() {
  return this.setGpstime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.base.v1.GameGpsInfo.prototype.hasGpstime = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional double longitude = 2;
 * @return {number}
 */
proto.base.v1.GameGpsInfo.prototype.getLongitude = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.GameGpsInfo} returns this
 */
proto.base.v1.GameGpsInfo.prototype.setLongitude = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional double latitude = 3;
 * @return {number}
 */
proto.base.v1.GameGpsInfo.prototype.getLatitude = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.GameGpsInfo} returns this
 */
proto.base.v1.GameGpsInfo.prototype.setLatitude = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional double directionRadian = 4;
 * @return {number}
 */
proto.base.v1.GameGpsInfo.prototype.getDirectionradian = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.GameGpsInfo} returns this
 */
proto.base.v1.GameGpsInfo.prototype.setDirectionradian = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional double altitude = 5;
 * @return {number}
 */
proto.base.v1.GameGpsInfo.prototype.getAltitude = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.GameGpsInfo} returns this
 */
proto.base.v1.GameGpsInfo.prototype.setAltitude = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.HeartRate.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.HeartRate.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.HeartRate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.HeartRate.toObject = function(includeInstance, msg) {
  var f, obj = {
timestampms: jspb.Message.getFieldWithDefault(msg, 1, 0),
hr: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.HeartRate}
 */
proto.base.v1.HeartRate.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.HeartRate;
  return proto.base.v1.HeartRate.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.HeartRate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.HeartRate}
 */
proto.base.v1.HeartRate.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTimestampms(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setHr(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.HeartRate.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.HeartRate.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.HeartRate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.HeartRate.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTimestampms();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getHr();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional int64 timeStampMs = 1;
 * @return {number}
 */
proto.base.v1.HeartRate.prototype.getTimestampms = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.HeartRate} returns this
 */
proto.base.v1.HeartRate.prototype.setTimestampms = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 hr = 2;
 * @return {number}
 */
proto.base.v1.HeartRate.prototype.getHr = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.HeartRate} returns this
 */
proto.base.v1.HeartRate.prototype.setHr = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.SignInReply.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.SignInReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.SignInReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.SignInReply.toObject = function(includeInstance, msg) {
  var f, obj = {
token: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.SignInReply}
 */
proto.base.v1.SignInReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.SignInReply;
  return proto.base.v1.SignInReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.SignInReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.SignInReply}
 */
proto.base.v1.SignInReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setToken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.SignInReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.SignInReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.SignInReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.SignInReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getToken();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string token = 1;
 * @return {string}
 */
proto.base.v1.SignInReply.prototype.getToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.v1.SignInReply} returns this
 */
proto.base.v1.SignInReply.prototype.setToken = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.GetQiNiuUpTokenReply.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.GetQiNiuUpTokenReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.GetQiNiuUpTokenReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.GetQiNiuUpTokenReply.toObject = function(includeInstance, msg) {
  var f, obj = {
uptoken: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.GetQiNiuUpTokenReply}
 */
proto.base.v1.GetQiNiuUpTokenReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.GetQiNiuUpTokenReply;
  return proto.base.v1.GetQiNiuUpTokenReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.GetQiNiuUpTokenReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.GetQiNiuUpTokenReply}
 */
proto.base.v1.GetQiNiuUpTokenReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUptoken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.GetQiNiuUpTokenReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.GetQiNiuUpTokenReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.GetQiNiuUpTokenReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.GetQiNiuUpTokenReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUptoken();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string upToken = 1;
 * @return {string}
 */
proto.base.v1.GetQiNiuUpTokenReply.prototype.getUptoken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.v1.GetQiNiuUpTokenReply} returns this
 */
proto.base.v1.GetQiNiuUpTokenReply.prototype.setUptoken = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.GameArriveControlPoint.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.GameArriveControlPoint.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.GameArriveControlPoint} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.GameArriveControlPoint.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
sn: jspb.Message.getFieldWithDefault(msg, 2, ""),
orderno: jspb.Message.getFieldWithDefault(msg, 3, 0),
totalno: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.GameArriveControlPoint}
 */
proto.base.v1.GameArriveControlPoint.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.GameArriveControlPoint;
  return proto.base.v1.GameArriveControlPoint.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.GameArriveControlPoint} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.GameArriveControlPoint}
 */
proto.base.v1.GameArriveControlPoint.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSn(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOrderno(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalno(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.GameArriveControlPoint.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.GameArriveControlPoint.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.GameArriveControlPoint} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.GameArriveControlPoint.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getSn();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getOrderno();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getTotalno();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.base.v1.GameArriveControlPoint.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.GameArriveControlPoint} returns this
 */
proto.base.v1.GameArriveControlPoint.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string sn = 2;
 * @return {string}
 */
proto.base.v1.GameArriveControlPoint.prototype.getSn = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.v1.GameArriveControlPoint} returns this
 */
proto.base.v1.GameArriveControlPoint.prototype.setSn = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 orderNo = 3;
 * @return {number}
 */
proto.base.v1.GameArriveControlPoint.prototype.getOrderno = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.GameArriveControlPoint} returns this
 */
proto.base.v1.GameArriveControlPoint.prototype.setOrderno = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 totalNo = 4;
 * @return {number}
 */
proto.base.v1.GameArriveControlPoint.prototype.getTotalno = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.GameArriveControlPoint} returns this
 */
proto.base.v1.GameArriveControlPoint.prototype.setTotalno = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.ActivityIdRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.ActivityIdRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.ActivityIdRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ActivityIdRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
matchtype: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.ActivityIdRequest}
 */
proto.base.v1.ActivityIdRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.ActivityIdRequest;
  return proto.base.v1.ActivityIdRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.ActivityIdRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.ActivityIdRequest}
 */
proto.base.v1.ActivityIdRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMatchtype(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.ActivityIdRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.ActivityIdRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.ActivityIdRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ActivityIdRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getMatchtype();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.base.v1.ActivityIdRequest.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ActivityIdRequest} returns this
 */
proto.base.v1.ActivityIdRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 matchType = 2;
 * @return {number}
 */
proto.base.v1.ActivityIdRequest.prototype.getMatchtype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ActivityIdRequest} returns this
 */
proto.base.v1.ActivityIdRequest.prototype.setMatchtype = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.MapRoute.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.MapRoute.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.MapRoute} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.MapRoute.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
image: (f = msg.getImage()) && proto.base.v1.NetImage.toObject(includeInstance, f),
isnfc: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
distancemeter: jspb.Message.getFieldWithDefault(msg, 5, 0),
altitudediffmeter: jspb.Message.getFieldWithDefault(msg, 6, 0),
usecount: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.MapRoute}
 */
proto.base.v1.MapRoute.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.MapRoute;
  return proto.base.v1.MapRoute.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.MapRoute} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.MapRoute}
 */
proto.base.v1.MapRoute.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = new proto.base.v1.NetImage;
      reader.readMessage(value,proto.base.v1.NetImage.deserializeBinaryFromReader);
      msg.setImage(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsnfc(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDistancemeter(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAltitudediffmeter(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUsecount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.MapRoute.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.MapRoute.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.MapRoute} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.MapRoute.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getImage();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.base.v1.NetImage.serializeBinaryToWriter
    );
  }
  f = message.getIsnfc();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getDistancemeter();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getAltitudediffmeter();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getUsecount();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.base.v1.MapRoute.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.MapRoute} returns this
 */
proto.base.v1.MapRoute.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.base.v1.MapRoute.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.v1.MapRoute} returns this
 */
proto.base.v1.MapRoute.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional NetImage image = 3;
 * @return {?proto.base.v1.NetImage}
 */
proto.base.v1.MapRoute.prototype.getImage = function() {
  return /** @type{?proto.base.v1.NetImage} */ (
    jspb.Message.getWrapperField(this, proto.base.v1.NetImage, 3));
};


/**
 * @param {?proto.base.v1.NetImage|undefined} value
 * @return {!proto.base.v1.MapRoute} returns this
*/
proto.base.v1.MapRoute.prototype.setImage = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.base.v1.MapRoute} returns this
 */
proto.base.v1.MapRoute.prototype.clearImage = function() {
  return this.setImage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.base.v1.MapRoute.prototype.hasImage = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional bool isNfc = 4;
 * @return {boolean}
 */
proto.base.v1.MapRoute.prototype.getIsnfc = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.base.v1.MapRoute} returns this
 */
proto.base.v1.MapRoute.prototype.setIsnfc = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional int32 distanceMeter = 5;
 * @return {number}
 */
proto.base.v1.MapRoute.prototype.getDistancemeter = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.MapRoute} returns this
 */
proto.base.v1.MapRoute.prototype.setDistancemeter = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 altitudeDiffMeter = 6;
 * @return {number}
 */
proto.base.v1.MapRoute.prototype.getAltitudediffmeter = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.MapRoute} returns this
 */
proto.base.v1.MapRoute.prototype.setAltitudediffmeter = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int32 useCount = 7;
 * @return {number}
 */
proto.base.v1.MapRoute.prototype.getUsecount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.MapRoute} returns this
 */
proto.base.v1.MapRoute.prototype.setUsecount = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.base.v1.IdArrRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.IdArrRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.IdArrRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.IdArrRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.IdArrRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
idarrList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.IdArrRequest}
 */
proto.base.v1.IdArrRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.IdArrRequest;
  return proto.base.v1.IdArrRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.IdArrRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.IdArrRequest}
 */
proto.base.v1.IdArrRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt32() : [reader.readInt32()]);
      for (var i = 0; i < values.length; i++) {
        msg.addIdarr(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.IdArrRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.IdArrRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.IdArrRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.IdArrRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIdarrList();
  if (f.length > 0) {
    writer.writePackedInt32(
      2,
      f
    );
  }
};


/**
 * repeated int32 IdArr = 2;
 * @return {!Array<number>}
 */
proto.base.v1.IdArrRequest.prototype.getIdarrList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.base.v1.IdArrRequest} returns this
 */
proto.base.v1.IdArrRequest.prototype.setIdarrList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.base.v1.IdArrRequest} returns this
 */
proto.base.v1.IdArrRequest.prototype.addIdarr = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.base.v1.IdArrRequest} returns this
 */
proto.base.v1.IdArrRequest.prototype.clearIdarrList = function() {
  return this.setIdarrList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.BaseMapInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.BaseMapInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.BaseMapInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.BaseMapInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
shopid: jspb.Message.getFieldWithDefault(msg, 1, 0),
mapname: jspb.Message.getFieldWithDefault(msg, 2, ""),
zipimage: (f = msg.getZipimage()) && proto.base.v1.NetImage.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.BaseMapInfo}
 */
proto.base.v1.BaseMapInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.BaseMapInfo;
  return proto.base.v1.BaseMapInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.BaseMapInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.BaseMapInfo}
 */
proto.base.v1.BaseMapInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setShopid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMapname(value);
      break;
    case 3:
      var value = new proto.base.v1.NetImage;
      reader.readMessage(value,proto.base.v1.NetImage.deserializeBinaryFromReader);
      msg.setZipimage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.BaseMapInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.BaseMapInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.BaseMapInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.BaseMapInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getShopid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getMapname();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getZipimage();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.base.v1.NetImage.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 shopId = 1;
 * @return {number}
 */
proto.base.v1.BaseMapInfo.prototype.getShopid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.BaseMapInfo} returns this
 */
proto.base.v1.BaseMapInfo.prototype.setShopid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string mapName = 2;
 * @return {string}
 */
proto.base.v1.BaseMapInfo.prototype.getMapname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.v1.BaseMapInfo} returns this
 */
proto.base.v1.BaseMapInfo.prototype.setMapname = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional NetImage zipImage = 3;
 * @return {?proto.base.v1.NetImage}
 */
proto.base.v1.BaseMapInfo.prototype.getZipimage = function() {
  return /** @type{?proto.base.v1.NetImage} */ (
    jspb.Message.getWrapperField(this, proto.base.v1.NetImage, 3));
};


/**
 * @param {?proto.base.v1.NetImage|undefined} value
 * @return {!proto.base.v1.BaseMapInfo} returns this
*/
proto.base.v1.BaseMapInfo.prototype.setZipimage = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.base.v1.BaseMapInfo} returns this
 */
proto.base.v1.BaseMapInfo.prototype.clearZipimage = function() {
  return this.setZipimage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.base.v1.BaseMapInfo.prototype.hasZipimage = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.Region.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.Region.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.Region} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.Region.toObject = function(includeInstance, msg) {
  var f, obj = {
code: jspb.Message.getFieldWithDefault(msg, 1, ""),
name: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.Region}
 */
proto.base.v1.Region.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.Region;
  return proto.base.v1.Region.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.Region} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.Region}
 */
proto.base.v1.Region.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.Region.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.Region.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.Region} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.Region.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string code = 1;
 * @return {string}
 */
proto.base.v1.Region.prototype.getCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.v1.Region} returns this
 */
proto.base.v1.Region.prototype.setCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.base.v1.Region.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.v1.Region} returns this
 */
proto.base.v1.Region.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.ShopList.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.ShopList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.ShopList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ShopList.toObject = function(includeInstance, msg) {
  var f, obj = {
shopid: jspb.Message.getFieldWithDefault(msg, 1, 0),
name: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.ShopList}
 */
proto.base.v1.ShopList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.ShopList;
  return proto.base.v1.ShopList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.ShopList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.ShopList}
 */
proto.base.v1.ShopList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setShopid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.ShopList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.ShopList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.ShopList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ShopList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getShopid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int32 shopId = 1;
 * @return {number}
 */
proto.base.v1.ShopList.prototype.getShopid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ShopList} returns this
 */
proto.base.v1.ShopList.prototype.setShopid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.base.v1.ShopList.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.v1.ShopList} returns this
 */
proto.base.v1.ShopList.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.GetSmsSendLeftTimeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.GetSmsSendLeftTimeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.GetSmsSendLeftTimeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.GetSmsSendLeftTimeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
phone: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.GetSmsSendLeftTimeRequest}
 */
proto.base.v1.GetSmsSendLeftTimeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.GetSmsSendLeftTimeRequest;
  return proto.base.v1.GetSmsSendLeftTimeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.GetSmsSendLeftTimeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.GetSmsSendLeftTimeRequest}
 */
proto.base.v1.GetSmsSendLeftTimeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhone(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.GetSmsSendLeftTimeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.GetSmsSendLeftTimeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.GetSmsSendLeftTimeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.GetSmsSendLeftTimeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPhone();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string phone = 1;
 * @return {string}
 */
proto.base.v1.GetSmsSendLeftTimeRequest.prototype.getPhone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.v1.GetSmsSendLeftTimeRequest} returns this
 */
proto.base.v1.GetSmsSendLeftTimeRequest.prototype.setPhone = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.GetSmsSendLeftTimeReply.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.GetSmsSendLeftTimeReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.GetSmsSendLeftTimeReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.GetSmsSendLeftTimeReply.toObject = function(includeInstance, msg) {
  var f, obj = {
second: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.GetSmsSendLeftTimeReply}
 */
proto.base.v1.GetSmsSendLeftTimeReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.GetSmsSendLeftTimeReply;
  return proto.base.v1.GetSmsSendLeftTimeReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.GetSmsSendLeftTimeReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.GetSmsSendLeftTimeReply}
 */
proto.base.v1.GetSmsSendLeftTimeReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSecond(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.GetSmsSendLeftTimeReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.GetSmsSendLeftTimeReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.GetSmsSendLeftTimeReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.GetSmsSendLeftTimeReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSecond();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 second = 1;
 * @return {number}
 */
proto.base.v1.GetSmsSendLeftTimeReply.prototype.getSecond = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.GetSmsSendLeftTimeReply} returns this
 */
proto.base.v1.GetSmsSendLeftTimeReply.prototype.setSecond = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.ControlInfoList.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.ControlInfoList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.ControlInfoList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ControlInfoList.toObject = function(includeInstance, msg) {
  var f, obj = {
ciid: jspb.Message.getFieldWithDefault(msg, 1, 0),
cicode: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.ControlInfoList}
 */
proto.base.v1.ControlInfoList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.ControlInfoList;
  return proto.base.v1.ControlInfoList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.ControlInfoList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.ControlInfoList}
 */
proto.base.v1.ControlInfoList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCiid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCicode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.ControlInfoList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.ControlInfoList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.ControlInfoList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ControlInfoList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCiid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getCicode();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int32 ciId = 1;
 * @return {number}
 */
proto.base.v1.ControlInfoList.prototype.getCiid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ControlInfoList} returns this
 */
proto.base.v1.ControlInfoList.prototype.setCiid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string ciCode = 2;
 * @return {string}
 */
proto.base.v1.ControlInfoList.prototype.getCicode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.v1.ControlInfoList} returns this
 */
proto.base.v1.ControlInfoList.prototype.setCicode = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.DefaultReply.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.DefaultReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.DefaultReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.DefaultReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.DefaultReply}
 */
proto.base.v1.DefaultReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.DefaultReply;
  return proto.base.v1.DefaultReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.DefaultReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.DefaultReply}
 */
proto.base.v1.DefaultReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.DefaultReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.DefaultReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.DefaultReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.DefaultReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.IdRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.IdRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.IdRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.IdRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.IdRequest}
 */
proto.base.v1.IdRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.IdRequest;
  return proto.base.v1.IdRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.IdRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.IdRequest}
 */
proto.base.v1.IdRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.IdRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.IdRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.IdRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.IdRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.base.v1.IdRequest.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.IdRequest} returns this
 */
proto.base.v1.IdRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.DefaultRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.DefaultRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.DefaultRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.DefaultRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.DefaultRequest}
 */
proto.base.v1.DefaultRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.DefaultRequest;
  return proto.base.v1.DefaultRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.DefaultRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.DefaultRequest}
 */
proto.base.v1.DefaultRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.DefaultRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.DefaultRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.DefaultRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.DefaultRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.Position.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.Position.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.Position} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.Position.toObject = function(includeInstance, msg) {
  var f, obj = {
longitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
latitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
altitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.Position}
 */
proto.base.v1.Position.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.Position;
  return proto.base.v1.Position.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.Position} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.Position}
 */
proto.base.v1.Position.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLongitude(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLatitude(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAltitude(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.Position.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.Position.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.Position} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.Position.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLongitude();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getLatitude();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getAltitude();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
};


/**
 * optional double longitude = 1;
 * @return {number}
 */
proto.base.v1.Position.prototype.getLongitude = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.Position} returns this
 */
proto.base.v1.Position.prototype.setLongitude = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional double latitude = 2;
 * @return {number}
 */
proto.base.v1.Position.prototype.getLatitude = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.Position} returns this
 */
proto.base.v1.Position.prototype.setLatitude = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional double altitude = 3;
 * @return {number}
 */
proto.base.v1.Position.prototype.getAltitude = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.Position} returns this
 */
proto.base.v1.Position.prototype.setAltitude = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.BinaryPart.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.BinaryPart.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.BinaryPart} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.BinaryPart.toObject = function(includeInstance, msg) {
  var f, obj = {
ext: jspb.Message.getFieldWithDefault(msg, 1, ""),
data: msg.getData_asB64(),
allcount: jspb.Message.getFieldWithDefault(msg, 3, 0),
nonce: msg.getNonce_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.BinaryPart}
 */
proto.base.v1.BinaryPart.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.BinaryPart;
  return proto.base.v1.BinaryPart.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.BinaryPart} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.BinaryPart}
 */
proto.base.v1.BinaryPart.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setExt(value);
      break;
    case 2:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setData(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAllcount(value);
      break;
    case 4:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setNonce(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.BinaryPart.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.BinaryPart.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.BinaryPart} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.BinaryPart.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExt();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getData_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      2,
      f
    );
  }
  f = message.getAllcount();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getNonce_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      4,
      f
    );
  }
};


/**
 * optional string ext = 1;
 * @return {string}
 */
proto.base.v1.BinaryPart.prototype.getExt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.v1.BinaryPart} returns this
 */
proto.base.v1.BinaryPart.prototype.setExt = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bytes data = 2;
 * @return {string}
 */
proto.base.v1.BinaryPart.prototype.getData = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * optional bytes data = 2;
 * This is a type-conversion wrapper around `getData()`
 * @return {string}
 */
proto.base.v1.BinaryPart.prototype.getData_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getData()));
};


/**
 * optional bytes data = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getData()`
 * @return {!Uint8Array}
 */
proto.base.v1.BinaryPart.prototype.getData_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getData()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.base.v1.BinaryPart} returns this
 */
proto.base.v1.BinaryPart.prototype.setData = function(value) {
  return jspb.Message.setProto3BytesField(this, 2, value);
};


/**
 * optional int32 allCount = 3;
 * @return {number}
 */
proto.base.v1.BinaryPart.prototype.getAllcount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.BinaryPart} returns this
 */
proto.base.v1.BinaryPart.prototype.setAllcount = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional bytes nonce = 4;
 * @return {string}
 */
proto.base.v1.BinaryPart.prototype.getNonce = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * optional bytes nonce = 4;
 * This is a type-conversion wrapper around `getNonce()`
 * @return {string}
 */
proto.base.v1.BinaryPart.prototype.getNonce_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getNonce()));
};


/**
 * optional bytes nonce = 4;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getNonce()`
 * @return {!Uint8Array}
 */
proto.base.v1.BinaryPart.prototype.getNonce_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getNonce()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.base.v1.BinaryPart} returns this
 */
proto.base.v1.BinaryPart.prototype.setNonce = function(value) {
  return jspb.Message.setProto3BytesField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.BinaryPartV2.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.BinaryPartV2.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.BinaryPartV2} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.BinaryPartV2.toObject = function(includeInstance, msg) {
  var f, obj = {
data: msg.getData_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.BinaryPartV2}
 */
proto.base.v1.BinaryPartV2.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.BinaryPartV2;
  return proto.base.v1.BinaryPartV2.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.BinaryPartV2} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.BinaryPartV2}
 */
proto.base.v1.BinaryPartV2.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.BinaryPartV2.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.BinaryPartV2.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.BinaryPartV2} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.BinaryPartV2.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getData_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
};


/**
 * optional bytes data = 1;
 * @return {string}
 */
proto.base.v1.BinaryPartV2.prototype.getData = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes data = 1;
 * This is a type-conversion wrapper around `getData()`
 * @return {string}
 */
proto.base.v1.BinaryPartV2.prototype.getData_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getData()));
};


/**
 * optional bytes data = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getData()`
 * @return {!Uint8Array}
 */
proto.base.v1.BinaryPartV2.prototype.getData_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getData()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.base.v1.BinaryPartV2} returns this
 */
proto.base.v1.BinaryPartV2.prototype.setData = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.Image.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.Image.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.Image} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.Image.toObject = function(includeInstance, msg) {
  var f, obj = {
ext: jspb.Message.getFieldWithDefault(msg, 1, ""),
data: msg.getData_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.Image}
 */
proto.base.v1.Image.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.Image;
  return proto.base.v1.Image.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.Image} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.Image}
 */
proto.base.v1.Image.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setExt(value);
      break;
    case 2:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.Image.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.Image.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.Image} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.Image.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExt();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getData_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      2,
      f
    );
  }
};


/**
 * optional string ext = 1;
 * @return {string}
 */
proto.base.v1.Image.prototype.getExt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.v1.Image} returns this
 */
proto.base.v1.Image.prototype.setExt = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bytes data = 2;
 * @return {string}
 */
proto.base.v1.Image.prototype.getData = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * optional bytes data = 2;
 * This is a type-conversion wrapper around `getData()`
 * @return {string}
 */
proto.base.v1.Image.prototype.getData_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getData()));
};


/**
 * optional bytes data = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getData()`
 * @return {!Uint8Array}
 */
proto.base.v1.Image.prototype.getData_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getData()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.base.v1.Image} returns this
 */
proto.base.v1.Image.prototype.setData = function(value) {
  return jspb.Message.setProto3BytesField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.StatusEditRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.StatusEditRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.StatusEditRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.StatusEditRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
status: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.StatusEditRequest}
 */
proto.base.v1.StatusEditRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.StatusEditRequest;
  return proto.base.v1.StatusEditRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.StatusEditRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.StatusEditRequest}
 */
proto.base.v1.StatusEditRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {!proto.base.v1.StatusType} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.StatusEditRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.StatusEditRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.StatusEditRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.StatusEditRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.base.v1.StatusEditRequest.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.StatusEditRequest} returns this
 */
proto.base.v1.StatusEditRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional StatusType status = 2;
 * @return {!proto.base.v1.StatusType}
 */
proto.base.v1.StatusEditRequest.prototype.getStatus = function() {
  return /** @type {!proto.base.v1.StatusType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.base.v1.StatusType} value
 * @return {!proto.base.v1.StatusEditRequest} returns this
 */
proto.base.v1.StatusEditRequest.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.base.v1.CourseInfo.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.CourseInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.CourseInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.CourseInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.CourseInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
totalcontrolnum: jspb.Message.getFieldWithDefault(msg, 3, 0),
maxrange: jspb.Message.getFieldWithDefault(msg, 4, 0),
controlPointSortedListList: jspb.Message.toObjectList(msg.getControlPointSortedListList(),
    proto.base.v1.ControlPoint.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.CourseInfo}
 */
proto.base.v1.CourseInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.CourseInfo;
  return proto.base.v1.CourseInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.CourseInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.CourseInfo}
 */
proto.base.v1.CourseInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalcontrolnum(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMaxrange(value);
      break;
    case 5:
      var value = new proto.base.v1.ControlPoint;
      reader.readMessage(value,proto.base.v1.ControlPoint.deserializeBinaryFromReader);
      msg.addControlPointSortedList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.CourseInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.CourseInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.CourseInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.CourseInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTotalcontrolnum();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getMaxrange();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getControlPointSortedListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.base.v1.ControlPoint.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.base.v1.CourseInfo.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.CourseInfo} returns this
 */
proto.base.v1.CourseInfo.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.base.v1.CourseInfo.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.v1.CourseInfo} returns this
 */
proto.base.v1.CourseInfo.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 totalControlNum = 3;
 * @return {number}
 */
proto.base.v1.CourseInfo.prototype.getTotalcontrolnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.CourseInfo} returns this
 */
proto.base.v1.CourseInfo.prototype.setTotalcontrolnum = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 maxRange = 4;
 * @return {number}
 */
proto.base.v1.CourseInfo.prototype.getMaxrange = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.CourseInfo} returns this
 */
proto.base.v1.CourseInfo.prototype.setMaxrange = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * repeated ControlPoint control_point_sorted_list = 5;
 * @return {!Array<!proto.base.v1.ControlPoint>}
 */
proto.base.v1.CourseInfo.prototype.getControlPointSortedListList = function() {
  return /** @type{!Array<!proto.base.v1.ControlPoint>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.base.v1.ControlPoint, 5));
};


/**
 * @param {!Array<!proto.base.v1.ControlPoint>} value
 * @return {!proto.base.v1.CourseInfo} returns this
*/
proto.base.v1.CourseInfo.prototype.setControlPointSortedListList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.base.v1.ControlPoint=} opt_value
 * @param {number=} opt_index
 * @return {!proto.base.v1.ControlPoint}
 */
proto.base.v1.CourseInfo.prototype.addControlPointSortedList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.base.v1.ControlPoint, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.base.v1.CourseInfo} returns this
 */
proto.base.v1.CourseInfo.prototype.clearControlPointSortedListList = function() {
  return this.setControlPointSortedListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.QrCodeInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.QrCodeInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.QrCodeInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.QrCodeInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
qrcode: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.QrCodeInfo}
 */
proto.base.v1.QrCodeInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.QrCodeInfo;
  return proto.base.v1.QrCodeInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.QrCodeInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.QrCodeInfo}
 */
proto.base.v1.QrCodeInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setQrcode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.QrCodeInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.QrCodeInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.QrCodeInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.QrCodeInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQrcode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string qrCode = 1;
 * @return {string}
 */
proto.base.v1.QrCodeInfo.prototype.getQrcode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.v1.QrCodeInfo} returns this
 */
proto.base.v1.QrCodeInfo.prototype.setQrcode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.ControlPointInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.ControlPointInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.ControlPointInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ControlPointInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
displayinfo: (f = msg.getDisplayinfo()) && google_protobuf_any_pb.Any.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.ControlPointInfo}
 */
proto.base.v1.ControlPointInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.ControlPointInfo;
  return proto.base.v1.ControlPointInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.ControlPointInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.ControlPointInfo}
 */
proto.base.v1.ControlPointInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_any_pb.Any;
      reader.readMessage(value,google_protobuf_any_pb.Any.deserializeBinaryFromReader);
      msg.setDisplayinfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.ControlPointInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.ControlPointInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.ControlPointInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ControlPointInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDisplayinfo();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_any_pb.Any.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Any displayInfo = 1;
 * @return {?proto.google.protobuf.Any}
 */
proto.base.v1.ControlPointInfo.prototype.getDisplayinfo = function() {
  return /** @type{?proto.google.protobuf.Any} */ (
    jspb.Message.getWrapperField(this, google_protobuf_any_pb.Any, 1));
};


/**
 * @param {?proto.google.protobuf.Any|undefined} value
 * @return {!proto.base.v1.ControlPointInfo} returns this
*/
proto.base.v1.ControlPointInfo.prototype.setDisplayinfo = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.base.v1.ControlPointInfo} returns this
 */
proto.base.v1.ControlPointInfo.prototype.clearDisplayinfo = function() {
  return this.setDisplayinfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.base.v1.ControlPointInfo.prototype.hasDisplayinfo = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.base.v1.ControlPointDisplayInfoSingleChoice.repeatedFields_ = [3,7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.ControlPointDisplayInfoSingleChoice.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.ControlPointDisplayInfoSingleChoice.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.ControlPointDisplayInfoSingleChoice} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ControlPointDisplayInfoSingleChoice.toObject = function(includeInstance, msg) {
  var f, obj = {
question: jspb.Message.getFieldWithDefault(msg, 1, ""),
image: (f = msg.getImage()) && proto.base.v1.NetImage.toObject(includeInstance, f),
answerList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
rightanswerindex: jspb.Message.getFieldWithDefault(msg, 4, 0),
qbid: jspb.Message.getFieldWithDefault(msg, 5, 0),
fullimage: (f = msg.getFullimage()) && proto.base.v1.NetImage.toObject(includeInstance, f),
rightanswersarrList: (f = jspb.Message.getRepeatedField(msg, 7)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.ControlPointDisplayInfoSingleChoice}
 */
proto.base.v1.ControlPointDisplayInfoSingleChoice.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.ControlPointDisplayInfoSingleChoice;
  return proto.base.v1.ControlPointDisplayInfoSingleChoice.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.ControlPointDisplayInfoSingleChoice} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.ControlPointDisplayInfoSingleChoice}
 */
proto.base.v1.ControlPointDisplayInfoSingleChoice.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestion(value);
      break;
    case 2:
      var value = new proto.base.v1.NetImage;
      reader.readMessage(value,proto.base.v1.NetImage.deserializeBinaryFromReader);
      msg.setImage(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addAnswer(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRightanswerindex(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQbid(value);
      break;
    case 6:
      var value = new proto.base.v1.NetImage;
      reader.readMessage(value,proto.base.v1.NetImage.deserializeBinaryFromReader);
      msg.setFullimage(value);
      break;
    case 7:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt32() : [reader.readInt32()]);
      for (var i = 0; i < values.length; i++) {
        msg.addRightanswersarr(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.ControlPointDisplayInfoSingleChoice.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.ControlPointDisplayInfoSingleChoice.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.ControlPointDisplayInfoSingleChoice} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ControlPointDisplayInfoSingleChoice.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuestion();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getImage();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.base.v1.NetImage.serializeBinaryToWriter
    );
  }
  f = message.getAnswerList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = message.getRightanswerindex();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getQbid();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getFullimage();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.base.v1.NetImage.serializeBinaryToWriter
    );
  }
  f = message.getRightanswersarrList();
  if (f.length > 0) {
    writer.writePackedInt32(
      7,
      f
    );
  }
};


/**
 * optional string question = 1;
 * @return {string}
 */
proto.base.v1.ControlPointDisplayInfoSingleChoice.prototype.getQuestion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.v1.ControlPointDisplayInfoSingleChoice} returns this
 */
proto.base.v1.ControlPointDisplayInfoSingleChoice.prototype.setQuestion = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional NetImage image = 2;
 * @return {?proto.base.v1.NetImage}
 */
proto.base.v1.ControlPointDisplayInfoSingleChoice.prototype.getImage = function() {
  return /** @type{?proto.base.v1.NetImage} */ (
    jspb.Message.getWrapperField(this, proto.base.v1.NetImage, 2));
};


/**
 * @param {?proto.base.v1.NetImage|undefined} value
 * @return {!proto.base.v1.ControlPointDisplayInfoSingleChoice} returns this
*/
proto.base.v1.ControlPointDisplayInfoSingleChoice.prototype.setImage = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.base.v1.ControlPointDisplayInfoSingleChoice} returns this
 */
proto.base.v1.ControlPointDisplayInfoSingleChoice.prototype.clearImage = function() {
  return this.setImage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.base.v1.ControlPointDisplayInfoSingleChoice.prototype.hasImage = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated string answer = 3;
 * @return {!Array<string>}
 */
proto.base.v1.ControlPointDisplayInfoSingleChoice.prototype.getAnswerList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.base.v1.ControlPointDisplayInfoSingleChoice} returns this
 */
proto.base.v1.ControlPointDisplayInfoSingleChoice.prototype.setAnswerList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.base.v1.ControlPointDisplayInfoSingleChoice} returns this
 */
proto.base.v1.ControlPointDisplayInfoSingleChoice.prototype.addAnswer = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.base.v1.ControlPointDisplayInfoSingleChoice} returns this
 */
proto.base.v1.ControlPointDisplayInfoSingleChoice.prototype.clearAnswerList = function() {
  return this.setAnswerList([]);
};


/**
 * optional int32 rightAnswerIndex = 4;
 * @return {number}
 */
proto.base.v1.ControlPointDisplayInfoSingleChoice.prototype.getRightanswerindex = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ControlPointDisplayInfoSingleChoice} returns this
 */
proto.base.v1.ControlPointDisplayInfoSingleChoice.prototype.setRightanswerindex = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 qbId = 5;
 * @return {number}
 */
proto.base.v1.ControlPointDisplayInfoSingleChoice.prototype.getQbid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ControlPointDisplayInfoSingleChoice} returns this
 */
proto.base.v1.ControlPointDisplayInfoSingleChoice.prototype.setQbid = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional NetImage fullImage = 6;
 * @return {?proto.base.v1.NetImage}
 */
proto.base.v1.ControlPointDisplayInfoSingleChoice.prototype.getFullimage = function() {
  return /** @type{?proto.base.v1.NetImage} */ (
    jspb.Message.getWrapperField(this, proto.base.v1.NetImage, 6));
};


/**
 * @param {?proto.base.v1.NetImage|undefined} value
 * @return {!proto.base.v1.ControlPointDisplayInfoSingleChoice} returns this
*/
proto.base.v1.ControlPointDisplayInfoSingleChoice.prototype.setFullimage = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.base.v1.ControlPointDisplayInfoSingleChoice} returns this
 */
proto.base.v1.ControlPointDisplayInfoSingleChoice.prototype.clearFullimage = function() {
  return this.setFullimage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.base.v1.ControlPointDisplayInfoSingleChoice.prototype.hasFullimage = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * repeated int32 rightAnswersArr = 7;
 * @return {!Array<number>}
 */
proto.base.v1.ControlPointDisplayInfoSingleChoice.prototype.getRightanswersarrList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 7));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.base.v1.ControlPointDisplayInfoSingleChoice} returns this
 */
proto.base.v1.ControlPointDisplayInfoSingleChoice.prototype.setRightanswersarrList = function(value) {
  return jspb.Message.setField(this, 7, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.base.v1.ControlPointDisplayInfoSingleChoice} returns this
 */
proto.base.v1.ControlPointDisplayInfoSingleChoice.prototype.addRightanswersarr = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 7, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.base.v1.ControlPointDisplayInfoSingleChoice} returns this
 */
proto.base.v1.ControlPointDisplayInfoSingleChoice.prototype.clearRightanswersarrList = function() {
  return this.setRightanswersarrList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.ControlPointDisplayCapture.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.ControlPointDisplayCapture.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.ControlPointDisplayCapture} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ControlPointDisplayCapture.toObject = function(includeInstance, msg) {
  var f, obj = {
prompt: jspb.Message.getFieldWithDefault(msg, 1, ""),
fullimage: (f = msg.getFullimage()) && proto.base.v1.NetImage.toObject(includeInstance, f),
image: (f = msg.getImage()) && proto.base.v1.NetImage.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.ControlPointDisplayCapture}
 */
proto.base.v1.ControlPointDisplayCapture.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.ControlPointDisplayCapture;
  return proto.base.v1.ControlPointDisplayCapture.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.ControlPointDisplayCapture} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.ControlPointDisplayCapture}
 */
proto.base.v1.ControlPointDisplayCapture.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrompt(value);
      break;
    case 2:
      var value = new proto.base.v1.NetImage;
      reader.readMessage(value,proto.base.v1.NetImage.deserializeBinaryFromReader);
      msg.setFullimage(value);
      break;
    case 3:
      var value = new proto.base.v1.NetImage;
      reader.readMessage(value,proto.base.v1.NetImage.deserializeBinaryFromReader);
      msg.setImage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.ControlPointDisplayCapture.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.ControlPointDisplayCapture.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.ControlPointDisplayCapture} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ControlPointDisplayCapture.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPrompt();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFullimage();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.base.v1.NetImage.serializeBinaryToWriter
    );
  }
  f = message.getImage();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.base.v1.NetImage.serializeBinaryToWriter
    );
  }
};


/**
 * optional string prompt = 1;
 * @return {string}
 */
proto.base.v1.ControlPointDisplayCapture.prototype.getPrompt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.v1.ControlPointDisplayCapture} returns this
 */
proto.base.v1.ControlPointDisplayCapture.prototype.setPrompt = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional NetImage fullImage = 2;
 * @return {?proto.base.v1.NetImage}
 */
proto.base.v1.ControlPointDisplayCapture.prototype.getFullimage = function() {
  return /** @type{?proto.base.v1.NetImage} */ (
    jspb.Message.getWrapperField(this, proto.base.v1.NetImage, 2));
};


/**
 * @param {?proto.base.v1.NetImage|undefined} value
 * @return {!proto.base.v1.ControlPointDisplayCapture} returns this
*/
proto.base.v1.ControlPointDisplayCapture.prototype.setFullimage = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.base.v1.ControlPointDisplayCapture} returns this
 */
proto.base.v1.ControlPointDisplayCapture.prototype.clearFullimage = function() {
  return this.setFullimage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.base.v1.ControlPointDisplayCapture.prototype.hasFullimage = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional NetImage image = 3;
 * @return {?proto.base.v1.NetImage}
 */
proto.base.v1.ControlPointDisplayCapture.prototype.getImage = function() {
  return /** @type{?proto.base.v1.NetImage} */ (
    jspb.Message.getWrapperField(this, proto.base.v1.NetImage, 3));
};


/**
 * @param {?proto.base.v1.NetImage|undefined} value
 * @return {!proto.base.v1.ControlPointDisplayCapture} returns this
*/
proto.base.v1.ControlPointDisplayCapture.prototype.setImage = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.base.v1.ControlPointDisplayCapture} returns this
 */
proto.base.v1.ControlPointDisplayCapture.prototype.clearImage = function() {
  return this.setImage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.base.v1.ControlPointDisplayCapture.prototype.hasImage = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.ControlPointDisplayString.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.ControlPointDisplayString.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.ControlPointDisplayString} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ControlPointDisplayString.toObject = function(includeInstance, msg) {
  var f, obj = {
prompt: jspb.Message.getFieldWithDefault(msg, 1, ""),
fullimage: (f = msg.getFullimage()) && proto.base.v1.NetImage.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.ControlPointDisplayString}
 */
proto.base.v1.ControlPointDisplayString.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.ControlPointDisplayString;
  return proto.base.v1.ControlPointDisplayString.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.ControlPointDisplayString} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.ControlPointDisplayString}
 */
proto.base.v1.ControlPointDisplayString.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrompt(value);
      break;
    case 2:
      var value = new proto.base.v1.NetImage;
      reader.readMessage(value,proto.base.v1.NetImage.deserializeBinaryFromReader);
      msg.setFullimage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.ControlPointDisplayString.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.ControlPointDisplayString.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.ControlPointDisplayString} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ControlPointDisplayString.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPrompt();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFullimage();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.base.v1.NetImage.serializeBinaryToWriter
    );
  }
};


/**
 * optional string prompt = 1;
 * @return {string}
 */
proto.base.v1.ControlPointDisplayString.prototype.getPrompt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.v1.ControlPointDisplayString} returns this
 */
proto.base.v1.ControlPointDisplayString.prototype.setPrompt = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional NetImage fullImage = 2;
 * @return {?proto.base.v1.NetImage}
 */
proto.base.v1.ControlPointDisplayString.prototype.getFullimage = function() {
  return /** @type{?proto.base.v1.NetImage} */ (
    jspb.Message.getWrapperField(this, proto.base.v1.NetImage, 2));
};


/**
 * @param {?proto.base.v1.NetImage|undefined} value
 * @return {!proto.base.v1.ControlPointDisplayString} returns this
*/
proto.base.v1.ControlPointDisplayString.prototype.setFullimage = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.base.v1.ControlPointDisplayString} returns this
 */
proto.base.v1.ControlPointDisplayString.prototype.clearFullimage = function() {
  return this.setFullimage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.base.v1.ControlPointDisplayString.prototype.hasFullimage = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.ControlPointTaskString.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.ControlPointTaskString.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.ControlPointTaskString} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ControlPointTaskString.toObject = function(includeInstance, msg) {
  var f, obj = {
prompt: jspb.Message.getFieldWithDefault(msg, 1, ""),
fullimage: (f = msg.getFullimage()) && proto.base.v1.NetImage.toObject(includeInstance, f),
image: (f = msg.getImage()) && proto.base.v1.NetImage.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.ControlPointTaskString}
 */
proto.base.v1.ControlPointTaskString.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.ControlPointTaskString;
  return proto.base.v1.ControlPointTaskString.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.ControlPointTaskString} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.ControlPointTaskString}
 */
proto.base.v1.ControlPointTaskString.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrompt(value);
      break;
    case 2:
      var value = new proto.base.v1.NetImage;
      reader.readMessage(value,proto.base.v1.NetImage.deserializeBinaryFromReader);
      msg.setFullimage(value);
      break;
    case 3:
      var value = new proto.base.v1.NetImage;
      reader.readMessage(value,proto.base.v1.NetImage.deserializeBinaryFromReader);
      msg.setImage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.ControlPointTaskString.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.ControlPointTaskString.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.ControlPointTaskString} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ControlPointTaskString.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPrompt();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFullimage();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.base.v1.NetImage.serializeBinaryToWriter
    );
  }
  f = message.getImage();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.base.v1.NetImage.serializeBinaryToWriter
    );
  }
};


/**
 * optional string prompt = 1;
 * @return {string}
 */
proto.base.v1.ControlPointTaskString.prototype.getPrompt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.v1.ControlPointTaskString} returns this
 */
proto.base.v1.ControlPointTaskString.prototype.setPrompt = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional NetImage fullImage = 2;
 * @return {?proto.base.v1.NetImage}
 */
proto.base.v1.ControlPointTaskString.prototype.getFullimage = function() {
  return /** @type{?proto.base.v1.NetImage} */ (
    jspb.Message.getWrapperField(this, proto.base.v1.NetImage, 2));
};


/**
 * @param {?proto.base.v1.NetImage|undefined} value
 * @return {!proto.base.v1.ControlPointTaskString} returns this
*/
proto.base.v1.ControlPointTaskString.prototype.setFullimage = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.base.v1.ControlPointTaskString} returns this
 */
proto.base.v1.ControlPointTaskString.prototype.clearFullimage = function() {
  return this.setFullimage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.base.v1.ControlPointTaskString.prototype.hasFullimage = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional NetImage image = 3;
 * @return {?proto.base.v1.NetImage}
 */
proto.base.v1.ControlPointTaskString.prototype.getImage = function() {
  return /** @type{?proto.base.v1.NetImage} */ (
    jspb.Message.getWrapperField(this, proto.base.v1.NetImage, 3));
};


/**
 * @param {?proto.base.v1.NetImage|undefined} value
 * @return {!proto.base.v1.ControlPointTaskString} returns this
*/
proto.base.v1.ControlPointTaskString.prototype.setImage = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.base.v1.ControlPointTaskString} returns this
 */
proto.base.v1.ControlPointTaskString.prototype.clearImage = function() {
  return this.setImage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.base.v1.ControlPointTaskString.prototype.hasImage = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.ControlPointDisplayHtml.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.ControlPointDisplayHtml.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.ControlPointDisplayHtml} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ControlPointDisplayHtml.toObject = function(includeInstance, msg) {
  var f, obj = {
url: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.ControlPointDisplayHtml}
 */
proto.base.v1.ControlPointDisplayHtml.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.ControlPointDisplayHtml;
  return proto.base.v1.ControlPointDisplayHtml.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.ControlPointDisplayHtml} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.ControlPointDisplayHtml}
 */
proto.base.v1.ControlPointDisplayHtml.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.ControlPointDisplayHtml.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.ControlPointDisplayHtml.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.ControlPointDisplayHtml} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ControlPointDisplayHtml.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string url = 1;
 * @return {string}
 */
proto.base.v1.ControlPointDisplayHtml.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.v1.ControlPointDisplayHtml} returns this
 */
proto.base.v1.ControlPointDisplayHtml.prototype.setUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.base.v1.ControlPoint.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.ControlPoint.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.ControlPoint.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.ControlPoint} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ControlPoint.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
info: (f = msg.getInfo()) && proto.base.v1.ControlPointInfo.toObject(includeInstance, f),
nfcIdListList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
onMapX: jspb.Message.getFieldWithDefault(msg, 4, 0),
onMapY: jspb.Message.getFieldWithDefault(msg, 5, 0),
sn: jspb.Message.getFieldWithDefault(msg, 6, ""),
ciposition: (f = msg.getCiposition()) && proto.base.v1.Position.toObject(includeInstance, f),
mapposition: (f = msg.getMapposition()) && proto.base.v1.Position.toObject(includeInstance, f),
category: jspb.Message.getFieldWithDefault(msg, 9, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.ControlPoint}
 */
proto.base.v1.ControlPoint.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.ControlPoint;
  return proto.base.v1.ControlPoint.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.ControlPoint} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.ControlPoint}
 */
proto.base.v1.ControlPoint.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = new proto.base.v1.ControlPointInfo;
      reader.readMessage(value,proto.base.v1.ControlPointInfo.deserializeBinaryFromReader);
      msg.setInfo(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addNfcIdList(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOnMapX(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOnMapY(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setSn(value);
      break;
    case 7:
      var value = new proto.base.v1.Position;
      reader.readMessage(value,proto.base.v1.Position.deserializeBinaryFromReader);
      msg.setCiposition(value);
      break;
    case 8:
      var value = new proto.base.v1.Position;
      reader.readMessage(value,proto.base.v1.Position.deserializeBinaryFromReader);
      msg.setMapposition(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCategory(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.ControlPoint.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.ControlPoint.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.ControlPoint} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ControlPoint.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getInfo();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.base.v1.ControlPointInfo.serializeBinaryToWriter
    );
  }
  f = message.getNfcIdListList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = message.getOnMapX();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getOnMapY();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getSn();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getCiposition();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.base.v1.Position.serializeBinaryToWriter
    );
  }
  f = message.getMapposition();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.base.v1.Position.serializeBinaryToWriter
    );
  }
  f = message.getCategory();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.base.v1.ControlPoint.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ControlPoint} returns this
 */
proto.base.v1.ControlPoint.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional ControlPointInfo info = 2;
 * @return {?proto.base.v1.ControlPointInfo}
 */
proto.base.v1.ControlPoint.prototype.getInfo = function() {
  return /** @type{?proto.base.v1.ControlPointInfo} */ (
    jspb.Message.getWrapperField(this, proto.base.v1.ControlPointInfo, 2));
};


/**
 * @param {?proto.base.v1.ControlPointInfo|undefined} value
 * @return {!proto.base.v1.ControlPoint} returns this
*/
proto.base.v1.ControlPoint.prototype.setInfo = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.base.v1.ControlPoint} returns this
 */
proto.base.v1.ControlPoint.prototype.clearInfo = function() {
  return this.setInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.base.v1.ControlPoint.prototype.hasInfo = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated string nfc_id_list = 3;
 * @return {!Array<string>}
 */
proto.base.v1.ControlPoint.prototype.getNfcIdListList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.base.v1.ControlPoint} returns this
 */
proto.base.v1.ControlPoint.prototype.setNfcIdListList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.base.v1.ControlPoint} returns this
 */
proto.base.v1.ControlPoint.prototype.addNfcIdList = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.base.v1.ControlPoint} returns this
 */
proto.base.v1.ControlPoint.prototype.clearNfcIdListList = function() {
  return this.setNfcIdListList([]);
};


/**
 * optional int64 on_map_x = 4;
 * @return {number}
 */
proto.base.v1.ControlPoint.prototype.getOnMapX = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ControlPoint} returns this
 */
proto.base.v1.ControlPoint.prototype.setOnMapX = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 on_map_y = 5;
 * @return {number}
 */
proto.base.v1.ControlPoint.prototype.getOnMapY = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ControlPoint} returns this
 */
proto.base.v1.ControlPoint.prototype.setOnMapY = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string sn = 6;
 * @return {string}
 */
proto.base.v1.ControlPoint.prototype.getSn = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.v1.ControlPoint} returns this
 */
proto.base.v1.ControlPoint.prototype.setSn = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional Position ciPosition = 7;
 * @return {?proto.base.v1.Position}
 */
proto.base.v1.ControlPoint.prototype.getCiposition = function() {
  return /** @type{?proto.base.v1.Position} */ (
    jspb.Message.getWrapperField(this, proto.base.v1.Position, 7));
};


/**
 * @param {?proto.base.v1.Position|undefined} value
 * @return {!proto.base.v1.ControlPoint} returns this
*/
proto.base.v1.ControlPoint.prototype.setCiposition = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.base.v1.ControlPoint} returns this
 */
proto.base.v1.ControlPoint.prototype.clearCiposition = function() {
  return this.setCiposition(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.base.v1.ControlPoint.prototype.hasCiposition = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional Position mapPosition = 8;
 * @return {?proto.base.v1.Position}
 */
proto.base.v1.ControlPoint.prototype.getMapposition = function() {
  return /** @type{?proto.base.v1.Position} */ (
    jspb.Message.getWrapperField(this, proto.base.v1.Position, 8));
};


/**
 * @param {?proto.base.v1.Position|undefined} value
 * @return {!proto.base.v1.ControlPoint} returns this
*/
proto.base.v1.ControlPoint.prototype.setMapposition = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.base.v1.ControlPoint} returns this
 */
proto.base.v1.ControlPoint.prototype.clearMapposition = function() {
  return this.setMapposition(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.base.v1.ControlPoint.prototype.hasMapposition = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional int32 category = 9;
 * @return {number}
 */
proto.base.v1.ControlPoint.prototype.getCategory = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ControlPoint} returns this
 */
proto.base.v1.ControlPoint.prototype.setCategory = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.base.v1.ControlPointSimple.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.ControlPointSimple.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.ControlPointSimple.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.ControlPointSimple} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ControlPointSimple.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
nfcIdListList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
sn: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.ControlPointSimple}
 */
proto.base.v1.ControlPointSimple.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.ControlPointSimple;
  return proto.base.v1.ControlPointSimple.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.ControlPointSimple} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.ControlPointSimple}
 */
proto.base.v1.ControlPointSimple.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addNfcIdList(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSn(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.ControlPointSimple.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.ControlPointSimple.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.ControlPointSimple} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ControlPointSimple.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getNfcIdListList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
  f = message.getSn();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.base.v1.ControlPointSimple.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ControlPointSimple} returns this
 */
proto.base.v1.ControlPointSimple.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * repeated string nfc_id_list = 2;
 * @return {!Array<string>}
 */
proto.base.v1.ControlPointSimple.prototype.getNfcIdListList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.base.v1.ControlPointSimple} returns this
 */
proto.base.v1.ControlPointSimple.prototype.setNfcIdListList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.base.v1.ControlPointSimple} returns this
 */
proto.base.v1.ControlPointSimple.prototype.addNfcIdList = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.base.v1.ControlPointSimple} returns this
 */
proto.base.v1.ControlPointSimple.prototype.clearNfcIdListList = function() {
  return this.setNfcIdListList([]);
};


/**
 * optional string sn = 3;
 * @return {string}
 */
proto.base.v1.ControlPointSimple.prototype.getSn = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.v1.ControlPointSimple} returns this
 */
proto.base.v1.ControlPointSimple.prototype.setSn = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.base.v1.GameDetailV2Reply.repeatedFields_ = [4,21,24];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.GameDetailV2Reply.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.GameDetailV2Reply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.GameDetailV2Reply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.GameDetailV2Reply.toObject = function(includeInstance, msg) {
  var f, obj = {
gameId: jspb.Message.getFieldWithDefault(msg, 1, 0),
iscomplete: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
startAt: (f = msg.getStartAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
checkedSortedListList: jspb.Message.toObjectList(msg.getCheckedSortedListList(),
    proto.base.v1.ControlPointGameInfo.toObject, includeInstance),
duration: (f = msg.getDuration()) && google_protobuf_duration_pb.Duration.toObject(includeInstance, f),
stopAt: (f = msg.getStopAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
qrjsoncode: jspb.Message.getFieldWithDefault(msg, 7, ""),
issuccess: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
syspoint: jspb.Message.getFieldWithDefault(msg, 9, 0),
totalpointnum: jspb.Message.getFieldWithDefault(msg, 10, 0),
actname: jspb.Message.getFieldWithDefault(msg, 13, ""),
distance: jspb.Message.getFieldWithDefault(msg, 14, 0),
pace: jspb.Message.getFieldWithDefault(msg, 15, 0),
avghr: jspb.Message.getFieldWithDefault(msg, 16, 0),
calorie: jspb.Message.getFieldWithDefault(msg, 17, 0),
ck: jspb.Message.getFieldWithDefault(msg, 18, 0),
ei: jspb.Message.getFloatingPointFieldWithDefault(msg, 19, 0.0),
stepnum: jspb.Message.getFieldWithDefault(msg, 20, 0),
gamegpsinfoList: jspb.Message.toObjectList(msg.getGamegpsinfoList(),
    proto.base.v1.GameGpsInfo.toObject, includeInstance),
mapZip: (f = msg.getMapZip()) && proto.base.v1.NetImage.toObject(includeInstance, f),
answerhistory: (f = msg.getAnswerhistory()) && proto.base.v1.AnswerHistoryInfo.toObject(includeInstance, f),
gamehrinfosList: jspb.Message.toObjectList(msg.getGamehrinfosList(),
    proto.base.v1.HeartRate.toObject, includeInstance),
source: jspb.Message.getFieldWithDefault(msg, 25, 0),
actid: jspb.Message.getFieldWithDefault(msg, 26, 0),
body: (f = msg.getBody()) && proto.base.v1.OrienteerBodyInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.GameDetailV2Reply}
 */
proto.base.v1.GameDetailV2Reply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.GameDetailV2Reply;
  return proto.base.v1.GameDetailV2Reply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.GameDetailV2Reply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.GameDetailV2Reply}
 */
proto.base.v1.GameDetailV2Reply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setGameId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIscomplete(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setStartAt(value);
      break;
    case 4:
      var value = new proto.base.v1.ControlPointGameInfo;
      reader.readMessage(value,proto.base.v1.ControlPointGameInfo.deserializeBinaryFromReader);
      msg.addCheckedSortedList(value);
      break;
    case 5:
      var value = new google_protobuf_duration_pb.Duration;
      reader.readMessage(value,google_protobuf_duration_pb.Duration.deserializeBinaryFromReader);
      msg.setDuration(value);
      break;
    case 6:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setStopAt(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setQrjsoncode(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIssuccess(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSyspoint(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalpointnum(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setActname(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDistance(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPace(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAvghr(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCalorie(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCk(value);
      break;
    case 19:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setEi(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setStepnum(value);
      break;
    case 21:
      var value = new proto.base.v1.GameGpsInfo;
      reader.readMessage(value,proto.base.v1.GameGpsInfo.deserializeBinaryFromReader);
      msg.addGamegpsinfo(value);
      break;
    case 22:
      var value = new proto.base.v1.NetImage;
      reader.readMessage(value,proto.base.v1.NetImage.deserializeBinaryFromReader);
      msg.setMapZip(value);
      break;
    case 23:
      var value = new proto.base.v1.AnswerHistoryInfo;
      reader.readMessage(value,proto.base.v1.AnswerHistoryInfo.deserializeBinaryFromReader);
      msg.setAnswerhistory(value);
      break;
    case 24:
      var value = new proto.base.v1.HeartRate;
      reader.readMessage(value,proto.base.v1.HeartRate.deserializeBinaryFromReader);
      msg.addGamehrinfos(value);
      break;
    case 25:
      var value = /** @type {!proto.base.v1.GameHistorySource} */ (reader.readEnum());
      msg.setSource(value);
      break;
    case 26:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setActid(value);
      break;
    case 27:
      var value = new proto.base.v1.OrienteerBodyInfo;
      reader.readMessage(value,proto.base.v1.OrienteerBodyInfo.deserializeBinaryFromReader);
      msg.setBody(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.GameDetailV2Reply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.GameDetailV2Reply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.GameDetailV2Reply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.GameDetailV2Reply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGameId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getIscomplete();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getStartAt();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getCheckedSortedListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.base.v1.ControlPointGameInfo.serializeBinaryToWriter
    );
  }
  f = message.getDuration();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_duration_pb.Duration.serializeBinaryToWriter
    );
  }
  f = message.getStopAt();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getQrjsoncode();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getIssuccess();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getSyspoint();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getTotalpointnum();
  if (f !== 0) {
    writer.writeInt32(
      10,
      f
    );
  }
  f = message.getActname();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getDistance();
  if (f !== 0) {
    writer.writeInt32(
      14,
      f
    );
  }
  f = message.getPace();
  if (f !== 0) {
    writer.writeInt32(
      15,
      f
    );
  }
  f = message.getAvghr();
  if (f !== 0) {
    writer.writeInt32(
      16,
      f
    );
  }
  f = message.getCalorie();
  if (f !== 0) {
    writer.writeInt32(
      17,
      f
    );
  }
  f = message.getCk();
  if (f !== 0) {
    writer.writeInt32(
      18,
      f
    );
  }
  f = message.getEi();
  if (f !== 0.0) {
    writer.writeFloat(
      19,
      f
    );
  }
  f = message.getStepnum();
  if (f !== 0) {
    writer.writeInt32(
      20,
      f
    );
  }
  f = message.getGamegpsinfoList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      21,
      f,
      proto.base.v1.GameGpsInfo.serializeBinaryToWriter
    );
  }
  f = message.getMapZip();
  if (f != null) {
    writer.writeMessage(
      22,
      f,
      proto.base.v1.NetImage.serializeBinaryToWriter
    );
  }
  f = message.getAnswerhistory();
  if (f != null) {
    writer.writeMessage(
      23,
      f,
      proto.base.v1.AnswerHistoryInfo.serializeBinaryToWriter
    );
  }
  f = message.getGamehrinfosList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      24,
      f,
      proto.base.v1.HeartRate.serializeBinaryToWriter
    );
  }
  f = message.getSource();
  if (f !== 0.0) {
    writer.writeEnum(
      25,
      f
    );
  }
  f = message.getActid();
  if (f !== 0) {
    writer.writeInt32(
      26,
      f
    );
  }
  f = message.getBody();
  if (f != null) {
    writer.writeMessage(
      27,
      f,
      proto.base.v1.OrienteerBodyInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 game_id = 1;
 * @return {number}
 */
proto.base.v1.GameDetailV2Reply.prototype.getGameId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.GameDetailV2Reply} returns this
 */
proto.base.v1.GameDetailV2Reply.prototype.setGameId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool isComplete = 2;
 * @return {boolean}
 */
proto.base.v1.GameDetailV2Reply.prototype.getIscomplete = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.base.v1.GameDetailV2Reply} returns this
 */
proto.base.v1.GameDetailV2Reply.prototype.setIscomplete = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional google.protobuf.Timestamp start_at = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.base.v1.GameDetailV2Reply.prototype.getStartAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.base.v1.GameDetailV2Reply} returns this
*/
proto.base.v1.GameDetailV2Reply.prototype.setStartAt = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.base.v1.GameDetailV2Reply} returns this
 */
proto.base.v1.GameDetailV2Reply.prototype.clearStartAt = function() {
  return this.setStartAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.base.v1.GameDetailV2Reply.prototype.hasStartAt = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * repeated ControlPointGameInfo checked_sorted_list = 4;
 * @return {!Array<!proto.base.v1.ControlPointGameInfo>}
 */
proto.base.v1.GameDetailV2Reply.prototype.getCheckedSortedListList = function() {
  return /** @type{!Array<!proto.base.v1.ControlPointGameInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.base.v1.ControlPointGameInfo, 4));
};


/**
 * @param {!Array<!proto.base.v1.ControlPointGameInfo>} value
 * @return {!proto.base.v1.GameDetailV2Reply} returns this
*/
proto.base.v1.GameDetailV2Reply.prototype.setCheckedSortedListList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.base.v1.ControlPointGameInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.base.v1.ControlPointGameInfo}
 */
proto.base.v1.GameDetailV2Reply.prototype.addCheckedSortedList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.base.v1.ControlPointGameInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.base.v1.GameDetailV2Reply} returns this
 */
proto.base.v1.GameDetailV2Reply.prototype.clearCheckedSortedListList = function() {
  return this.setCheckedSortedListList([]);
};


/**
 * optional google.protobuf.Duration duration = 5;
 * @return {?proto.google.protobuf.Duration}
 */
proto.base.v1.GameDetailV2Reply.prototype.getDuration = function() {
  return /** @type{?proto.google.protobuf.Duration} */ (
    jspb.Message.getWrapperField(this, google_protobuf_duration_pb.Duration, 5));
};


/**
 * @param {?proto.google.protobuf.Duration|undefined} value
 * @return {!proto.base.v1.GameDetailV2Reply} returns this
*/
proto.base.v1.GameDetailV2Reply.prototype.setDuration = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.base.v1.GameDetailV2Reply} returns this
 */
proto.base.v1.GameDetailV2Reply.prototype.clearDuration = function() {
  return this.setDuration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.base.v1.GameDetailV2Reply.prototype.hasDuration = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.Timestamp stop_at = 6;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.base.v1.GameDetailV2Reply.prototype.getStopAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 6));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.base.v1.GameDetailV2Reply} returns this
*/
proto.base.v1.GameDetailV2Reply.prototype.setStopAt = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.base.v1.GameDetailV2Reply} returns this
 */
proto.base.v1.GameDetailV2Reply.prototype.clearStopAt = function() {
  return this.setStopAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.base.v1.GameDetailV2Reply.prototype.hasStopAt = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional string qrJsonCode = 7;
 * @return {string}
 */
proto.base.v1.GameDetailV2Reply.prototype.getQrjsoncode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.v1.GameDetailV2Reply} returns this
 */
proto.base.v1.GameDetailV2Reply.prototype.setQrjsoncode = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional bool isSuccess = 8;
 * @return {boolean}
 */
proto.base.v1.GameDetailV2Reply.prototype.getIssuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.base.v1.GameDetailV2Reply} returns this
 */
proto.base.v1.GameDetailV2Reply.prototype.setIssuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * optional int32 sysPoint = 9;
 * @return {number}
 */
proto.base.v1.GameDetailV2Reply.prototype.getSyspoint = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.GameDetailV2Reply} returns this
 */
proto.base.v1.GameDetailV2Reply.prototype.setSyspoint = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int32 totalPointNum = 10;
 * @return {number}
 */
proto.base.v1.GameDetailV2Reply.prototype.getTotalpointnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.GameDetailV2Reply} returns this
 */
proto.base.v1.GameDetailV2Reply.prototype.setTotalpointnum = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional string actName = 13;
 * @return {string}
 */
proto.base.v1.GameDetailV2Reply.prototype.getActname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.v1.GameDetailV2Reply} returns this
 */
proto.base.v1.GameDetailV2Reply.prototype.setActname = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional int32 distance = 14;
 * @return {number}
 */
proto.base.v1.GameDetailV2Reply.prototype.getDistance = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.GameDetailV2Reply} returns this
 */
proto.base.v1.GameDetailV2Reply.prototype.setDistance = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional int32 pace = 15;
 * @return {number}
 */
proto.base.v1.GameDetailV2Reply.prototype.getPace = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.GameDetailV2Reply} returns this
 */
proto.base.v1.GameDetailV2Reply.prototype.setPace = function(value) {
  return jspb.Message.setProto3IntField(this, 15, value);
};


/**
 * optional int32 avgHr = 16;
 * @return {number}
 */
proto.base.v1.GameDetailV2Reply.prototype.getAvghr = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.GameDetailV2Reply} returns this
 */
proto.base.v1.GameDetailV2Reply.prototype.setAvghr = function(value) {
  return jspb.Message.setProto3IntField(this, 16, value);
};


/**
 * optional int32 Calorie = 17;
 * @return {number}
 */
proto.base.v1.GameDetailV2Reply.prototype.getCalorie = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.GameDetailV2Reply} returns this
 */
proto.base.v1.GameDetailV2Reply.prototype.setCalorie = function(value) {
  return jspb.Message.setProto3IntField(this, 17, value);
};


/**
 * optional int32 Ck = 18;
 * @return {number}
 */
proto.base.v1.GameDetailV2Reply.prototype.getCk = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.GameDetailV2Reply} returns this
 */
proto.base.v1.GameDetailV2Reply.prototype.setCk = function(value) {
  return jspb.Message.setProto3IntField(this, 18, value);
};


/**
 * optional float Ei = 19;
 * @return {number}
 */
proto.base.v1.GameDetailV2Reply.prototype.getEi = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 19, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.GameDetailV2Reply} returns this
 */
proto.base.v1.GameDetailV2Reply.prototype.setEi = function(value) {
  return jspb.Message.setProto3FloatField(this, 19, value);
};


/**
 * optional int32 stepNum = 20;
 * @return {number}
 */
proto.base.v1.GameDetailV2Reply.prototype.getStepnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 20, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.GameDetailV2Reply} returns this
 */
proto.base.v1.GameDetailV2Reply.prototype.setStepnum = function(value) {
  return jspb.Message.setProto3IntField(this, 20, value);
};


/**
 * repeated GameGpsInfo gameGpsInfo = 21;
 * @return {!Array<!proto.base.v1.GameGpsInfo>}
 */
proto.base.v1.GameDetailV2Reply.prototype.getGamegpsinfoList = function() {
  return /** @type{!Array<!proto.base.v1.GameGpsInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.base.v1.GameGpsInfo, 21));
};


/**
 * @param {!Array<!proto.base.v1.GameGpsInfo>} value
 * @return {!proto.base.v1.GameDetailV2Reply} returns this
*/
proto.base.v1.GameDetailV2Reply.prototype.setGamegpsinfoList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 21, value);
};


/**
 * @param {!proto.base.v1.GameGpsInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.base.v1.GameGpsInfo}
 */
proto.base.v1.GameDetailV2Reply.prototype.addGamegpsinfo = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 21, opt_value, proto.base.v1.GameGpsInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.base.v1.GameDetailV2Reply} returns this
 */
proto.base.v1.GameDetailV2Reply.prototype.clearGamegpsinfoList = function() {
  return this.setGamegpsinfoList([]);
};


/**
 * optional NetImage map_zip = 22;
 * @return {?proto.base.v1.NetImage}
 */
proto.base.v1.GameDetailV2Reply.prototype.getMapZip = function() {
  return /** @type{?proto.base.v1.NetImage} */ (
    jspb.Message.getWrapperField(this, proto.base.v1.NetImage, 22));
};


/**
 * @param {?proto.base.v1.NetImage|undefined} value
 * @return {!proto.base.v1.GameDetailV2Reply} returns this
*/
proto.base.v1.GameDetailV2Reply.prototype.setMapZip = function(value) {
  return jspb.Message.setWrapperField(this, 22, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.base.v1.GameDetailV2Reply} returns this
 */
proto.base.v1.GameDetailV2Reply.prototype.clearMapZip = function() {
  return this.setMapZip(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.base.v1.GameDetailV2Reply.prototype.hasMapZip = function() {
  return jspb.Message.getField(this, 22) != null;
};


/**
 * optional AnswerHistoryInfo answerHistory = 23;
 * @return {?proto.base.v1.AnswerHistoryInfo}
 */
proto.base.v1.GameDetailV2Reply.prototype.getAnswerhistory = function() {
  return /** @type{?proto.base.v1.AnswerHistoryInfo} */ (
    jspb.Message.getWrapperField(this, proto.base.v1.AnswerHistoryInfo, 23));
};


/**
 * @param {?proto.base.v1.AnswerHistoryInfo|undefined} value
 * @return {!proto.base.v1.GameDetailV2Reply} returns this
*/
proto.base.v1.GameDetailV2Reply.prototype.setAnswerhistory = function(value) {
  return jspb.Message.setWrapperField(this, 23, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.base.v1.GameDetailV2Reply} returns this
 */
proto.base.v1.GameDetailV2Reply.prototype.clearAnswerhistory = function() {
  return this.setAnswerhistory(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.base.v1.GameDetailV2Reply.prototype.hasAnswerhistory = function() {
  return jspb.Message.getField(this, 23) != null;
};


/**
 * repeated HeartRate gameHrInfos = 24;
 * @return {!Array<!proto.base.v1.HeartRate>}
 */
proto.base.v1.GameDetailV2Reply.prototype.getGamehrinfosList = function() {
  return /** @type{!Array<!proto.base.v1.HeartRate>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.base.v1.HeartRate, 24));
};


/**
 * @param {!Array<!proto.base.v1.HeartRate>} value
 * @return {!proto.base.v1.GameDetailV2Reply} returns this
*/
proto.base.v1.GameDetailV2Reply.prototype.setGamehrinfosList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 24, value);
};


/**
 * @param {!proto.base.v1.HeartRate=} opt_value
 * @param {number=} opt_index
 * @return {!proto.base.v1.HeartRate}
 */
proto.base.v1.GameDetailV2Reply.prototype.addGamehrinfos = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 24, opt_value, proto.base.v1.HeartRate, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.base.v1.GameDetailV2Reply} returns this
 */
proto.base.v1.GameDetailV2Reply.prototype.clearGamehrinfosList = function() {
  return this.setGamehrinfosList([]);
};


/**
 * optional GameHistorySource source = 25;
 * @return {!proto.base.v1.GameHistorySource}
 */
proto.base.v1.GameDetailV2Reply.prototype.getSource = function() {
  return /** @type {!proto.base.v1.GameHistorySource} */ (jspb.Message.getFieldWithDefault(this, 25, 0));
};


/**
 * @param {!proto.base.v1.GameHistorySource} value
 * @return {!proto.base.v1.GameDetailV2Reply} returns this
 */
proto.base.v1.GameDetailV2Reply.prototype.setSource = function(value) {
  return jspb.Message.setProto3EnumField(this, 25, value);
};


/**
 * optional int32 actId = 26;
 * @return {number}
 */
proto.base.v1.GameDetailV2Reply.prototype.getActid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 26, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.GameDetailV2Reply} returns this
 */
proto.base.v1.GameDetailV2Reply.prototype.setActid = function(value) {
  return jspb.Message.setProto3IntField(this, 26, value);
};


/**
 * optional OrienteerBodyInfo body = 27;
 * @return {?proto.base.v1.OrienteerBodyInfo}
 */
proto.base.v1.GameDetailV2Reply.prototype.getBody = function() {
  return /** @type{?proto.base.v1.OrienteerBodyInfo} */ (
    jspb.Message.getWrapperField(this, proto.base.v1.OrienteerBodyInfo, 27));
};


/**
 * @param {?proto.base.v1.OrienteerBodyInfo|undefined} value
 * @return {!proto.base.v1.GameDetailV2Reply} returns this
*/
proto.base.v1.GameDetailV2Reply.prototype.setBody = function(value) {
  return jspb.Message.setWrapperField(this, 27, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.base.v1.GameDetailV2Reply} returns this
 */
proto.base.v1.GameDetailV2Reply.prototype.clearBody = function() {
  return this.setBody(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.base.v1.GameDetailV2Reply.prototype.hasBody = function() {
  return jspb.Message.getField(this, 27) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.OrienteerBodyInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.OrienteerBodyInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.OrienteerBodyInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.OrienteerBodyInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
oid: jspb.Message.getFieldWithDefault(msg, 1, 0),
sex: jspb.Message.getFieldWithDefault(msg, 2, 0),
birthdayyear: jspb.Message.getFieldWithDefault(msg, 3, 0),
heightmillimeter: jspb.Message.getFieldWithDefault(msg, 4, 0),
weightgram: jspb.Message.getFieldWithDefault(msg, 5, 0),
statichr: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.OrienteerBodyInfo}
 */
proto.base.v1.OrienteerBodyInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.OrienteerBodyInfo;
  return proto.base.v1.OrienteerBodyInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.OrienteerBodyInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.OrienteerBodyInfo}
 */
proto.base.v1.OrienteerBodyInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOid(value);
      break;
    case 2:
      var value = /** @type {!proto.base.v1.User.Sex} */ (reader.readEnum());
      msg.setSex(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setBirthdayyear(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setHeightmillimeter(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setWeightgram(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setStatichr(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.OrienteerBodyInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.OrienteerBodyInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.OrienteerBodyInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.OrienteerBodyInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getSex();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getBirthdayyear();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getHeightmillimeter();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getWeightgram();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getStatichr();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
};


/**
 * optional int32 oId = 1;
 * @return {number}
 */
proto.base.v1.OrienteerBodyInfo.prototype.getOid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.OrienteerBodyInfo} returns this
 */
proto.base.v1.OrienteerBodyInfo.prototype.setOid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional User.Sex sex = 2;
 * @return {!proto.base.v1.User.Sex}
 */
proto.base.v1.OrienteerBodyInfo.prototype.getSex = function() {
  return /** @type {!proto.base.v1.User.Sex} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.base.v1.User.Sex} value
 * @return {!proto.base.v1.OrienteerBodyInfo} returns this
 */
proto.base.v1.OrienteerBodyInfo.prototype.setSex = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional int32 birthdayYear = 3;
 * @return {number}
 */
proto.base.v1.OrienteerBodyInfo.prototype.getBirthdayyear = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.OrienteerBodyInfo} returns this
 */
proto.base.v1.OrienteerBodyInfo.prototype.setBirthdayyear = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 heightMillimeter = 4;
 * @return {number}
 */
proto.base.v1.OrienteerBodyInfo.prototype.getHeightmillimeter = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.OrienteerBodyInfo} returns this
 */
proto.base.v1.OrienteerBodyInfo.prototype.setHeightmillimeter = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 weightGram = 5;
 * @return {number}
 */
proto.base.v1.OrienteerBodyInfo.prototype.getWeightgram = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.OrienteerBodyInfo} returns this
 */
proto.base.v1.OrienteerBodyInfo.prototype.setWeightgram = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 staticHr = 6;
 * @return {number}
 */
proto.base.v1.OrienteerBodyInfo.prototype.getStatichr = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.OrienteerBodyInfo} returns this
 */
proto.base.v1.OrienteerBodyInfo.prototype.setStatichr = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.ControlPointGameInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.ControlPointGameInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.ControlPointGameInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ControlPointGameInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
sn: jspb.Message.getFieldWithDefault(msg, 2, ""),
ctype: jspb.Message.getFieldWithDefault(msg, 3, 0),
orderno: jspb.Message.getFieldWithDefault(msg, 4, 0),
isCheckSuccess: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
checkAfterLast: (f = msg.getCheckAfterLast()) && google_protobuf_duration_pb.Duration.toObject(includeInstance, f),
punchtime: (f = msg.getPunchtime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
position: (f = msg.getPosition()) && proto.base.v1.Position.toObject(includeInstance, f),
disafterlast: jspb.Message.getFieldWithDefault(msg, 9, 0),
disstraightafterlast: jspb.Message.getFieldWithDefault(msg, 10, 0),
paceafterlast: jspb.Message.getFieldWithDefault(msg, 11, 0),
paceafterstart: jspb.Message.getFieldWithDefault(msg, 12, 0),
checkAfterStart: (f = msg.getCheckAfterStart()) && google_protobuf_duration_pb.Duration.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.ControlPointGameInfo}
 */
proto.base.v1.ControlPointGameInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.ControlPointGameInfo;
  return proto.base.v1.ControlPointGameInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.ControlPointGameInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.ControlPointGameInfo}
 */
proto.base.v1.ControlPointGameInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSn(value);
      break;
    case 3:
      var value = /** @type {!proto.base.v1.CType} */ (reader.readEnum());
      msg.setCtype(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOrderno(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsCheckSuccess(value);
      break;
    case 6:
      var value = new google_protobuf_duration_pb.Duration;
      reader.readMessage(value,google_protobuf_duration_pb.Duration.deserializeBinaryFromReader);
      msg.setCheckAfterLast(value);
      break;
    case 7:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setPunchtime(value);
      break;
    case 8:
      var value = new proto.base.v1.Position;
      reader.readMessage(value,proto.base.v1.Position.deserializeBinaryFromReader);
      msg.setPosition(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDisafterlast(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDisstraightafterlast(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPaceafterlast(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPaceafterstart(value);
      break;
    case 13:
      var value = new google_protobuf_duration_pb.Duration;
      reader.readMessage(value,google_protobuf_duration_pb.Duration.deserializeBinaryFromReader);
      msg.setCheckAfterStart(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.ControlPointGameInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.ControlPointGameInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.ControlPointGameInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ControlPointGameInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getSn();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCtype();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getOrderno();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getIsCheckSuccess();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getCheckAfterLast();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_duration_pb.Duration.serializeBinaryToWriter
    );
  }
  f = message.getPunchtime();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getPosition();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.base.v1.Position.serializeBinaryToWriter
    );
  }
  f = message.getDisafterlast();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getDisstraightafterlast();
  if (f !== 0) {
    writer.writeInt32(
      10,
      f
    );
  }
  f = message.getPaceafterlast();
  if (f !== 0) {
    writer.writeInt32(
      11,
      f
    );
  }
  f = message.getPaceafterstart();
  if (f !== 0) {
    writer.writeInt32(
      12,
      f
    );
  }
  f = message.getCheckAfterStart();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      google_protobuf_duration_pb.Duration.serializeBinaryToWriter
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.base.v1.ControlPointGameInfo.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ControlPointGameInfo} returns this
 */
proto.base.v1.ControlPointGameInfo.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string sn = 2;
 * @return {string}
 */
proto.base.v1.ControlPointGameInfo.prototype.getSn = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.v1.ControlPointGameInfo} returns this
 */
proto.base.v1.ControlPointGameInfo.prototype.setSn = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional CType cType = 3;
 * @return {!proto.base.v1.CType}
 */
proto.base.v1.ControlPointGameInfo.prototype.getCtype = function() {
  return /** @type {!proto.base.v1.CType} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.base.v1.CType} value
 * @return {!proto.base.v1.ControlPointGameInfo} returns this
 */
proto.base.v1.ControlPointGameInfo.prototype.setCtype = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional int32 orderNo = 4;
 * @return {number}
 */
proto.base.v1.ControlPointGameInfo.prototype.getOrderno = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ControlPointGameInfo} returns this
 */
proto.base.v1.ControlPointGameInfo.prototype.setOrderno = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional bool is_check_success = 5;
 * @return {boolean}
 */
proto.base.v1.ControlPointGameInfo.prototype.getIsCheckSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.base.v1.ControlPointGameInfo} returns this
 */
proto.base.v1.ControlPointGameInfo.prototype.setIsCheckSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional google.protobuf.Duration check_after_last = 6;
 * @return {?proto.google.protobuf.Duration}
 */
proto.base.v1.ControlPointGameInfo.prototype.getCheckAfterLast = function() {
  return /** @type{?proto.google.protobuf.Duration} */ (
    jspb.Message.getWrapperField(this, google_protobuf_duration_pb.Duration, 6));
};


/**
 * @param {?proto.google.protobuf.Duration|undefined} value
 * @return {!proto.base.v1.ControlPointGameInfo} returns this
*/
proto.base.v1.ControlPointGameInfo.prototype.setCheckAfterLast = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.base.v1.ControlPointGameInfo} returns this
 */
proto.base.v1.ControlPointGameInfo.prototype.clearCheckAfterLast = function() {
  return this.setCheckAfterLast(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.base.v1.ControlPointGameInfo.prototype.hasCheckAfterLast = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional google.protobuf.Timestamp punchTime = 7;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.base.v1.ControlPointGameInfo.prototype.getPunchtime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 7));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.base.v1.ControlPointGameInfo} returns this
*/
proto.base.v1.ControlPointGameInfo.prototype.setPunchtime = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.base.v1.ControlPointGameInfo} returns this
 */
proto.base.v1.ControlPointGameInfo.prototype.clearPunchtime = function() {
  return this.setPunchtime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.base.v1.ControlPointGameInfo.prototype.hasPunchtime = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional Position position = 8;
 * @return {?proto.base.v1.Position}
 */
proto.base.v1.ControlPointGameInfo.prototype.getPosition = function() {
  return /** @type{?proto.base.v1.Position} */ (
    jspb.Message.getWrapperField(this, proto.base.v1.Position, 8));
};


/**
 * @param {?proto.base.v1.Position|undefined} value
 * @return {!proto.base.v1.ControlPointGameInfo} returns this
*/
proto.base.v1.ControlPointGameInfo.prototype.setPosition = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.base.v1.ControlPointGameInfo} returns this
 */
proto.base.v1.ControlPointGameInfo.prototype.clearPosition = function() {
  return this.setPosition(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.base.v1.ControlPointGameInfo.prototype.hasPosition = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional int32 disAfterLast = 9;
 * @return {number}
 */
proto.base.v1.ControlPointGameInfo.prototype.getDisafterlast = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ControlPointGameInfo} returns this
 */
proto.base.v1.ControlPointGameInfo.prototype.setDisafterlast = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int32 disStraightAfterLast = 10;
 * @return {number}
 */
proto.base.v1.ControlPointGameInfo.prototype.getDisstraightafterlast = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ControlPointGameInfo} returns this
 */
proto.base.v1.ControlPointGameInfo.prototype.setDisstraightafterlast = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional int32 paceAfterLast = 11;
 * @return {number}
 */
proto.base.v1.ControlPointGameInfo.prototype.getPaceafterlast = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ControlPointGameInfo} returns this
 */
proto.base.v1.ControlPointGameInfo.prototype.setPaceafterlast = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional int32 paceAfterStart = 12;
 * @return {number}
 */
proto.base.v1.ControlPointGameInfo.prototype.getPaceafterstart = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ControlPointGameInfo} returns this
 */
proto.base.v1.ControlPointGameInfo.prototype.setPaceafterstart = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional google.protobuf.Duration check_after_start = 13;
 * @return {?proto.google.protobuf.Duration}
 */
proto.base.v1.ControlPointGameInfo.prototype.getCheckAfterStart = function() {
  return /** @type{?proto.google.protobuf.Duration} */ (
    jspb.Message.getWrapperField(this, google_protobuf_duration_pb.Duration, 13));
};


/**
 * @param {?proto.google.protobuf.Duration|undefined} value
 * @return {!proto.base.v1.ControlPointGameInfo} returns this
*/
proto.base.v1.ControlPointGameInfo.prototype.setCheckAfterStart = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.base.v1.ControlPointGameInfo} returns this
 */
proto.base.v1.ControlPointGameInfo.prototype.clearCheckAfterStart = function() {
  return this.setCheckAfterStart(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.base.v1.ControlPointGameInfo.prototype.hasCheckAfterStart = function() {
  return jspb.Message.getField(this, 13) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.base.v1.AnswerHistoryInfo.repeatedFields_ = [6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.AnswerHistoryInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.AnswerHistoryInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.AnswerHistoryInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.AnswerHistoryInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
accuracy: jspb.Message.getFieldWithDefault(msg, 1, 0),
totalanswernum: jspb.Message.getFieldWithDefault(msg, 2, 0),
correctanswernum: jspb.Message.getFieldWithDefault(msg, 3, 0),
ranking: jspb.Message.getFieldWithDefault(msg, 4, 0),
rankingday: jspb.Message.getFieldWithDefault(msg, 5, 0),
listList: jspb.Message.toObjectList(msg.getListList(),
    proto.base.v1.AnswerDetailInfo.toObject, includeInstance),
rankingsurpass: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.AnswerHistoryInfo}
 */
proto.base.v1.AnswerHistoryInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.AnswerHistoryInfo;
  return proto.base.v1.AnswerHistoryInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.AnswerHistoryInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.AnswerHistoryInfo}
 */
proto.base.v1.AnswerHistoryInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAccuracy(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalanswernum(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCorrectanswernum(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRanking(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRankingday(value);
      break;
    case 6:
      var value = new proto.base.v1.AnswerDetailInfo;
      reader.readMessage(value,proto.base.v1.AnswerDetailInfo.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRankingsurpass(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.AnswerHistoryInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.AnswerHistoryInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.AnswerHistoryInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.AnswerHistoryInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccuracy();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getTotalanswernum();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getCorrectanswernum();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getRanking();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getRankingday();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.base.v1.AnswerDetailInfo.serializeBinaryToWriter
    );
  }
  f = message.getRankingsurpass();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
};


/**
 * optional int32 accuracy = 1;
 * @return {number}
 */
proto.base.v1.AnswerHistoryInfo.prototype.getAccuracy = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.AnswerHistoryInfo} returns this
 */
proto.base.v1.AnswerHistoryInfo.prototype.setAccuracy = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 totalAnswerNum = 2;
 * @return {number}
 */
proto.base.v1.AnswerHistoryInfo.prototype.getTotalanswernum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.AnswerHistoryInfo} returns this
 */
proto.base.v1.AnswerHistoryInfo.prototype.setTotalanswernum = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 correctAnswerNum = 3;
 * @return {number}
 */
proto.base.v1.AnswerHistoryInfo.prototype.getCorrectanswernum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.AnswerHistoryInfo} returns this
 */
proto.base.v1.AnswerHistoryInfo.prototype.setCorrectanswernum = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 ranking = 4;
 * @return {number}
 */
proto.base.v1.AnswerHistoryInfo.prototype.getRanking = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.AnswerHistoryInfo} returns this
 */
proto.base.v1.AnswerHistoryInfo.prototype.setRanking = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 rankingDay = 5;
 * @return {number}
 */
proto.base.v1.AnswerHistoryInfo.prototype.getRankingday = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.AnswerHistoryInfo} returns this
 */
proto.base.v1.AnswerHistoryInfo.prototype.setRankingday = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * repeated AnswerDetailInfo list = 6;
 * @return {!Array<!proto.base.v1.AnswerDetailInfo>}
 */
proto.base.v1.AnswerHistoryInfo.prototype.getListList = function() {
  return /** @type{!Array<!proto.base.v1.AnswerDetailInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.base.v1.AnswerDetailInfo, 6));
};


/**
 * @param {!Array<!proto.base.v1.AnswerDetailInfo>} value
 * @return {!proto.base.v1.AnswerHistoryInfo} returns this
*/
proto.base.v1.AnswerHistoryInfo.prototype.setListList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.base.v1.AnswerDetailInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.base.v1.AnswerDetailInfo}
 */
proto.base.v1.AnswerHistoryInfo.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.base.v1.AnswerDetailInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.base.v1.AnswerHistoryInfo} returns this
 */
proto.base.v1.AnswerHistoryInfo.prototype.clearListList = function() {
  return this.setListList([]);
};


/**
 * optional int32 rankingSurpass = 7;
 * @return {number}
 */
proto.base.v1.AnswerHistoryInfo.prototype.getRankingsurpass = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.AnswerHistoryInfo} returns this
 */
proto.base.v1.AnswerHistoryInfo.prototype.setRankingsurpass = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.base.v1.AnswerDetailInfo.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.AnswerDetailInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.AnswerDetailInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.AnswerDetailInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.AnswerDetailInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
qbid: jspb.Message.getFieldWithDefault(msg, 1, 0),
question: jspb.Message.getFieldWithDefault(msg, 2, ""),
image: (f = msg.getImage()) && proto.base.v1.NetImage.toObject(includeInstance, f),
answerList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f,
rightanswerindex: jspb.Message.getFieldWithDefault(msg, 5, 0),
useranswerindex: jspb.Message.getFieldWithDefault(msg, 6, 0),
answercorrect: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
isanswer: jspb.Message.getBooleanFieldWithDefault(msg, 8, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.AnswerDetailInfo}
 */
proto.base.v1.AnswerDetailInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.AnswerDetailInfo;
  return proto.base.v1.AnswerDetailInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.AnswerDetailInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.AnswerDetailInfo}
 */
proto.base.v1.AnswerDetailInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQbid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestion(value);
      break;
    case 3:
      var value = new proto.base.v1.NetImage;
      reader.readMessage(value,proto.base.v1.NetImage.deserializeBinaryFromReader);
      msg.setImage(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.addAnswer(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRightanswerindex(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUseranswerindex(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAnswercorrect(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsanswer(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.AnswerDetailInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.AnswerDetailInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.AnswerDetailInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.AnswerDetailInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQbid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getQuestion();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getImage();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.base.v1.NetImage.serializeBinaryToWriter
    );
  }
  f = message.getAnswerList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      4,
      f
    );
  }
  f = message.getRightanswerindex();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getUseranswerindex();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getAnswercorrect();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getIsanswer();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
};


/**
 * optional int32 qbId = 1;
 * @return {number}
 */
proto.base.v1.AnswerDetailInfo.prototype.getQbid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.AnswerDetailInfo} returns this
 */
proto.base.v1.AnswerDetailInfo.prototype.setQbid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string question = 2;
 * @return {string}
 */
proto.base.v1.AnswerDetailInfo.prototype.getQuestion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.v1.AnswerDetailInfo} returns this
 */
proto.base.v1.AnswerDetailInfo.prototype.setQuestion = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional NetImage image = 3;
 * @return {?proto.base.v1.NetImage}
 */
proto.base.v1.AnswerDetailInfo.prototype.getImage = function() {
  return /** @type{?proto.base.v1.NetImage} */ (
    jspb.Message.getWrapperField(this, proto.base.v1.NetImage, 3));
};


/**
 * @param {?proto.base.v1.NetImage|undefined} value
 * @return {!proto.base.v1.AnswerDetailInfo} returns this
*/
proto.base.v1.AnswerDetailInfo.prototype.setImage = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.base.v1.AnswerDetailInfo} returns this
 */
proto.base.v1.AnswerDetailInfo.prototype.clearImage = function() {
  return this.setImage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.base.v1.AnswerDetailInfo.prototype.hasImage = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * repeated string answer = 4;
 * @return {!Array<string>}
 */
proto.base.v1.AnswerDetailInfo.prototype.getAnswerList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.base.v1.AnswerDetailInfo} returns this
 */
proto.base.v1.AnswerDetailInfo.prototype.setAnswerList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.base.v1.AnswerDetailInfo} returns this
 */
proto.base.v1.AnswerDetailInfo.prototype.addAnswer = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.base.v1.AnswerDetailInfo} returns this
 */
proto.base.v1.AnswerDetailInfo.prototype.clearAnswerList = function() {
  return this.setAnswerList([]);
};


/**
 * optional int32 rightAnswerIndex = 5;
 * @return {number}
 */
proto.base.v1.AnswerDetailInfo.prototype.getRightanswerindex = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.AnswerDetailInfo} returns this
 */
proto.base.v1.AnswerDetailInfo.prototype.setRightanswerindex = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 userAnswerIndex = 6;
 * @return {number}
 */
proto.base.v1.AnswerDetailInfo.prototype.getUseranswerindex = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.AnswerDetailInfo} returns this
 */
proto.base.v1.AnswerDetailInfo.prototype.setUseranswerindex = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional bool answerCorrect = 7;
 * @return {boolean}
 */
proto.base.v1.AnswerDetailInfo.prototype.getAnswercorrect = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.base.v1.AnswerDetailInfo} returns this
 */
proto.base.v1.AnswerDetailInfo.prototype.setAnswercorrect = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional bool isAnswer = 8;
 * @return {boolean}
 */
proto.base.v1.AnswerDetailInfo.prototype.getIsanswer = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.base.v1.AnswerDetailInfo} returns this
 */
proto.base.v1.AnswerDetailInfo.prototype.setIsanswer = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.ToActivityRegusterEditRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.ToActivityRegusterEditRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.ToActivityRegusterEditRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ToActivityRegusterEditRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
regid: jspb.Message.getFieldWithDefault(msg, 1, 0),
regname: jspb.Message.getFieldWithDefault(msg, 2, ""),
startsecond: jspb.Message.getFieldWithDefault(msg, 3, 0),
endsecond: jspb.Message.getFieldWithDefault(msg, 4, 0),
organizer: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.ToActivityRegusterEditRequest}
 */
proto.base.v1.ToActivityRegusterEditRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.ToActivityRegusterEditRequest;
  return proto.base.v1.ToActivityRegusterEditRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.ToActivityRegusterEditRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.ToActivityRegusterEditRequest}
 */
proto.base.v1.ToActivityRegusterEditRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRegid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRegname(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setStartsecond(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEndsecond(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrganizer(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.ToActivityRegusterEditRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.ToActivityRegusterEditRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.ToActivityRegusterEditRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ToActivityRegusterEditRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRegid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getRegname();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getStartsecond();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getEndsecond();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getOrganizer();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional int32 regId = 1;
 * @return {number}
 */
proto.base.v1.ToActivityRegusterEditRequest.prototype.getRegid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ToActivityRegusterEditRequest} returns this
 */
proto.base.v1.ToActivityRegusterEditRequest.prototype.setRegid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string regName = 2;
 * @return {string}
 */
proto.base.v1.ToActivityRegusterEditRequest.prototype.getRegname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.v1.ToActivityRegusterEditRequest} returns this
 */
proto.base.v1.ToActivityRegusterEditRequest.prototype.setRegname = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 startSecond = 3;
 * @return {number}
 */
proto.base.v1.ToActivityRegusterEditRequest.prototype.getStartsecond = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ToActivityRegusterEditRequest} returns this
 */
proto.base.v1.ToActivityRegusterEditRequest.prototype.setStartsecond = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 endSecond = 4;
 * @return {number}
 */
proto.base.v1.ToActivityRegusterEditRequest.prototype.getEndsecond = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ToActivityRegusterEditRequest} returns this
 */
proto.base.v1.ToActivityRegusterEditRequest.prototype.setEndsecond = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string organizer = 5;
 * @return {string}
 */
proto.base.v1.ToActivityRegusterEditRequest.prototype.getOrganizer = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.v1.ToActivityRegusterEditRequest} returns this
 */
proto.base.v1.ToActivityRegusterEditRequest.prototype.setOrganizer = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.ToActivityRegusterListRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.ToActivityRegusterListRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.ToActivityRegusterListRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ToActivityRegusterListRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
offset: jspb.Message.getFieldWithDefault(msg, 1, 0),
limit: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.ToActivityRegusterListRequest}
 */
proto.base.v1.ToActivityRegusterListRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.ToActivityRegusterListRequest;
  return proto.base.v1.ToActivityRegusterListRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.ToActivityRegusterListRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.ToActivityRegusterListRequest}
 */
proto.base.v1.ToActivityRegusterListRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOffset(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLimit(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.ToActivityRegusterListRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.ToActivityRegusterListRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.ToActivityRegusterListRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ToActivityRegusterListRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOffset();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional int32 offset = 1;
 * @return {number}
 */
proto.base.v1.ToActivityRegusterListRequest.prototype.getOffset = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ToActivityRegusterListRequest} returns this
 */
proto.base.v1.ToActivityRegusterListRequest.prototype.setOffset = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 limit = 2;
 * @return {number}
 */
proto.base.v1.ToActivityRegusterListRequest.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ToActivityRegusterListRequest} returns this
 */
proto.base.v1.ToActivityRegusterListRequest.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.base.v1.ToActivityRegusterListReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.ToActivityRegusterListReply.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.ToActivityRegusterListReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.ToActivityRegusterListReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ToActivityRegusterListReply.toObject = function(includeInstance, msg) {
  var f, obj = {
listList: jspb.Message.toObjectList(msg.getListList(),
    proto.base.v1.ToActivityRegusterInfo.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.ToActivityRegusterListReply}
 */
proto.base.v1.ToActivityRegusterListReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.ToActivityRegusterListReply;
  return proto.base.v1.ToActivityRegusterListReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.ToActivityRegusterListReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.ToActivityRegusterListReply}
 */
proto.base.v1.ToActivityRegusterListReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.base.v1.ToActivityRegusterInfo;
      reader.readMessage(value,proto.base.v1.ToActivityRegusterInfo.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.ToActivityRegusterListReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.ToActivityRegusterListReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.ToActivityRegusterListReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ToActivityRegusterListReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.base.v1.ToActivityRegusterInfo.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ToActivityRegusterInfo list = 1;
 * @return {!Array<!proto.base.v1.ToActivityRegusterInfo>}
 */
proto.base.v1.ToActivityRegusterListReply.prototype.getListList = function() {
  return /** @type{!Array<!proto.base.v1.ToActivityRegusterInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.base.v1.ToActivityRegusterInfo, 1));
};


/**
 * @param {!Array<!proto.base.v1.ToActivityRegusterInfo>} value
 * @return {!proto.base.v1.ToActivityRegusterListReply} returns this
*/
proto.base.v1.ToActivityRegusterListReply.prototype.setListList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.base.v1.ToActivityRegusterInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.base.v1.ToActivityRegusterInfo}
 */
proto.base.v1.ToActivityRegusterListReply.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.base.v1.ToActivityRegusterInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.base.v1.ToActivityRegusterListReply} returns this
 */
proto.base.v1.ToActivityRegusterListReply.prototype.clearListList = function() {
  return this.setListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.ToActivityRegusterInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.ToActivityRegusterInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.ToActivityRegusterInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ToActivityRegusterInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
regid: jspb.Message.getFieldWithDefault(msg, 1, 0),
regname: jspb.Message.getFieldWithDefault(msg, 2, ""),
startsecond: jspb.Message.getFieldWithDefault(msg, 3, 0),
endsecond: jspb.Message.getFieldWithDefault(msg, 4, 0),
organizer: jspb.Message.getFieldWithDefault(msg, 5, ""),
key: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.ToActivityRegusterInfo}
 */
proto.base.v1.ToActivityRegusterInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.ToActivityRegusterInfo;
  return proto.base.v1.ToActivityRegusterInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.ToActivityRegusterInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.ToActivityRegusterInfo}
 */
proto.base.v1.ToActivityRegusterInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRegid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRegname(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setStartsecond(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEndsecond(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrganizer(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setKey(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.ToActivityRegusterInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.ToActivityRegusterInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.ToActivityRegusterInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ToActivityRegusterInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRegid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getRegname();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getStartsecond();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getEndsecond();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getOrganizer();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getKey();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional int32 regId = 1;
 * @return {number}
 */
proto.base.v1.ToActivityRegusterInfo.prototype.getRegid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ToActivityRegusterInfo} returns this
 */
proto.base.v1.ToActivityRegusterInfo.prototype.setRegid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string regName = 2;
 * @return {string}
 */
proto.base.v1.ToActivityRegusterInfo.prototype.getRegname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.v1.ToActivityRegusterInfo} returns this
 */
proto.base.v1.ToActivityRegusterInfo.prototype.setRegname = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 startSecond = 3;
 * @return {number}
 */
proto.base.v1.ToActivityRegusterInfo.prototype.getStartsecond = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ToActivityRegusterInfo} returns this
 */
proto.base.v1.ToActivityRegusterInfo.prototype.setStartsecond = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 endSecond = 4;
 * @return {number}
 */
proto.base.v1.ToActivityRegusterInfo.prototype.getEndsecond = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ToActivityRegusterInfo} returns this
 */
proto.base.v1.ToActivityRegusterInfo.prototype.setEndsecond = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string organizer = 5;
 * @return {string}
 */
proto.base.v1.ToActivityRegusterInfo.prototype.getOrganizer = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.v1.ToActivityRegusterInfo} returns this
 */
proto.base.v1.ToActivityRegusterInfo.prototype.setOrganizer = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string key = 6;
 * @return {string}
 */
proto.base.v1.ToActivityRegusterInfo.prototype.getKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.v1.ToActivityRegusterInfo} returns this
 */
proto.base.v1.ToActivityRegusterInfo.prototype.setKey = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.ToGameRankingRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.ToGameRankingRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.ToGameRankingRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ToGameRankingRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
mapid: jspb.Message.getFieldWithDefault(msg, 1, 0),
startsecond: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.ToGameRankingRequest}
 */
proto.base.v1.ToGameRankingRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.ToGameRankingRequest;
  return proto.base.v1.ToGameRankingRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.ToGameRankingRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.ToGameRankingRequest}
 */
proto.base.v1.ToGameRankingRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMapid(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setStartsecond(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.ToGameRankingRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.ToGameRankingRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.ToGameRankingRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ToGameRankingRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMapid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getStartsecond();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional int32 mapId = 1;
 * @return {number}
 */
proto.base.v1.ToGameRankingRequest.prototype.getMapid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ToGameRankingRequest} returns this
 */
proto.base.v1.ToGameRankingRequest.prototype.setMapid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 startSecond = 2;
 * @return {number}
 */
proto.base.v1.ToGameRankingRequest.prototype.getStartsecond = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ToGameRankingRequest} returns this
 */
proto.base.v1.ToGameRankingRequest.prototype.setStartsecond = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.base.v1.ToGameRankingReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.ToGameRankingReply.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.ToGameRankingReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.ToGameRankingReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ToGameRankingReply.toObject = function(includeInstance, msg) {
  var f, obj = {
listList: jspb.Message.toObjectList(msg.getListList(),
    proto.base.v1.ToActionRankInfo.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.ToGameRankingReply}
 */
proto.base.v1.ToGameRankingReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.ToGameRankingReply;
  return proto.base.v1.ToGameRankingReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.ToGameRankingReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.ToGameRankingReply}
 */
proto.base.v1.ToGameRankingReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.base.v1.ToActionRankInfo;
      reader.readMessage(value,proto.base.v1.ToActionRankInfo.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.ToGameRankingReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.ToGameRankingReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.ToGameRankingReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ToGameRankingReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.base.v1.ToActionRankInfo.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ToActionRankInfo list = 1;
 * @return {!Array<!proto.base.v1.ToActionRankInfo>}
 */
proto.base.v1.ToGameRankingReply.prototype.getListList = function() {
  return /** @type{!Array<!proto.base.v1.ToActionRankInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.base.v1.ToActionRankInfo, 1));
};


/**
 * @param {!Array<!proto.base.v1.ToActionRankInfo>} value
 * @return {!proto.base.v1.ToGameRankingReply} returns this
*/
proto.base.v1.ToGameRankingReply.prototype.setListList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.base.v1.ToActionRankInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.base.v1.ToActionRankInfo}
 */
proto.base.v1.ToGameRankingReply.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.base.v1.ToActionRankInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.base.v1.ToGameRankingReply} returns this
 */
proto.base.v1.ToGameRankingReply.prototype.clearListList = function() {
  return this.setListList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.base.v1.ToActionRankInfo.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.ToActionRankInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.ToActionRankInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.ToActionRankInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ToActionRankInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
actid: jspb.Message.getFieldWithDefault(msg, 1, 0),
actname: jspb.Message.getFieldWithDefault(msg, 2, ""),
totalusernum: jspb.Message.getFieldWithDefault(msg, 3, 0),
ranklistList: jspb.Message.toObjectList(msg.getRanklistList(),
    proto.base.v1.ToOrienteerRankInfo.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.ToActionRankInfo}
 */
proto.base.v1.ToActionRankInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.ToActionRankInfo;
  return proto.base.v1.ToActionRankInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.ToActionRankInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.ToActionRankInfo}
 */
proto.base.v1.ToActionRankInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setActid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setActname(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalusernum(value);
      break;
    case 4:
      var value = new proto.base.v1.ToOrienteerRankInfo;
      reader.readMessage(value,proto.base.v1.ToOrienteerRankInfo.deserializeBinaryFromReader);
      msg.addRanklist(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.ToActionRankInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.ToActionRankInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.ToActionRankInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ToActionRankInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getActid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getActname();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTotalusernum();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getRanklistList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.base.v1.ToOrienteerRankInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 actId = 1;
 * @return {number}
 */
proto.base.v1.ToActionRankInfo.prototype.getActid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ToActionRankInfo} returns this
 */
proto.base.v1.ToActionRankInfo.prototype.setActid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string actName = 2;
 * @return {string}
 */
proto.base.v1.ToActionRankInfo.prototype.getActname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.v1.ToActionRankInfo} returns this
 */
proto.base.v1.ToActionRankInfo.prototype.setActname = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 totalUserNum = 3;
 * @return {number}
 */
proto.base.v1.ToActionRankInfo.prototype.getTotalusernum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ToActionRankInfo} returns this
 */
proto.base.v1.ToActionRankInfo.prototype.setTotalusernum = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * repeated ToOrienteerRankInfo rankList = 4;
 * @return {!Array<!proto.base.v1.ToOrienteerRankInfo>}
 */
proto.base.v1.ToActionRankInfo.prototype.getRanklistList = function() {
  return /** @type{!Array<!proto.base.v1.ToOrienteerRankInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.base.v1.ToOrienteerRankInfo, 4));
};


/**
 * @param {!Array<!proto.base.v1.ToOrienteerRankInfo>} value
 * @return {!proto.base.v1.ToActionRankInfo} returns this
*/
proto.base.v1.ToActionRankInfo.prototype.setRanklistList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.base.v1.ToOrienteerRankInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.base.v1.ToOrienteerRankInfo}
 */
proto.base.v1.ToActionRankInfo.prototype.addRanklist = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.base.v1.ToOrienteerRankInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.base.v1.ToActionRankInfo} returns this
 */
proto.base.v1.ToActionRankInfo.prototype.clearRanklistList = function() {
  return this.setRanklistList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.ToOrienteerRankInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.ToOrienteerRankInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.ToOrienteerRankInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ToOrienteerRankInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
gameid: jspb.Message.getFieldWithDefault(msg, 1, 0),
oname: jspb.Message.getFieldWithDefault(msg, 2, ""),
phone: jspb.Message.getFieldWithDefault(msg, 3, ""),
coursename: jspb.Message.getFieldWithDefault(msg, 4, ""),
state: jspb.Message.getFieldWithDefault(msg, 5, 0),
startAt: (f = msg.getStartAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
duration: (f = msg.getDuration()) && google_protobuf_duration_pb.Duration.toObject(includeInstance, f),
distance: jspb.Message.getFieldWithDefault(msg, 8, 0),
totalcontrolnum: jspb.Message.getFieldWithDefault(msg, 9, 0),
oid: jspb.Message.getFieldWithDefault(msg, 10, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.ToOrienteerRankInfo}
 */
proto.base.v1.ToOrienteerRankInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.ToOrienteerRankInfo;
  return proto.base.v1.ToOrienteerRankInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.ToOrienteerRankInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.ToOrienteerRankInfo}
 */
proto.base.v1.ToOrienteerRankInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setGameid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setOname(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhone(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCoursename(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setState(value);
      break;
    case 6:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setStartAt(value);
      break;
    case 7:
      var value = new google_protobuf_duration_pb.Duration;
      reader.readMessage(value,google_protobuf_duration_pb.Duration.deserializeBinaryFromReader);
      msg.setDuration(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDistance(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalcontrolnum(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.ToOrienteerRankInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.ToOrienteerRankInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.ToOrienteerRankInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ToOrienteerRankInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGameid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getOname();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPhone();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCoursename();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getState();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getStartAt();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getDuration();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_duration_pb.Duration.serializeBinaryToWriter
    );
  }
  f = message.getDistance();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getTotalcontrolnum();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getOid();
  if (f !== 0) {
    writer.writeInt32(
      10,
      f
    );
  }
};


/**
 * optional int32 gameId = 1;
 * @return {number}
 */
proto.base.v1.ToOrienteerRankInfo.prototype.getGameid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ToOrienteerRankInfo} returns this
 */
proto.base.v1.ToOrienteerRankInfo.prototype.setGameid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string oName = 2;
 * @return {string}
 */
proto.base.v1.ToOrienteerRankInfo.prototype.getOname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.v1.ToOrienteerRankInfo} returns this
 */
proto.base.v1.ToOrienteerRankInfo.prototype.setOname = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string phone = 3;
 * @return {string}
 */
proto.base.v1.ToOrienteerRankInfo.prototype.getPhone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.v1.ToOrienteerRankInfo} returns this
 */
proto.base.v1.ToOrienteerRankInfo.prototype.setPhone = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string courseName = 4;
 * @return {string}
 */
proto.base.v1.ToOrienteerRankInfo.prototype.getCoursename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.v1.ToOrienteerRankInfo} returns this
 */
proto.base.v1.ToOrienteerRankInfo.prototype.setCoursename = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int32 state = 5;
 * @return {number}
 */
proto.base.v1.ToOrienteerRankInfo.prototype.getState = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ToOrienteerRankInfo} returns this
 */
proto.base.v1.ToOrienteerRankInfo.prototype.setState = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional google.protobuf.Timestamp start_at = 6;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.base.v1.ToOrienteerRankInfo.prototype.getStartAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 6));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.base.v1.ToOrienteerRankInfo} returns this
*/
proto.base.v1.ToOrienteerRankInfo.prototype.setStartAt = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.base.v1.ToOrienteerRankInfo} returns this
 */
proto.base.v1.ToOrienteerRankInfo.prototype.clearStartAt = function() {
  return this.setStartAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.base.v1.ToOrienteerRankInfo.prototype.hasStartAt = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional google.protobuf.Duration duration = 7;
 * @return {?proto.google.protobuf.Duration}
 */
proto.base.v1.ToOrienteerRankInfo.prototype.getDuration = function() {
  return /** @type{?proto.google.protobuf.Duration} */ (
    jspb.Message.getWrapperField(this, google_protobuf_duration_pb.Duration, 7));
};


/**
 * @param {?proto.google.protobuf.Duration|undefined} value
 * @return {!proto.base.v1.ToOrienteerRankInfo} returns this
*/
proto.base.v1.ToOrienteerRankInfo.prototype.setDuration = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.base.v1.ToOrienteerRankInfo} returns this
 */
proto.base.v1.ToOrienteerRankInfo.prototype.clearDuration = function() {
  return this.setDuration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.base.v1.ToOrienteerRankInfo.prototype.hasDuration = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional int32 distance = 8;
 * @return {number}
 */
proto.base.v1.ToOrienteerRankInfo.prototype.getDistance = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ToOrienteerRankInfo} returns this
 */
proto.base.v1.ToOrienteerRankInfo.prototype.setDistance = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int32 totalControlNum = 9;
 * @return {number}
 */
proto.base.v1.ToOrienteerRankInfo.prototype.getTotalcontrolnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ToOrienteerRankInfo} returns this
 */
proto.base.v1.ToOrienteerRankInfo.prototype.setTotalcontrolnum = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int32 oId = 10;
 * @return {number}
 */
proto.base.v1.ToOrienteerRankInfo.prototype.getOid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ToOrienteerRankInfo} returns this
 */
proto.base.v1.ToOrienteerRankInfo.prototype.setOid = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.ToGetUpdateVersionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.ToGetUpdateVersionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.ToGetUpdateVersionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ToGetUpdateVersionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
vcode: jspb.Message.getFieldWithDefault(msg, 1, ""),
vshop: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.ToGetUpdateVersionRequest}
 */
proto.base.v1.ToGetUpdateVersionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.ToGetUpdateVersionRequest;
  return proto.base.v1.ToGetUpdateVersionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.ToGetUpdateVersionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.ToGetUpdateVersionRequest}
 */
proto.base.v1.ToGetUpdateVersionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setVcode(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setVshop(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.ToGetUpdateVersionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.ToGetUpdateVersionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.ToGetUpdateVersionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ToGetUpdateVersionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVcode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getVshop();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional string vCode = 1;
 * @return {string}
 */
proto.base.v1.ToGetUpdateVersionRequest.prototype.getVcode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.v1.ToGetUpdateVersionRequest} returns this
 */
proto.base.v1.ToGetUpdateVersionRequest.prototype.setVcode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 vShop = 2;
 * @return {number}
 */
proto.base.v1.ToGetUpdateVersionRequest.prototype.getVshop = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ToGetUpdateVersionRequest} returns this
 */
proto.base.v1.ToGetUpdateVersionRequest.prototype.setVshop = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.ToGetUpdateVersionReply.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.ToGetUpdateVersionReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.ToGetUpdateVersionReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ToGetUpdateVersionReply.toObject = function(includeInstance, msg) {
  var f, obj = {
needupdate: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
vcode: jspb.Message.getFieldWithDefault(msg, 2, ""),
vmemo: jspb.Message.getFieldWithDefault(msg, 3, ""),
vurl: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.ToGetUpdateVersionReply}
 */
proto.base.v1.ToGetUpdateVersionReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.ToGetUpdateVersionReply;
  return proto.base.v1.ToGetUpdateVersionReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.ToGetUpdateVersionReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.ToGetUpdateVersionReply}
 */
proto.base.v1.ToGetUpdateVersionReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setNeedupdate(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setVcode(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setVmemo(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setVurl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.ToGetUpdateVersionReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.ToGetUpdateVersionReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.ToGetUpdateVersionReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ToGetUpdateVersionReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNeedupdate();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getVcode();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getVmemo();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getVurl();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional bool needUpdate = 1;
 * @return {boolean}
 */
proto.base.v1.ToGetUpdateVersionReply.prototype.getNeedupdate = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.base.v1.ToGetUpdateVersionReply} returns this
 */
proto.base.v1.ToGetUpdateVersionReply.prototype.setNeedupdate = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string vCode = 2;
 * @return {string}
 */
proto.base.v1.ToGetUpdateVersionReply.prototype.getVcode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.v1.ToGetUpdateVersionReply} returns this
 */
proto.base.v1.ToGetUpdateVersionReply.prototype.setVcode = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string vMemo = 3;
 * @return {string}
 */
proto.base.v1.ToGetUpdateVersionReply.prototype.getVmemo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.v1.ToGetUpdateVersionReply} returns this
 */
proto.base.v1.ToGetUpdateVersionReply.prototype.setVmemo = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string vUrl = 4;
 * @return {string}
 */
proto.base.v1.ToGetUpdateVersionReply.prototype.getVurl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.v1.ToGetUpdateVersionReply} returns this
 */
proto.base.v1.ToGetUpdateVersionReply.prototype.setVurl = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.base.v1.ToGameDetailReply.repeatedFields_ = [4,21,24];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.ToGameDetailReply.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.ToGameDetailReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.ToGameDetailReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ToGameDetailReply.toObject = function(includeInstance, msg) {
  var f, obj = {
gameId: jspb.Message.getFieldWithDefault(msg, 1, 0),
iscomplete: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
startAt: (f = msg.getStartAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
checkedSortedListList: jspb.Message.toObjectList(msg.getCheckedSortedListList(),
    proto.base.v1.ToControlPoint.toObject, includeInstance),
duration: (f = msg.getDuration()) && google_protobuf_duration_pb.Duration.toObject(includeInstance, f),
stopAt: (f = msg.getStopAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
issuccess: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
syspoint: jspb.Message.getFieldWithDefault(msg, 9, 0),
totalpointnum: jspb.Message.getFieldWithDefault(msg, 10, 0),
actname: jspb.Message.getFieldWithDefault(msg, 13, ""),
distance: jspb.Message.getFieldWithDefault(msg, 14, 0),
pace: jspb.Message.getFieldWithDefault(msg, 15, 0),
avghr: jspb.Message.getFieldWithDefault(msg, 16, 0),
calorie: jspb.Message.getFieldWithDefault(msg, 17, 0),
ck: jspb.Message.getFieldWithDefault(msg, 18, 0),
ei: jspb.Message.getFloatingPointFieldWithDefault(msg, 19, 0.0),
stepnum: jspb.Message.getFieldWithDefault(msg, 20, 0),
gamegpsinfoList: jspb.Message.toObjectList(msg.getGamegpsinfoList(),
    proto.base.v1.GameGpsInfo.toObject, includeInstance),
gamehrinfosList: jspb.Message.toObjectList(msg.getGamehrinfosList(),
    proto.base.v1.HeartRate.toObject, includeInstance),
source: jspb.Message.getFieldWithDefault(msg, 25, 0),
actid: jspb.Message.getFieldWithDefault(msg, 26, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.ToGameDetailReply}
 */
proto.base.v1.ToGameDetailReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.ToGameDetailReply;
  return proto.base.v1.ToGameDetailReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.ToGameDetailReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.ToGameDetailReply}
 */
proto.base.v1.ToGameDetailReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setGameId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIscomplete(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setStartAt(value);
      break;
    case 4:
      var value = new proto.base.v1.ToControlPoint;
      reader.readMessage(value,proto.base.v1.ToControlPoint.deserializeBinaryFromReader);
      msg.addCheckedSortedList(value);
      break;
    case 5:
      var value = new google_protobuf_duration_pb.Duration;
      reader.readMessage(value,google_protobuf_duration_pb.Duration.deserializeBinaryFromReader);
      msg.setDuration(value);
      break;
    case 6:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setStopAt(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIssuccess(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSyspoint(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalpointnum(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setActname(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDistance(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPace(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAvghr(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCalorie(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCk(value);
      break;
    case 19:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setEi(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setStepnum(value);
      break;
    case 21:
      var value = new proto.base.v1.GameGpsInfo;
      reader.readMessage(value,proto.base.v1.GameGpsInfo.deserializeBinaryFromReader);
      msg.addGamegpsinfo(value);
      break;
    case 24:
      var value = new proto.base.v1.HeartRate;
      reader.readMessage(value,proto.base.v1.HeartRate.deserializeBinaryFromReader);
      msg.addGamehrinfos(value);
      break;
    case 25:
      var value = /** @type {!proto.base.v1.GameHistorySource} */ (reader.readEnum());
      msg.setSource(value);
      break;
    case 26:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setActid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.ToGameDetailReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.ToGameDetailReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.ToGameDetailReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ToGameDetailReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGameId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getIscomplete();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getStartAt();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getCheckedSortedListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.base.v1.ToControlPoint.serializeBinaryToWriter
    );
  }
  f = message.getDuration();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_duration_pb.Duration.serializeBinaryToWriter
    );
  }
  f = message.getStopAt();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getIssuccess();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getSyspoint();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getTotalpointnum();
  if (f !== 0) {
    writer.writeInt32(
      10,
      f
    );
  }
  f = message.getActname();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getDistance();
  if (f !== 0) {
    writer.writeInt32(
      14,
      f
    );
  }
  f = message.getPace();
  if (f !== 0) {
    writer.writeInt32(
      15,
      f
    );
  }
  f = message.getAvghr();
  if (f !== 0) {
    writer.writeInt32(
      16,
      f
    );
  }
  f = message.getCalorie();
  if (f !== 0) {
    writer.writeInt32(
      17,
      f
    );
  }
  f = message.getCk();
  if (f !== 0) {
    writer.writeInt32(
      18,
      f
    );
  }
  f = message.getEi();
  if (f !== 0.0) {
    writer.writeFloat(
      19,
      f
    );
  }
  f = message.getStepnum();
  if (f !== 0) {
    writer.writeInt32(
      20,
      f
    );
  }
  f = message.getGamegpsinfoList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      21,
      f,
      proto.base.v1.GameGpsInfo.serializeBinaryToWriter
    );
  }
  f = message.getGamehrinfosList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      24,
      f,
      proto.base.v1.HeartRate.serializeBinaryToWriter
    );
  }
  f = message.getSource();
  if (f !== 0.0) {
    writer.writeEnum(
      25,
      f
    );
  }
  f = message.getActid();
  if (f !== 0) {
    writer.writeInt32(
      26,
      f
    );
  }
};


/**
 * optional int32 game_id = 1;
 * @return {number}
 */
proto.base.v1.ToGameDetailReply.prototype.getGameId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ToGameDetailReply} returns this
 */
proto.base.v1.ToGameDetailReply.prototype.setGameId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool isComplete = 2;
 * @return {boolean}
 */
proto.base.v1.ToGameDetailReply.prototype.getIscomplete = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.base.v1.ToGameDetailReply} returns this
 */
proto.base.v1.ToGameDetailReply.prototype.setIscomplete = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional google.protobuf.Timestamp start_at = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.base.v1.ToGameDetailReply.prototype.getStartAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.base.v1.ToGameDetailReply} returns this
*/
proto.base.v1.ToGameDetailReply.prototype.setStartAt = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.base.v1.ToGameDetailReply} returns this
 */
proto.base.v1.ToGameDetailReply.prototype.clearStartAt = function() {
  return this.setStartAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.base.v1.ToGameDetailReply.prototype.hasStartAt = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * repeated ToControlPoint checked_sorted_list = 4;
 * @return {!Array<!proto.base.v1.ToControlPoint>}
 */
proto.base.v1.ToGameDetailReply.prototype.getCheckedSortedListList = function() {
  return /** @type{!Array<!proto.base.v1.ToControlPoint>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.base.v1.ToControlPoint, 4));
};


/**
 * @param {!Array<!proto.base.v1.ToControlPoint>} value
 * @return {!proto.base.v1.ToGameDetailReply} returns this
*/
proto.base.v1.ToGameDetailReply.prototype.setCheckedSortedListList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.base.v1.ToControlPoint=} opt_value
 * @param {number=} opt_index
 * @return {!proto.base.v1.ToControlPoint}
 */
proto.base.v1.ToGameDetailReply.prototype.addCheckedSortedList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.base.v1.ToControlPoint, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.base.v1.ToGameDetailReply} returns this
 */
proto.base.v1.ToGameDetailReply.prototype.clearCheckedSortedListList = function() {
  return this.setCheckedSortedListList([]);
};


/**
 * optional google.protobuf.Duration duration = 5;
 * @return {?proto.google.protobuf.Duration}
 */
proto.base.v1.ToGameDetailReply.prototype.getDuration = function() {
  return /** @type{?proto.google.protobuf.Duration} */ (
    jspb.Message.getWrapperField(this, google_protobuf_duration_pb.Duration, 5));
};


/**
 * @param {?proto.google.protobuf.Duration|undefined} value
 * @return {!proto.base.v1.ToGameDetailReply} returns this
*/
proto.base.v1.ToGameDetailReply.prototype.setDuration = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.base.v1.ToGameDetailReply} returns this
 */
proto.base.v1.ToGameDetailReply.prototype.clearDuration = function() {
  return this.setDuration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.base.v1.ToGameDetailReply.prototype.hasDuration = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.Timestamp stop_at = 6;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.base.v1.ToGameDetailReply.prototype.getStopAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 6));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.base.v1.ToGameDetailReply} returns this
*/
proto.base.v1.ToGameDetailReply.prototype.setStopAt = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.base.v1.ToGameDetailReply} returns this
 */
proto.base.v1.ToGameDetailReply.prototype.clearStopAt = function() {
  return this.setStopAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.base.v1.ToGameDetailReply.prototype.hasStopAt = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional bool isSuccess = 8;
 * @return {boolean}
 */
proto.base.v1.ToGameDetailReply.prototype.getIssuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.base.v1.ToGameDetailReply} returns this
 */
proto.base.v1.ToGameDetailReply.prototype.setIssuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * optional int32 sysPoint = 9;
 * @return {number}
 */
proto.base.v1.ToGameDetailReply.prototype.getSyspoint = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ToGameDetailReply} returns this
 */
proto.base.v1.ToGameDetailReply.prototype.setSyspoint = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int32 totalPointNum = 10;
 * @return {number}
 */
proto.base.v1.ToGameDetailReply.prototype.getTotalpointnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ToGameDetailReply} returns this
 */
proto.base.v1.ToGameDetailReply.prototype.setTotalpointnum = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional string actName = 13;
 * @return {string}
 */
proto.base.v1.ToGameDetailReply.prototype.getActname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.v1.ToGameDetailReply} returns this
 */
proto.base.v1.ToGameDetailReply.prototype.setActname = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional int32 distance = 14;
 * @return {number}
 */
proto.base.v1.ToGameDetailReply.prototype.getDistance = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ToGameDetailReply} returns this
 */
proto.base.v1.ToGameDetailReply.prototype.setDistance = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional int32 pace = 15;
 * @return {number}
 */
proto.base.v1.ToGameDetailReply.prototype.getPace = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ToGameDetailReply} returns this
 */
proto.base.v1.ToGameDetailReply.prototype.setPace = function(value) {
  return jspb.Message.setProto3IntField(this, 15, value);
};


/**
 * optional int32 avgHr = 16;
 * @return {number}
 */
proto.base.v1.ToGameDetailReply.prototype.getAvghr = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ToGameDetailReply} returns this
 */
proto.base.v1.ToGameDetailReply.prototype.setAvghr = function(value) {
  return jspb.Message.setProto3IntField(this, 16, value);
};


/**
 * optional int32 Calorie = 17;
 * @return {number}
 */
proto.base.v1.ToGameDetailReply.prototype.getCalorie = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ToGameDetailReply} returns this
 */
proto.base.v1.ToGameDetailReply.prototype.setCalorie = function(value) {
  return jspb.Message.setProto3IntField(this, 17, value);
};


/**
 * optional int32 Ck = 18;
 * @return {number}
 */
proto.base.v1.ToGameDetailReply.prototype.getCk = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ToGameDetailReply} returns this
 */
proto.base.v1.ToGameDetailReply.prototype.setCk = function(value) {
  return jspb.Message.setProto3IntField(this, 18, value);
};


/**
 * optional float Ei = 19;
 * @return {number}
 */
proto.base.v1.ToGameDetailReply.prototype.getEi = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 19, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ToGameDetailReply} returns this
 */
proto.base.v1.ToGameDetailReply.prototype.setEi = function(value) {
  return jspb.Message.setProto3FloatField(this, 19, value);
};


/**
 * optional int32 stepNum = 20;
 * @return {number}
 */
proto.base.v1.ToGameDetailReply.prototype.getStepnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 20, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ToGameDetailReply} returns this
 */
proto.base.v1.ToGameDetailReply.prototype.setStepnum = function(value) {
  return jspb.Message.setProto3IntField(this, 20, value);
};


/**
 * repeated GameGpsInfo gameGpsInfo = 21;
 * @return {!Array<!proto.base.v1.GameGpsInfo>}
 */
proto.base.v1.ToGameDetailReply.prototype.getGamegpsinfoList = function() {
  return /** @type{!Array<!proto.base.v1.GameGpsInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.base.v1.GameGpsInfo, 21));
};


/**
 * @param {!Array<!proto.base.v1.GameGpsInfo>} value
 * @return {!proto.base.v1.ToGameDetailReply} returns this
*/
proto.base.v1.ToGameDetailReply.prototype.setGamegpsinfoList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 21, value);
};


/**
 * @param {!proto.base.v1.GameGpsInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.base.v1.GameGpsInfo}
 */
proto.base.v1.ToGameDetailReply.prototype.addGamegpsinfo = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 21, opt_value, proto.base.v1.GameGpsInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.base.v1.ToGameDetailReply} returns this
 */
proto.base.v1.ToGameDetailReply.prototype.clearGamegpsinfoList = function() {
  return this.setGamegpsinfoList([]);
};


/**
 * repeated HeartRate gameHrInfos = 24;
 * @return {!Array<!proto.base.v1.HeartRate>}
 */
proto.base.v1.ToGameDetailReply.prototype.getGamehrinfosList = function() {
  return /** @type{!Array<!proto.base.v1.HeartRate>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.base.v1.HeartRate, 24));
};


/**
 * @param {!Array<!proto.base.v1.HeartRate>} value
 * @return {!proto.base.v1.ToGameDetailReply} returns this
*/
proto.base.v1.ToGameDetailReply.prototype.setGamehrinfosList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 24, value);
};


/**
 * @param {!proto.base.v1.HeartRate=} opt_value
 * @param {number=} opt_index
 * @return {!proto.base.v1.HeartRate}
 */
proto.base.v1.ToGameDetailReply.prototype.addGamehrinfos = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 24, opt_value, proto.base.v1.HeartRate, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.base.v1.ToGameDetailReply} returns this
 */
proto.base.v1.ToGameDetailReply.prototype.clearGamehrinfosList = function() {
  return this.setGamehrinfosList([]);
};


/**
 * optional GameHistorySource source = 25;
 * @return {!proto.base.v1.GameHistorySource}
 */
proto.base.v1.ToGameDetailReply.prototype.getSource = function() {
  return /** @type {!proto.base.v1.GameHistorySource} */ (jspb.Message.getFieldWithDefault(this, 25, 0));
};


/**
 * @param {!proto.base.v1.GameHistorySource} value
 * @return {!proto.base.v1.ToGameDetailReply} returns this
 */
proto.base.v1.ToGameDetailReply.prototype.setSource = function(value) {
  return jspb.Message.setProto3EnumField(this, 25, value);
};


/**
 * optional int32 actId = 26;
 * @return {number}
 */
proto.base.v1.ToGameDetailReply.prototype.getActid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 26, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ToGameDetailReply} returns this
 */
proto.base.v1.ToGameDetailReply.prototype.setActid = function(value) {
  return jspb.Message.setProto3IntField(this, 26, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.base.v1.ToHisUserListQueryReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.ToHisUserListQueryReply.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.ToHisUserListQueryReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.ToHisUserListQueryReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ToHisUserListQueryReply.toObject = function(includeInstance, msg) {
  var f, obj = {
listList: jspb.Message.toObjectList(msg.getListList(),
    proto.base.v1.ToHisUserBasic.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.ToHisUserListQueryReply}
 */
proto.base.v1.ToHisUserListQueryReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.ToHisUserListQueryReply;
  return proto.base.v1.ToHisUserListQueryReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.ToHisUserListQueryReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.ToHisUserListQueryReply}
 */
proto.base.v1.ToHisUserListQueryReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.base.v1.ToHisUserBasic;
      reader.readMessage(value,proto.base.v1.ToHisUserBasic.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.ToHisUserListQueryReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.ToHisUserListQueryReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.ToHisUserListQueryReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ToHisUserListQueryReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.base.v1.ToHisUserBasic.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ToHisUserBasic list = 1;
 * @return {!Array<!proto.base.v1.ToHisUserBasic>}
 */
proto.base.v1.ToHisUserListQueryReply.prototype.getListList = function() {
  return /** @type{!Array<!proto.base.v1.ToHisUserBasic>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.base.v1.ToHisUserBasic, 1));
};


/**
 * @param {!Array<!proto.base.v1.ToHisUserBasic>} value
 * @return {!proto.base.v1.ToHisUserListQueryReply} returns this
*/
proto.base.v1.ToHisUserListQueryReply.prototype.setListList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.base.v1.ToHisUserBasic=} opt_value
 * @param {number=} opt_index
 * @return {!proto.base.v1.ToHisUserBasic}
 */
proto.base.v1.ToHisUserListQueryReply.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.base.v1.ToHisUserBasic, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.base.v1.ToHisUserListQueryReply} returns this
 */
proto.base.v1.ToHisUserListQueryReply.prototype.clearListList = function() {
  return this.setListList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.base.v1.ToHisUserBasic.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.ToHisUserBasic.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.ToHisUserBasic.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.ToHisUserBasic} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ToHisUserBasic.toObject = function(includeInstance, msg) {
  var f, obj = {
oid: jspb.Message.getFieldWithDefault(msg, 1, 0),
oname: jspb.Message.getFieldWithDefault(msg, 2, ""),
listList: jspb.Message.toObjectList(msg.getListList(),
    proto.base.v1.ToHisUserInfo.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.ToHisUserBasic}
 */
proto.base.v1.ToHisUserBasic.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.ToHisUserBasic;
  return proto.base.v1.ToHisUserBasic.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.ToHisUserBasic} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.ToHisUserBasic}
 */
proto.base.v1.ToHisUserBasic.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setOname(value);
      break;
    case 3:
      var value = new proto.base.v1.ToHisUserInfo;
      reader.readMessage(value,proto.base.v1.ToHisUserInfo.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.ToHisUserBasic.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.ToHisUserBasic.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.ToHisUserBasic} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ToHisUserBasic.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getOname();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.base.v1.ToHisUserInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 OId = 1;
 * @return {number}
 */
proto.base.v1.ToHisUserBasic.prototype.getOid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ToHisUserBasic} returns this
 */
proto.base.v1.ToHisUserBasic.prototype.setOid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string OName = 2;
 * @return {string}
 */
proto.base.v1.ToHisUserBasic.prototype.getOname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.v1.ToHisUserBasic} returns this
 */
proto.base.v1.ToHisUserBasic.prototype.setOname = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated ToHisUserInfo list = 3;
 * @return {!Array<!proto.base.v1.ToHisUserInfo>}
 */
proto.base.v1.ToHisUserBasic.prototype.getListList = function() {
  return /** @type{!Array<!proto.base.v1.ToHisUserInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.base.v1.ToHisUserInfo, 3));
};


/**
 * @param {!Array<!proto.base.v1.ToHisUserInfo>} value
 * @return {!proto.base.v1.ToHisUserBasic} returns this
*/
proto.base.v1.ToHisUserBasic.prototype.setListList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.base.v1.ToHisUserInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.base.v1.ToHisUserInfo}
 */
proto.base.v1.ToHisUserBasic.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.base.v1.ToHisUserInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.base.v1.ToHisUserBasic} returns this
 */
proto.base.v1.ToHisUserBasic.prototype.clearListList = function() {
  return this.setListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.ToHisUserInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.ToHisUserInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.ToHisUserInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ToHisUserInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
gameid: jspb.Message.getFieldWithDefault(msg, 1, 0),
coursename: jspb.Message.getFieldWithDefault(msg, 2, ""),
actname: jspb.Message.getFieldWithDefault(msg, 3, ""),
iscomplete: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
startAt: (f = msg.getStartAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
duration: (f = msg.getDuration()) && google_protobuf_duration_pb.Duration.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.ToHisUserInfo}
 */
proto.base.v1.ToHisUserInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.ToHisUserInfo;
  return proto.base.v1.ToHisUserInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.ToHisUserInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.ToHisUserInfo}
 */
proto.base.v1.ToHisUserInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setGameid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCoursename(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setActname(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIscomplete(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setStartAt(value);
      break;
    case 6:
      var value = new google_protobuf_duration_pb.Duration;
      reader.readMessage(value,google_protobuf_duration_pb.Duration.deserializeBinaryFromReader);
      msg.setDuration(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.ToHisUserInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.ToHisUserInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.ToHisUserInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ToHisUserInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGameid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getCoursename();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getActname();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getIscomplete();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getStartAt();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getDuration();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_duration_pb.Duration.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 GameId = 1;
 * @return {number}
 */
proto.base.v1.ToHisUserInfo.prototype.getGameid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ToHisUserInfo} returns this
 */
proto.base.v1.ToHisUserInfo.prototype.setGameid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string CourseName = 2;
 * @return {string}
 */
proto.base.v1.ToHisUserInfo.prototype.getCoursename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.v1.ToHisUserInfo} returns this
 */
proto.base.v1.ToHisUserInfo.prototype.setCoursename = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string ActName = 3;
 * @return {string}
 */
proto.base.v1.ToHisUserInfo.prototype.getActname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.v1.ToHisUserInfo} returns this
 */
proto.base.v1.ToHisUserInfo.prototype.setActname = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bool isComplete = 4;
 * @return {boolean}
 */
proto.base.v1.ToHisUserInfo.prototype.getIscomplete = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.base.v1.ToHisUserInfo} returns this
 */
proto.base.v1.ToHisUserInfo.prototype.setIscomplete = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional google.protobuf.Timestamp start_at = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.base.v1.ToHisUserInfo.prototype.getStartAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.base.v1.ToHisUserInfo} returns this
*/
proto.base.v1.ToHisUserInfo.prototype.setStartAt = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.base.v1.ToHisUserInfo} returns this
 */
proto.base.v1.ToHisUserInfo.prototype.clearStartAt = function() {
  return this.setStartAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.base.v1.ToHisUserInfo.prototype.hasStartAt = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.Duration duration = 6;
 * @return {?proto.google.protobuf.Duration}
 */
proto.base.v1.ToHisUserInfo.prototype.getDuration = function() {
  return /** @type{?proto.google.protobuf.Duration} */ (
    jspb.Message.getWrapperField(this, google_protobuf_duration_pb.Duration, 6));
};


/**
 * @param {?proto.google.protobuf.Duration|undefined} value
 * @return {!proto.base.v1.ToHisUserInfo} returns this
*/
proto.base.v1.ToHisUserInfo.prototype.setDuration = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.base.v1.ToHisUserInfo} returns this
 */
proto.base.v1.ToHisUserInfo.prototype.clearDuration = function() {
  return this.setDuration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.base.v1.ToHisUserInfo.prototype.hasDuration = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.ToUserInActionBasicQueryRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.ToUserInActionBasicQueryRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.ToUserInActionBasicQueryRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ToUserInActionBasicQueryRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
actid: jspb.Message.getFieldWithDefault(msg, 1, 0),
userid: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.ToUserInActionBasicQueryRequest}
 */
proto.base.v1.ToUserInActionBasicQueryRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.ToUserInActionBasicQueryRequest;
  return proto.base.v1.ToUserInActionBasicQueryRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.ToUserInActionBasicQueryRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.ToUserInActionBasicQueryRequest}
 */
proto.base.v1.ToUserInActionBasicQueryRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setActid(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUserid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.ToUserInActionBasicQueryRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.ToUserInActionBasicQueryRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.ToUserInActionBasicQueryRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ToUserInActionBasicQueryRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getActid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getUserid();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional int32 ActId = 1;
 * @return {number}
 */
proto.base.v1.ToUserInActionBasicQueryRequest.prototype.getActid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ToUserInActionBasicQueryRequest} returns this
 */
proto.base.v1.ToUserInActionBasicQueryRequest.prototype.setActid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 UserId = 2;
 * @return {number}
 */
proto.base.v1.ToUserInActionBasicQueryRequest.prototype.getUserid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ToUserInActionBasicQueryRequest} returns this
 */
proto.base.v1.ToUserInActionBasicQueryRequest.prototype.setUserid = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.base.v1.ToUserInActionBasicQueryV2Request.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.ToUserInActionBasicQueryV2Request.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.ToUserInActionBasicQueryV2Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.ToUserInActionBasicQueryV2Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ToUserInActionBasicQueryV2Request.toObject = function(includeInstance, msg) {
  var f, obj = {
actid: jspb.Message.getFieldWithDefault(msg, 1, 0),
useridlistList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.ToUserInActionBasicQueryV2Request}
 */
proto.base.v1.ToUserInActionBasicQueryV2Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.ToUserInActionBasicQueryV2Request;
  return proto.base.v1.ToUserInActionBasicQueryV2Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.ToUserInActionBasicQueryV2Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.ToUserInActionBasicQueryV2Request}
 */
proto.base.v1.ToUserInActionBasicQueryV2Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setActid(value);
      break;
    case 2:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt32() : [reader.readInt32()]);
      for (var i = 0; i < values.length; i++) {
        msg.addUseridlist(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.ToUserInActionBasicQueryV2Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.ToUserInActionBasicQueryV2Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.ToUserInActionBasicQueryV2Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ToUserInActionBasicQueryV2Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getActid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getUseridlistList();
  if (f.length > 0) {
    writer.writePackedInt32(
      2,
      f
    );
  }
};


/**
 * optional int32 ActId = 1;
 * @return {number}
 */
proto.base.v1.ToUserInActionBasicQueryV2Request.prototype.getActid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ToUserInActionBasicQueryV2Request} returns this
 */
proto.base.v1.ToUserInActionBasicQueryV2Request.prototype.setActid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * repeated int32 UserIdList = 2;
 * @return {!Array<number>}
 */
proto.base.v1.ToUserInActionBasicQueryV2Request.prototype.getUseridlistList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.base.v1.ToUserInActionBasicQueryV2Request} returns this
 */
proto.base.v1.ToUserInActionBasicQueryV2Request.prototype.setUseridlistList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.base.v1.ToUserInActionBasicQueryV2Request} returns this
 */
proto.base.v1.ToUserInActionBasicQueryV2Request.prototype.addUseridlist = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.base.v1.ToUserInActionBasicQueryV2Request} returns this
 */
proto.base.v1.ToUserInActionBasicQueryV2Request.prototype.clearUseridlistList = function() {
  return this.setUseridlistList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.ToGetBinaryByMd5Request.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.ToGetBinaryByMd5Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.ToGetBinaryByMd5Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ToGetBinaryByMd5Request.toObject = function(includeInstance, msg) {
  var f, obj = {
md5: msg.getMd5_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.ToGetBinaryByMd5Request}
 */
proto.base.v1.ToGetBinaryByMd5Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.ToGetBinaryByMd5Request;
  return proto.base.v1.ToGetBinaryByMd5Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.ToGetBinaryByMd5Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.ToGetBinaryByMd5Request}
 */
proto.base.v1.ToGetBinaryByMd5Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setMd5(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.ToGetBinaryByMd5Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.ToGetBinaryByMd5Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.ToGetBinaryByMd5Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ToGetBinaryByMd5Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMd5_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
};


/**
 * optional bytes md5 = 1;
 * @return {string}
 */
proto.base.v1.ToGetBinaryByMd5Request.prototype.getMd5 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes md5 = 1;
 * This is a type-conversion wrapper around `getMd5()`
 * @return {string}
 */
proto.base.v1.ToGetBinaryByMd5Request.prototype.getMd5_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getMd5()));
};


/**
 * optional bytes md5 = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getMd5()`
 * @return {!Uint8Array}
 */
proto.base.v1.ToGetBinaryByMd5Request.prototype.getMd5_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getMd5()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.base.v1.ToGetBinaryByMd5Request} returns this
 */
proto.base.v1.ToGetBinaryByMd5Request.prototype.setMd5 = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.GetServerTimeRp.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.GetServerTimeRp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.GetServerTimeRp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.GetServerTimeRp.toObject = function(includeInstance, msg) {
  var f, obj = {
millisecondstamp: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.GetServerTimeRp}
 */
proto.base.v1.GetServerTimeRp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.GetServerTimeRp;
  return proto.base.v1.GetServerTimeRp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.GetServerTimeRp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.GetServerTimeRp}
 */
proto.base.v1.GetServerTimeRp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMillisecondstamp(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.GetServerTimeRp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.GetServerTimeRp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.GetServerTimeRp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.GetServerTimeRp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMillisecondstamp();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 millisecondStamp = 1;
 * @return {number}
 */
proto.base.v1.GetServerTimeRp.prototype.getMillisecondstamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.GetServerTimeRp} returns this
 */
proto.base.v1.GetServerTimeRp.prototype.setMillisecondstamp = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.ToSendCodeToPhoneRequestV2.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.ToSendCodeToPhoneRequestV2.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.ToSendCodeToPhoneRequestV2} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ToSendCodeToPhoneRequestV2.toObject = function(includeInstance, msg) {
  var f, obj = {
phone: jspb.Message.getFieldWithDefault(msg, 1, ""),
smstype: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.ToSendCodeToPhoneRequestV2}
 */
proto.base.v1.ToSendCodeToPhoneRequestV2.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.ToSendCodeToPhoneRequestV2;
  return proto.base.v1.ToSendCodeToPhoneRequestV2.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.ToSendCodeToPhoneRequestV2} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.ToSendCodeToPhoneRequestV2}
 */
proto.base.v1.ToSendCodeToPhoneRequestV2.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhone(value);
      break;
    case 2:
      var value = /** @type {!proto.base.v1.SmsType} */ (reader.readEnum());
      msg.setSmstype(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.ToSendCodeToPhoneRequestV2.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.ToSendCodeToPhoneRequestV2.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.ToSendCodeToPhoneRequestV2} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ToSendCodeToPhoneRequestV2.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPhone();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSmstype();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional string phone = 1;
 * @return {string}
 */
proto.base.v1.ToSendCodeToPhoneRequestV2.prototype.getPhone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.v1.ToSendCodeToPhoneRequestV2} returns this
 */
proto.base.v1.ToSendCodeToPhoneRequestV2.prototype.setPhone = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional SmsType smsType = 2;
 * @return {!proto.base.v1.SmsType}
 */
proto.base.v1.ToSendCodeToPhoneRequestV2.prototype.getSmstype = function() {
  return /** @type {!proto.base.v1.SmsType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.base.v1.SmsType} value
 * @return {!proto.base.v1.ToSendCodeToPhoneRequestV2} returns this
 */
proto.base.v1.ToSendCodeToPhoneRequestV2.prototype.setSmstype = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.ToSignInRequestV2.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.ToSignInRequestV2.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.ToSignInRequestV2} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ToSignInRequestV2.toObject = function(includeInstance, msg) {
  var f, obj = {
usercode: jspb.Message.getFieldWithDefault(msg, 1, ""),
password: jspb.Message.getFieldWithDefault(msg, 2, ""),
ip: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.ToSignInRequestV2}
 */
proto.base.v1.ToSignInRequestV2.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.ToSignInRequestV2;
  return proto.base.v1.ToSignInRequestV2.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.ToSignInRequestV2} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.ToSignInRequestV2}
 */
proto.base.v1.ToSignInRequestV2.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsercode(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPassword(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setIp(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.ToSignInRequestV2.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.ToSignInRequestV2.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.ToSignInRequestV2} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ToSignInRequestV2.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUsercode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPassword();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getIp();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string userCode = 1;
 * @return {string}
 */
proto.base.v1.ToSignInRequestV2.prototype.getUsercode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.v1.ToSignInRequestV2} returns this
 */
proto.base.v1.ToSignInRequestV2.prototype.setUsercode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string password = 2;
 * @return {string}
 */
proto.base.v1.ToSignInRequestV2.prototype.getPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.v1.ToSignInRequestV2} returns this
 */
proto.base.v1.ToSignInRequestV2.prototype.setPassword = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string ip = 3;
 * @return {string}
 */
proto.base.v1.ToSignInRequestV2.prototype.getIp = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.v1.ToSignInRequestV2} returns this
 */
proto.base.v1.ToSignInRequestV2.prototype.setIp = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.MapListRequestV2.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.MapListRequestV2.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.MapListRequestV2} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.MapListRequestV2.toObject = function(includeInstance, msg) {
  var f, obj = {
position: (f = msg.getPosition()) && proto.base.v1.Position.toObject(includeInstance, f),
offset: jspb.Message.getFieldWithDefault(msg, 2, 0),
limit: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.MapListRequestV2}
 */
proto.base.v1.MapListRequestV2.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.MapListRequestV2;
  return proto.base.v1.MapListRequestV2.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.MapListRequestV2} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.MapListRequestV2}
 */
proto.base.v1.MapListRequestV2.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.base.v1.Position;
      reader.readMessage(value,proto.base.v1.Position.deserializeBinaryFromReader);
      msg.setPosition(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOffset(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLimit(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.MapListRequestV2.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.MapListRequestV2.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.MapListRequestV2} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.MapListRequestV2.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPosition();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.base.v1.Position.serializeBinaryToWriter
    );
  }
  f = message.getOffset();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional Position position = 1;
 * @return {?proto.base.v1.Position}
 */
proto.base.v1.MapListRequestV2.prototype.getPosition = function() {
  return /** @type{?proto.base.v1.Position} */ (
    jspb.Message.getWrapperField(this, proto.base.v1.Position, 1));
};


/**
 * @param {?proto.base.v1.Position|undefined} value
 * @return {!proto.base.v1.MapListRequestV2} returns this
*/
proto.base.v1.MapListRequestV2.prototype.setPosition = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.base.v1.MapListRequestV2} returns this
 */
proto.base.v1.MapListRequestV2.prototype.clearPosition = function() {
  return this.setPosition(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.base.v1.MapListRequestV2.prototype.hasPosition = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int32 offset = 2;
 * @return {number}
 */
proto.base.v1.MapListRequestV2.prototype.getOffset = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.MapListRequestV2} returns this
 */
proto.base.v1.MapListRequestV2.prototype.setOffset = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 limit = 3;
 * @return {number}
 */
proto.base.v1.MapListRequestV2.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.MapListRequestV2} returns this
 */
proto.base.v1.MapListRequestV2.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.base.v1.ToMapListReplyV2.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.ToMapListReplyV2.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.ToMapListReplyV2.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.ToMapListReplyV2} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ToMapListReplyV2.toObject = function(includeInstance, msg) {
  var f, obj = {
listList: jspb.Message.toObjectList(msg.getListList(),
    proto.base.v1.ToMapSimpleV2.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.ToMapListReplyV2}
 */
proto.base.v1.ToMapListReplyV2.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.ToMapListReplyV2;
  return proto.base.v1.ToMapListReplyV2.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.ToMapListReplyV2} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.ToMapListReplyV2}
 */
proto.base.v1.ToMapListReplyV2.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.base.v1.ToMapSimpleV2;
      reader.readMessage(value,proto.base.v1.ToMapSimpleV2.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.ToMapListReplyV2.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.ToMapListReplyV2.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.ToMapListReplyV2} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ToMapListReplyV2.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.base.v1.ToMapSimpleV2.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ToMapSimpleV2 list = 1;
 * @return {!Array<!proto.base.v1.ToMapSimpleV2>}
 */
proto.base.v1.ToMapListReplyV2.prototype.getListList = function() {
  return /** @type{!Array<!proto.base.v1.ToMapSimpleV2>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.base.v1.ToMapSimpleV2, 1));
};


/**
 * @param {!Array<!proto.base.v1.ToMapSimpleV2>} value
 * @return {!proto.base.v1.ToMapListReplyV2} returns this
*/
proto.base.v1.ToMapListReplyV2.prototype.setListList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.base.v1.ToMapSimpleV2=} opt_value
 * @param {number=} opt_index
 * @return {!proto.base.v1.ToMapSimpleV2}
 */
proto.base.v1.ToMapListReplyV2.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.base.v1.ToMapSimpleV2, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.base.v1.ToMapListReplyV2} returns this
 */
proto.base.v1.ToMapListReplyV2.prototype.clearListList = function() {
  return this.setListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.ToMapSimpleV2.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.ToMapSimpleV2.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.ToMapSimpleV2} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ToMapSimpleV2.toObject = function(includeInstance, msg) {
  var f, obj = {
mapid: jspb.Message.getFieldWithDefault(msg, 1, 0),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
mapscalenumber: jspb.Message.getFieldWithDefault(msg, 3, 0),
description: jspb.Message.getFieldWithDefault(msg, 4, ""),
distance: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
image: (f = msg.getImage()) && proto.base.v1.NetImage.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.ToMapSimpleV2}
 */
proto.base.v1.ToMapSimpleV2.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.ToMapSimpleV2;
  return proto.base.v1.ToMapSimpleV2.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.ToMapSimpleV2} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.ToMapSimpleV2}
 */
proto.base.v1.ToMapSimpleV2.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMapid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMapscalenumber(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setDistance(value);
      break;
    case 6:
      var value = new proto.base.v1.NetImage;
      reader.readMessage(value,proto.base.v1.NetImage.deserializeBinaryFromReader);
      msg.setImage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.ToMapSimpleV2.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.ToMapSimpleV2.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.ToMapSimpleV2} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ToMapSimpleV2.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMapid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMapscalenumber();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getDistance();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getImage();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.base.v1.NetImage.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 mapId = 1;
 * @return {number}
 */
proto.base.v1.ToMapSimpleV2.prototype.getMapid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ToMapSimpleV2} returns this
 */
proto.base.v1.ToMapSimpleV2.prototype.setMapid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.base.v1.ToMapSimpleV2.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.v1.ToMapSimpleV2} returns this
 */
proto.base.v1.ToMapSimpleV2.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 mapScaleNumber = 3;
 * @return {number}
 */
proto.base.v1.ToMapSimpleV2.prototype.getMapscalenumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ToMapSimpleV2} returns this
 */
proto.base.v1.ToMapSimpleV2.prototype.setMapscalenumber = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string description = 4;
 * @return {string}
 */
proto.base.v1.ToMapSimpleV2.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.v1.ToMapSimpleV2} returns this
 */
proto.base.v1.ToMapSimpleV2.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional double distance = 5;
 * @return {number}
 */
proto.base.v1.ToMapSimpleV2.prototype.getDistance = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ToMapSimpleV2} returns this
 */
proto.base.v1.ToMapSimpleV2.prototype.setDistance = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional NetImage image = 6;
 * @return {?proto.base.v1.NetImage}
 */
proto.base.v1.ToMapSimpleV2.prototype.getImage = function() {
  return /** @type{?proto.base.v1.NetImage} */ (
    jspb.Message.getWrapperField(this, proto.base.v1.NetImage, 6));
};


/**
 * @param {?proto.base.v1.NetImage|undefined} value
 * @return {!proto.base.v1.ToMapSimpleV2} returns this
*/
proto.base.v1.ToMapSimpleV2.prototype.setImage = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.base.v1.ToMapSimpleV2} returns this
 */
proto.base.v1.ToMapSimpleV2.prototype.clearImage = function() {
  return this.setImage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.base.v1.ToMapSimpleV2.prototype.hasImage = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.ToMapInfoV2.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.ToMapInfoV2.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.ToMapInfoV2} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ToMapInfoV2.toObject = function(includeInstance, msg) {
  var f, obj = {
mapid: jspb.Message.getFieldWithDefault(msg, 1, 0),
mapname: jspb.Message.getFieldWithDefault(msg, 2, ""),
zipimage: (f = msg.getZipimage()) && proto.base.v1.NetImage.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.ToMapInfoV2}
 */
proto.base.v1.ToMapInfoV2.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.ToMapInfoV2;
  return proto.base.v1.ToMapInfoV2.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.ToMapInfoV2} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.ToMapInfoV2}
 */
proto.base.v1.ToMapInfoV2.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMapid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMapname(value);
      break;
    case 3:
      var value = new proto.base.v1.NetImage;
      reader.readMessage(value,proto.base.v1.NetImage.deserializeBinaryFromReader);
      msg.setZipimage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.ToMapInfoV2.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.ToMapInfoV2.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.ToMapInfoV2} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ToMapInfoV2.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMapid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getMapname();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getZipimage();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.base.v1.NetImage.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 mapId = 1;
 * @return {number}
 */
proto.base.v1.ToMapInfoV2.prototype.getMapid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ToMapInfoV2} returns this
 */
proto.base.v1.ToMapInfoV2.prototype.setMapid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string mapName = 2;
 * @return {string}
 */
proto.base.v1.ToMapInfoV2.prototype.getMapname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.v1.ToMapInfoV2} returns this
 */
proto.base.v1.ToMapInfoV2.prototype.setMapname = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional NetImage zipImage = 3;
 * @return {?proto.base.v1.NetImage}
 */
proto.base.v1.ToMapInfoV2.prototype.getZipimage = function() {
  return /** @type{?proto.base.v1.NetImage} */ (
    jspb.Message.getWrapperField(this, proto.base.v1.NetImage, 3));
};


/**
 * @param {?proto.base.v1.NetImage|undefined} value
 * @return {!proto.base.v1.ToMapInfoV2} returns this
*/
proto.base.v1.ToMapInfoV2.prototype.setZipimage = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.base.v1.ToMapInfoV2} returns this
 */
proto.base.v1.ToMapInfoV2.prototype.clearZipimage = function() {
  return this.setZipimage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.base.v1.ToMapInfoV2.prototype.hasZipimage = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.ToUserDetailQueryRequestV2.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.ToUserDetailQueryRequestV2.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.ToUserDetailQueryRequestV2} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ToUserDetailQueryRequestV2.toObject = function(includeInstance, msg) {
  var f, obj = {
mapid: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.ToUserDetailQueryRequestV2}
 */
proto.base.v1.ToUserDetailQueryRequestV2.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.ToUserDetailQueryRequestV2;
  return proto.base.v1.ToUserDetailQueryRequestV2.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.ToUserDetailQueryRequestV2} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.ToUserDetailQueryRequestV2}
 */
proto.base.v1.ToUserDetailQueryRequestV2.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMapid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.ToUserDetailQueryRequestV2.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.ToUserDetailQueryRequestV2.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.ToUserDetailQueryRequestV2} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ToUserDetailQueryRequestV2.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMapid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 mapId = 1;
 * @return {number}
 */
proto.base.v1.ToUserDetailQueryRequestV2.prototype.getMapid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ToUserDetailQueryRequestV2} returns this
 */
proto.base.v1.ToUserDetailQueryRequestV2.prototype.setMapid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.base.v1.ToUserDetailQueryReplyV2.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.ToUserDetailQueryReplyV2.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.ToUserDetailQueryReplyV2.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.ToUserDetailQueryReplyV2} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ToUserDetailQueryReplyV2.toObject = function(includeInstance, msg) {
  var f, obj = {
listList: jspb.Message.toObjectList(msg.getListList(),
    proto.base.v1.ToActionInfo.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.ToUserDetailQueryReplyV2}
 */
proto.base.v1.ToUserDetailQueryReplyV2.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.ToUserDetailQueryReplyV2;
  return proto.base.v1.ToUserDetailQueryReplyV2.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.ToUserDetailQueryReplyV2} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.ToUserDetailQueryReplyV2}
 */
proto.base.v1.ToUserDetailQueryReplyV2.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.base.v1.ToActionInfo;
      reader.readMessage(value,proto.base.v1.ToActionInfo.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.ToUserDetailQueryReplyV2.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.ToUserDetailQueryReplyV2.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.ToUserDetailQueryReplyV2} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ToUserDetailQueryReplyV2.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.base.v1.ToActionInfo.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ToActionInfo list = 1;
 * @return {!Array<!proto.base.v1.ToActionInfo>}
 */
proto.base.v1.ToUserDetailQueryReplyV2.prototype.getListList = function() {
  return /** @type{!Array<!proto.base.v1.ToActionInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.base.v1.ToActionInfo, 1));
};


/**
 * @param {!Array<!proto.base.v1.ToActionInfo>} value
 * @return {!proto.base.v1.ToUserDetailQueryReplyV2} returns this
*/
proto.base.v1.ToUserDetailQueryReplyV2.prototype.setListList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.base.v1.ToActionInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.base.v1.ToActionInfo}
 */
proto.base.v1.ToUserDetailQueryReplyV2.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.base.v1.ToActionInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.base.v1.ToUserDetailQueryReplyV2} returns this
 */
proto.base.v1.ToUserDetailQueryReplyV2.prototype.clearListList = function() {
  return this.setListList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.base.v1.ToActionInfo.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.ToActionInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.ToActionInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.ToActionInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ToActionInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
actid: jspb.Message.getFieldWithDefault(msg, 1, 0),
userlistList: jspb.Message.toObjectList(msg.getUserlistList(),
    proto.base.v1.ToOrienteerInGameInfo.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.ToActionInfo}
 */
proto.base.v1.ToActionInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.ToActionInfo;
  return proto.base.v1.ToActionInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.ToActionInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.ToActionInfo}
 */
proto.base.v1.ToActionInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setActid(value);
      break;
    case 4:
      var value = new proto.base.v1.ToOrienteerInGameInfo;
      reader.readMessage(value,proto.base.v1.ToOrienteerInGameInfo.deserializeBinaryFromReader);
      msg.addUserlist(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.ToActionInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.ToActionInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.ToActionInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ToActionInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getActid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getUserlistList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.base.v1.ToOrienteerInGameInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 actId = 1;
 * @return {number}
 */
proto.base.v1.ToActionInfo.prototype.getActid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ToActionInfo} returns this
 */
proto.base.v1.ToActionInfo.prototype.setActid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * repeated ToOrienteerInGameInfo userList = 4;
 * @return {!Array<!proto.base.v1.ToOrienteerInGameInfo>}
 */
proto.base.v1.ToActionInfo.prototype.getUserlistList = function() {
  return /** @type{!Array<!proto.base.v1.ToOrienteerInGameInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.base.v1.ToOrienteerInGameInfo, 4));
};


/**
 * @param {!Array<!proto.base.v1.ToOrienteerInGameInfo>} value
 * @return {!proto.base.v1.ToActionInfo} returns this
*/
proto.base.v1.ToActionInfo.prototype.setUserlistList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.base.v1.ToOrienteerInGameInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.base.v1.ToOrienteerInGameInfo}
 */
proto.base.v1.ToActionInfo.prototype.addUserlist = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.base.v1.ToOrienteerInGameInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.base.v1.ToActionInfo} returns this
 */
proto.base.v1.ToActionInfo.prototype.clearUserlistList = function() {
  return this.setUserlistList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.ToActionBasicInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.ToActionBasicInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.ToActionBasicInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ToActionBasicInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
actid: jspb.Message.getFieldWithDefault(msg, 1, 0),
actname: jspb.Message.getFieldWithDefault(msg, 2, ""),
totalcontrolnum: jspb.Message.getFieldWithDefault(msg, 3, 0),
state: jspb.Message.getFieldWithDefault(msg, 4, 0),
matchbt: jspb.Message.getFieldWithDefault(msg, 5, ""),
matchet: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.ToActionBasicInfo}
 */
proto.base.v1.ToActionBasicInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.ToActionBasicInfo;
  return proto.base.v1.ToActionBasicInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.ToActionBasicInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.ToActionBasicInfo}
 */
proto.base.v1.ToActionBasicInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setActid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setActname(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalcontrolnum(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setState(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setMatchbt(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setMatchet(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.ToActionBasicInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.ToActionBasicInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.ToActionBasicInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ToActionBasicInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getActid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getActname();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTotalcontrolnum();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getState();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getMatchbt();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getMatchet();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional int32 actId = 1;
 * @return {number}
 */
proto.base.v1.ToActionBasicInfo.prototype.getActid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ToActionBasicInfo} returns this
 */
proto.base.v1.ToActionBasicInfo.prototype.setActid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string actName = 2;
 * @return {string}
 */
proto.base.v1.ToActionBasicInfo.prototype.getActname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.v1.ToActionBasicInfo} returns this
 */
proto.base.v1.ToActionBasicInfo.prototype.setActname = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 totalControlNum = 3;
 * @return {number}
 */
proto.base.v1.ToActionBasicInfo.prototype.getTotalcontrolnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ToActionBasicInfo} returns this
 */
proto.base.v1.ToActionBasicInfo.prototype.setTotalcontrolnum = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 state = 4;
 * @return {number}
 */
proto.base.v1.ToActionBasicInfo.prototype.getState = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ToActionBasicInfo} returns this
 */
proto.base.v1.ToActionBasicInfo.prototype.setState = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string MatchBt = 5;
 * @return {string}
 */
proto.base.v1.ToActionBasicInfo.prototype.getMatchbt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.v1.ToActionBasicInfo} returns this
 */
proto.base.v1.ToActionBasicInfo.prototype.setMatchbt = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string MatchEt = 6;
 * @return {string}
 */
proto.base.v1.ToActionBasicInfo.prototype.getMatchet = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.v1.ToActionBasicInfo} returns this
 */
proto.base.v1.ToActionBasicInfo.prototype.setMatchet = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.ToOrienteerInGameInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.ToOrienteerInGameInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.ToOrienteerInGameInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ToOrienteerInGameInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
userid: jspb.Message.getFieldWithDefault(msg, 1, 0),
gpsinfo: (f = msg.getGpsinfo()) && proto.base.v1.OrienteerGpsInfo.toObject(includeInstance, f),
hrinfo: (f = msg.getHrinfo()) && proto.base.v1.OrienteerHrInfo.toObject(includeInstance, f),
gamesaveinfo: (f = msg.getGamesaveinfo()) && proto.base.v1.OrienteerGameSaveInfo.toObject(includeInstance, f),
otherinfo: (f = msg.getOtherinfo()) && proto.base.v1.OrienteerOtherInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.ToOrienteerInGameInfo}
 */
proto.base.v1.ToOrienteerInGameInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.ToOrienteerInGameInfo;
  return proto.base.v1.ToOrienteerInGameInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.ToOrienteerInGameInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.ToOrienteerInGameInfo}
 */
proto.base.v1.ToOrienteerInGameInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUserid(value);
      break;
    case 3:
      var value = new proto.base.v1.OrienteerGpsInfo;
      reader.readMessage(value,proto.base.v1.OrienteerGpsInfo.deserializeBinaryFromReader);
      msg.setGpsinfo(value);
      break;
    case 4:
      var value = new proto.base.v1.OrienteerHrInfo;
      reader.readMessage(value,proto.base.v1.OrienteerHrInfo.deserializeBinaryFromReader);
      msg.setHrinfo(value);
      break;
    case 5:
      var value = new proto.base.v1.OrienteerGameSaveInfo;
      reader.readMessage(value,proto.base.v1.OrienteerGameSaveInfo.deserializeBinaryFromReader);
      msg.setGamesaveinfo(value);
      break;
    case 7:
      var value = new proto.base.v1.OrienteerOtherInfo;
      reader.readMessage(value,proto.base.v1.OrienteerOtherInfo.deserializeBinaryFromReader);
      msg.setOtherinfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.ToOrienteerInGameInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.ToOrienteerInGameInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.ToOrienteerInGameInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ToOrienteerInGameInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getGpsinfo();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.base.v1.OrienteerGpsInfo.serializeBinaryToWriter
    );
  }
  f = message.getHrinfo();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.base.v1.OrienteerHrInfo.serializeBinaryToWriter
    );
  }
  f = message.getGamesaveinfo();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.base.v1.OrienteerGameSaveInfo.serializeBinaryToWriter
    );
  }
  f = message.getOtherinfo();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.base.v1.OrienteerOtherInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 UserId = 1;
 * @return {number}
 */
proto.base.v1.ToOrienteerInGameInfo.prototype.getUserid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ToOrienteerInGameInfo} returns this
 */
proto.base.v1.ToOrienteerInGameInfo.prototype.setUserid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional OrienteerGpsInfo gpsInfo = 3;
 * @return {?proto.base.v1.OrienteerGpsInfo}
 */
proto.base.v1.ToOrienteerInGameInfo.prototype.getGpsinfo = function() {
  return /** @type{?proto.base.v1.OrienteerGpsInfo} */ (
    jspb.Message.getWrapperField(this, proto.base.v1.OrienteerGpsInfo, 3));
};


/**
 * @param {?proto.base.v1.OrienteerGpsInfo|undefined} value
 * @return {!proto.base.v1.ToOrienteerInGameInfo} returns this
*/
proto.base.v1.ToOrienteerInGameInfo.prototype.setGpsinfo = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.base.v1.ToOrienteerInGameInfo} returns this
 */
proto.base.v1.ToOrienteerInGameInfo.prototype.clearGpsinfo = function() {
  return this.setGpsinfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.base.v1.ToOrienteerInGameInfo.prototype.hasGpsinfo = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional OrienteerHrInfo hrInfo = 4;
 * @return {?proto.base.v1.OrienteerHrInfo}
 */
proto.base.v1.ToOrienteerInGameInfo.prototype.getHrinfo = function() {
  return /** @type{?proto.base.v1.OrienteerHrInfo} */ (
    jspb.Message.getWrapperField(this, proto.base.v1.OrienteerHrInfo, 4));
};


/**
 * @param {?proto.base.v1.OrienteerHrInfo|undefined} value
 * @return {!proto.base.v1.ToOrienteerInGameInfo} returns this
*/
proto.base.v1.ToOrienteerInGameInfo.prototype.setHrinfo = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.base.v1.ToOrienteerInGameInfo} returns this
 */
proto.base.v1.ToOrienteerInGameInfo.prototype.clearHrinfo = function() {
  return this.setHrinfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.base.v1.ToOrienteerInGameInfo.prototype.hasHrinfo = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional OrienteerGameSaveInfo gameSaveInfo = 5;
 * @return {?proto.base.v1.OrienteerGameSaveInfo}
 */
proto.base.v1.ToOrienteerInGameInfo.prototype.getGamesaveinfo = function() {
  return /** @type{?proto.base.v1.OrienteerGameSaveInfo} */ (
    jspb.Message.getWrapperField(this, proto.base.v1.OrienteerGameSaveInfo, 5));
};


/**
 * @param {?proto.base.v1.OrienteerGameSaveInfo|undefined} value
 * @return {!proto.base.v1.ToOrienteerInGameInfo} returns this
*/
proto.base.v1.ToOrienteerInGameInfo.prototype.setGamesaveinfo = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.base.v1.ToOrienteerInGameInfo} returns this
 */
proto.base.v1.ToOrienteerInGameInfo.prototype.clearGamesaveinfo = function() {
  return this.setGamesaveinfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.base.v1.ToOrienteerInGameInfo.prototype.hasGamesaveinfo = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional OrienteerOtherInfo otherInfo = 7;
 * @return {?proto.base.v1.OrienteerOtherInfo}
 */
proto.base.v1.ToOrienteerInGameInfo.prototype.getOtherinfo = function() {
  return /** @type{?proto.base.v1.OrienteerOtherInfo} */ (
    jspb.Message.getWrapperField(this, proto.base.v1.OrienteerOtherInfo, 7));
};


/**
 * @param {?proto.base.v1.OrienteerOtherInfo|undefined} value
 * @return {!proto.base.v1.ToOrienteerInGameInfo} returns this
*/
proto.base.v1.ToOrienteerInGameInfo.prototype.setOtherinfo = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.base.v1.ToOrienteerInGameInfo} returns this
 */
proto.base.v1.ToOrienteerInGameInfo.prototype.clearOtherinfo = function() {
  return this.setOtherinfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.base.v1.ToOrienteerInGameInfo.prototype.hasOtherinfo = function() {
  return jspb.Message.getField(this, 7) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.ToUserInActionBasicInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.ToUserInActionBasicInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.ToUserInActionBasicInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ToUserInActionBasicInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
userid: jspb.Message.getFieldWithDefault(msg, 1, 0),
baseinfo: (f = msg.getBaseinfo()) && proto.base.v1.OrienteerBaseInfo.toObject(includeInstance, f),
coursebaseinfo: (f = msg.getCoursebaseinfo()) && proto.base.v1.CourseBaseInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.ToUserInActionBasicInfo}
 */
proto.base.v1.ToUserInActionBasicInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.ToUserInActionBasicInfo;
  return proto.base.v1.ToUserInActionBasicInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.ToUserInActionBasicInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.ToUserInActionBasicInfo}
 */
proto.base.v1.ToUserInActionBasicInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUserid(value);
      break;
    case 2:
      var value = new proto.base.v1.OrienteerBaseInfo;
      reader.readMessage(value,proto.base.v1.OrienteerBaseInfo.deserializeBinaryFromReader);
      msg.setBaseinfo(value);
      break;
    case 6:
      var value = new proto.base.v1.CourseBaseInfo;
      reader.readMessage(value,proto.base.v1.CourseBaseInfo.deserializeBinaryFromReader);
      msg.setCoursebaseinfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.ToUserInActionBasicInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.ToUserInActionBasicInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.ToUserInActionBasicInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ToUserInActionBasicInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getBaseinfo();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.base.v1.OrienteerBaseInfo.serializeBinaryToWriter
    );
  }
  f = message.getCoursebaseinfo();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.base.v1.CourseBaseInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 UserId = 1;
 * @return {number}
 */
proto.base.v1.ToUserInActionBasicInfo.prototype.getUserid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ToUserInActionBasicInfo} returns this
 */
proto.base.v1.ToUserInActionBasicInfo.prototype.setUserid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional OrienteerBaseInfo baseInfo = 2;
 * @return {?proto.base.v1.OrienteerBaseInfo}
 */
proto.base.v1.ToUserInActionBasicInfo.prototype.getBaseinfo = function() {
  return /** @type{?proto.base.v1.OrienteerBaseInfo} */ (
    jspb.Message.getWrapperField(this, proto.base.v1.OrienteerBaseInfo, 2));
};


/**
 * @param {?proto.base.v1.OrienteerBaseInfo|undefined} value
 * @return {!proto.base.v1.ToUserInActionBasicInfo} returns this
*/
proto.base.v1.ToUserInActionBasicInfo.prototype.setBaseinfo = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.base.v1.ToUserInActionBasicInfo} returns this
 */
proto.base.v1.ToUserInActionBasicInfo.prototype.clearBaseinfo = function() {
  return this.setBaseinfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.base.v1.ToUserInActionBasicInfo.prototype.hasBaseinfo = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional CourseBaseInfo courseBaseInfo = 6;
 * @return {?proto.base.v1.CourseBaseInfo}
 */
proto.base.v1.ToUserInActionBasicInfo.prototype.getCoursebaseinfo = function() {
  return /** @type{?proto.base.v1.CourseBaseInfo} */ (
    jspb.Message.getWrapperField(this, proto.base.v1.CourseBaseInfo, 6));
};


/**
 * @param {?proto.base.v1.CourseBaseInfo|undefined} value
 * @return {!proto.base.v1.ToUserInActionBasicInfo} returns this
*/
proto.base.v1.ToUserInActionBasicInfo.prototype.setCoursebaseinfo = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.base.v1.ToUserInActionBasicInfo} returns this
 */
proto.base.v1.ToUserInActionBasicInfo.prototype.clearCoursebaseinfo = function() {
  return this.setCoursebaseinfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.base.v1.ToUserInActionBasicInfo.prototype.hasCoursebaseinfo = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.OrienteerBaseInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.OrienteerBaseInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.OrienteerBaseInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.OrienteerBaseInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
name: jspb.Message.getFieldWithDefault(msg, 1, ""),
phone: jspb.Message.getFieldWithDefault(msg, 2, ""),
headurl: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.OrienteerBaseInfo}
 */
proto.base.v1.OrienteerBaseInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.OrienteerBaseInfo;
  return proto.base.v1.OrienteerBaseInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.OrienteerBaseInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.OrienteerBaseInfo}
 */
proto.base.v1.OrienteerBaseInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhone(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setHeadurl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.OrienteerBaseInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.OrienteerBaseInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.OrienteerBaseInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.OrienteerBaseInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPhone();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getHeadurl();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string Name = 1;
 * @return {string}
 */
proto.base.v1.OrienteerBaseInfo.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.v1.OrienteerBaseInfo} returns this
 */
proto.base.v1.OrienteerBaseInfo.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string Phone = 2;
 * @return {string}
 */
proto.base.v1.OrienteerBaseInfo.prototype.getPhone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.v1.OrienteerBaseInfo} returns this
 */
proto.base.v1.OrienteerBaseInfo.prototype.setPhone = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string HeadUrl = 3;
 * @return {string}
 */
proto.base.v1.OrienteerBaseInfo.prototype.getHeadurl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.v1.OrienteerBaseInfo} returns this
 */
proto.base.v1.OrienteerBaseInfo.prototype.setHeadurl = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.base.v1.OrienteerGpsInfo.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.OrienteerGpsInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.OrienteerGpsInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.OrienteerGpsInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.OrienteerGpsInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
gamegpsinfosList: jspb.Message.toObjectList(msg.getGamegpsinfosList(),
    proto.base.v1.GameGpsInfo.toObject, includeInstance),
distance: jspb.Message.getFieldWithDefault(msg, 2, 0),
pace: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.OrienteerGpsInfo}
 */
proto.base.v1.OrienteerGpsInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.OrienteerGpsInfo;
  return proto.base.v1.OrienteerGpsInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.OrienteerGpsInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.OrienteerGpsInfo}
 */
proto.base.v1.OrienteerGpsInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.base.v1.GameGpsInfo;
      reader.readMessage(value,proto.base.v1.GameGpsInfo.deserializeBinaryFromReader);
      msg.addGamegpsinfos(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDistance(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPace(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.OrienteerGpsInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.OrienteerGpsInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.OrienteerGpsInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.OrienteerGpsInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGamegpsinfosList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.base.v1.GameGpsInfo.serializeBinaryToWriter
    );
  }
  f = message.getDistance();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getPace();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * repeated GameGpsInfo gameGpsInfos = 1;
 * @return {!Array<!proto.base.v1.GameGpsInfo>}
 */
proto.base.v1.OrienteerGpsInfo.prototype.getGamegpsinfosList = function() {
  return /** @type{!Array<!proto.base.v1.GameGpsInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.base.v1.GameGpsInfo, 1));
};


/**
 * @param {!Array<!proto.base.v1.GameGpsInfo>} value
 * @return {!proto.base.v1.OrienteerGpsInfo} returns this
*/
proto.base.v1.OrienteerGpsInfo.prototype.setGamegpsinfosList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.base.v1.GameGpsInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.base.v1.GameGpsInfo}
 */
proto.base.v1.OrienteerGpsInfo.prototype.addGamegpsinfos = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.base.v1.GameGpsInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.base.v1.OrienteerGpsInfo} returns this
 */
proto.base.v1.OrienteerGpsInfo.prototype.clearGamegpsinfosList = function() {
  return this.setGamegpsinfosList([]);
};


/**
 * optional int32 Distance = 2;
 * @return {number}
 */
proto.base.v1.OrienteerGpsInfo.prototype.getDistance = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.OrienteerGpsInfo} returns this
 */
proto.base.v1.OrienteerGpsInfo.prototype.setDistance = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 Pace = 3;
 * @return {number}
 */
proto.base.v1.OrienteerGpsInfo.prototype.getPace = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.OrienteerGpsInfo} returns this
 */
proto.base.v1.OrienteerGpsInfo.prototype.setPace = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.base.v1.OrienteerHrInfo.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.OrienteerHrInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.OrienteerHrInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.OrienteerHrInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.OrienteerHrInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
hrinfoList: jspb.Message.toObjectList(msg.getHrinfoList(),
    proto.base.v1.HeartRate.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.OrienteerHrInfo}
 */
proto.base.v1.OrienteerHrInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.OrienteerHrInfo;
  return proto.base.v1.OrienteerHrInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.OrienteerHrInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.OrienteerHrInfo}
 */
proto.base.v1.OrienteerHrInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.base.v1.HeartRate;
      reader.readMessage(value,proto.base.v1.HeartRate.deserializeBinaryFromReader);
      msg.addHrinfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.OrienteerHrInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.OrienteerHrInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.OrienteerHrInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.OrienteerHrInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHrinfoList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.base.v1.HeartRate.serializeBinaryToWriter
    );
  }
};


/**
 * repeated HeartRate hrInfo = 1;
 * @return {!Array<!proto.base.v1.HeartRate>}
 */
proto.base.v1.OrienteerHrInfo.prototype.getHrinfoList = function() {
  return /** @type{!Array<!proto.base.v1.HeartRate>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.base.v1.HeartRate, 1));
};


/**
 * @param {!Array<!proto.base.v1.HeartRate>} value
 * @return {!proto.base.v1.OrienteerHrInfo} returns this
*/
proto.base.v1.OrienteerHrInfo.prototype.setHrinfoList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.base.v1.HeartRate=} opt_value
 * @param {number=} opt_index
 * @return {!proto.base.v1.HeartRate}
 */
proto.base.v1.OrienteerHrInfo.prototype.addHrinfo = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.base.v1.HeartRate, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.base.v1.OrienteerHrInfo} returns this
 */
proto.base.v1.OrienteerHrInfo.prototype.clearHrinfoList = function() {
  return this.setHrinfoList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.OrienteerOtherInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.OrienteerOtherInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.OrienteerOtherInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.OrienteerOtherInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
stepnum: jspb.Message.getFieldWithDefault(msg, 1, 0),
heartratepercent: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.OrienteerOtherInfo}
 */
proto.base.v1.OrienteerOtherInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.OrienteerOtherInfo;
  return proto.base.v1.OrienteerOtherInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.OrienteerOtherInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.OrienteerOtherInfo}
 */
proto.base.v1.OrienteerOtherInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setStepnum(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setHeartratepercent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.OrienteerOtherInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.OrienteerOtherInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.OrienteerOtherInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.OrienteerOtherInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStepnum();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getHeartratepercent();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional int32 StepNum = 1;
 * @return {number}
 */
proto.base.v1.OrienteerOtherInfo.prototype.getStepnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.OrienteerOtherInfo} returns this
 */
proto.base.v1.OrienteerOtherInfo.prototype.setStepnum = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 HeartRatePercent = 2;
 * @return {number}
 */
proto.base.v1.OrienteerOtherInfo.prototype.getHeartratepercent = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.OrienteerOtherInfo} returns this
 */
proto.base.v1.OrienteerOtherInfo.prototype.setHeartratepercent = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.base.v1.CourseBaseInfo.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.CourseBaseInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.CourseBaseInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.CourseBaseInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.CourseBaseInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
courseid: jspb.Message.getFieldWithDefault(msg, 1, 0),
coursename: jspb.Message.getFieldWithDefault(msg, 2, ""),
controlpointsortedlistList: jspb.Message.toObjectList(msg.getControlpointsortedlistList(),
    proto.base.v1.ToControlPoint.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.CourseBaseInfo}
 */
proto.base.v1.CourseBaseInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.CourseBaseInfo;
  return proto.base.v1.CourseBaseInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.CourseBaseInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.CourseBaseInfo}
 */
proto.base.v1.CourseBaseInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCourseid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCoursename(value);
      break;
    case 3:
      var value = new proto.base.v1.ToControlPoint;
      reader.readMessage(value,proto.base.v1.ToControlPoint.deserializeBinaryFromReader);
      msg.addControlpointsortedlist(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.CourseBaseInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.CourseBaseInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.CourseBaseInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.CourseBaseInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCourseid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getCoursename();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getControlpointsortedlistList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.base.v1.ToControlPoint.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 CourseId = 1;
 * @return {number}
 */
proto.base.v1.CourseBaseInfo.prototype.getCourseid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.CourseBaseInfo} returns this
 */
proto.base.v1.CourseBaseInfo.prototype.setCourseid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string CourseName = 2;
 * @return {string}
 */
proto.base.v1.CourseBaseInfo.prototype.getCoursename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.v1.CourseBaseInfo} returns this
 */
proto.base.v1.CourseBaseInfo.prototype.setCoursename = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated ToControlPoint controlPointSortedList = 3;
 * @return {!Array<!proto.base.v1.ToControlPoint>}
 */
proto.base.v1.CourseBaseInfo.prototype.getControlpointsortedlistList = function() {
  return /** @type{!Array<!proto.base.v1.ToControlPoint>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.base.v1.ToControlPoint, 3));
};


/**
 * @param {!Array<!proto.base.v1.ToControlPoint>} value
 * @return {!proto.base.v1.CourseBaseInfo} returns this
*/
proto.base.v1.CourseBaseInfo.prototype.setControlpointsortedlistList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.base.v1.ToControlPoint=} opt_value
 * @param {number=} opt_index
 * @return {!proto.base.v1.ToControlPoint}
 */
proto.base.v1.CourseBaseInfo.prototype.addControlpointsortedlist = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.base.v1.ToControlPoint, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.base.v1.CourseBaseInfo} returns this
 */
proto.base.v1.CourseBaseInfo.prototype.clearControlpointsortedlistList = function() {
  return this.setControlpointsortedlistList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.CourseBase.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.CourseBase.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.CourseBase} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.CourseBase.toObject = function(includeInstance, msg) {
  var f, obj = {
cid: jspb.Message.getFieldWithDefault(msg, 1, 0),
cname: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.CourseBase}
 */
proto.base.v1.CourseBase.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.CourseBase;
  return proto.base.v1.CourseBase.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.CourseBase} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.CourseBase}
 */
proto.base.v1.CourseBase.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCname(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.CourseBase.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.CourseBase.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.CourseBase} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.CourseBase.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getCname();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int32 cId = 1;
 * @return {number}
 */
proto.base.v1.CourseBase.prototype.getCid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.CourseBase} returns this
 */
proto.base.v1.CourseBase.prototype.setCid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string cName = 2;
 * @return {string}
 */
proto.base.v1.CourseBase.prototype.getCname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.v1.CourseBase} returns this
 */
proto.base.v1.CourseBase.prototype.setCname = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.ToControlPoint.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.ToControlPoint.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.ToControlPoint} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ToControlPoint.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
sn: jspb.Message.getFieldWithDefault(msg, 2, ""),
ciposition: (f = msg.getCiposition()) && proto.base.v1.Position.toObject(includeInstance, f),
ctype: jspb.Message.getFieldWithDefault(msg, 4, 0),
orderno: jspb.Message.getFieldWithDefault(msg, 5, 0),
isCheckSuccess: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
checkAfterLast: (f = msg.getCheckAfterLast()) && google_protobuf_duration_pb.Duration.toObject(includeInstance, f),
punchtime: (f = msg.getPunchtime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
disafterlast: jspb.Message.getFieldWithDefault(msg, 9, 0),
disstraightafterlast: jspb.Message.getFieldWithDefault(msg, 10, 0),
paceafterlast: jspb.Message.getFieldWithDefault(msg, 11, 0),
paceafterstart: jspb.Message.getFieldWithDefault(msg, 12, 0),
checkAfterStart: (f = msg.getCheckAfterStart()) && google_protobuf_duration_pb.Duration.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.ToControlPoint}
 */
proto.base.v1.ToControlPoint.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.ToControlPoint;
  return proto.base.v1.ToControlPoint.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.ToControlPoint} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.ToControlPoint}
 */
proto.base.v1.ToControlPoint.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSn(value);
      break;
    case 3:
      var value = new proto.base.v1.Position;
      reader.readMessage(value,proto.base.v1.Position.deserializeBinaryFromReader);
      msg.setCiposition(value);
      break;
    case 4:
      var value = /** @type {!proto.base.v1.CType} */ (reader.readEnum());
      msg.setCtype(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOrderno(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsCheckSuccess(value);
      break;
    case 7:
      var value = new google_protobuf_duration_pb.Duration;
      reader.readMessage(value,google_protobuf_duration_pb.Duration.deserializeBinaryFromReader);
      msg.setCheckAfterLast(value);
      break;
    case 8:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setPunchtime(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDisafterlast(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDisstraightafterlast(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPaceafterlast(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPaceafterstart(value);
      break;
    case 13:
      var value = new google_protobuf_duration_pb.Duration;
      reader.readMessage(value,google_protobuf_duration_pb.Duration.deserializeBinaryFromReader);
      msg.setCheckAfterStart(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.ToControlPoint.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.ToControlPoint.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.ToControlPoint} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ToControlPoint.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getSn();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCiposition();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.base.v1.Position.serializeBinaryToWriter
    );
  }
  f = message.getCtype();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getOrderno();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getIsCheckSuccess();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getCheckAfterLast();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_duration_pb.Duration.serializeBinaryToWriter
    );
  }
  f = message.getPunchtime();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getDisafterlast();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getDisstraightafterlast();
  if (f !== 0) {
    writer.writeInt32(
      10,
      f
    );
  }
  f = message.getPaceafterlast();
  if (f !== 0) {
    writer.writeInt32(
      11,
      f
    );
  }
  f = message.getPaceafterstart();
  if (f !== 0) {
    writer.writeInt32(
      12,
      f
    );
  }
  f = message.getCheckAfterStart();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      google_protobuf_duration_pb.Duration.serializeBinaryToWriter
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.base.v1.ToControlPoint.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ToControlPoint} returns this
 */
proto.base.v1.ToControlPoint.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string sn = 2;
 * @return {string}
 */
proto.base.v1.ToControlPoint.prototype.getSn = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.v1.ToControlPoint} returns this
 */
proto.base.v1.ToControlPoint.prototype.setSn = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional Position ciPosition = 3;
 * @return {?proto.base.v1.Position}
 */
proto.base.v1.ToControlPoint.prototype.getCiposition = function() {
  return /** @type{?proto.base.v1.Position} */ (
    jspb.Message.getWrapperField(this, proto.base.v1.Position, 3));
};


/**
 * @param {?proto.base.v1.Position|undefined} value
 * @return {!proto.base.v1.ToControlPoint} returns this
*/
proto.base.v1.ToControlPoint.prototype.setCiposition = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.base.v1.ToControlPoint} returns this
 */
proto.base.v1.ToControlPoint.prototype.clearCiposition = function() {
  return this.setCiposition(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.base.v1.ToControlPoint.prototype.hasCiposition = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional CType cType = 4;
 * @return {!proto.base.v1.CType}
 */
proto.base.v1.ToControlPoint.prototype.getCtype = function() {
  return /** @type {!proto.base.v1.CType} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.base.v1.CType} value
 * @return {!proto.base.v1.ToControlPoint} returns this
 */
proto.base.v1.ToControlPoint.prototype.setCtype = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional int32 orderNo = 5;
 * @return {number}
 */
proto.base.v1.ToControlPoint.prototype.getOrderno = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ToControlPoint} returns this
 */
proto.base.v1.ToControlPoint.prototype.setOrderno = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional bool is_check_success = 6;
 * @return {boolean}
 */
proto.base.v1.ToControlPoint.prototype.getIsCheckSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.base.v1.ToControlPoint} returns this
 */
proto.base.v1.ToControlPoint.prototype.setIsCheckSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional google.protobuf.Duration check_after_last = 7;
 * @return {?proto.google.protobuf.Duration}
 */
proto.base.v1.ToControlPoint.prototype.getCheckAfterLast = function() {
  return /** @type{?proto.google.protobuf.Duration} */ (
    jspb.Message.getWrapperField(this, google_protobuf_duration_pb.Duration, 7));
};


/**
 * @param {?proto.google.protobuf.Duration|undefined} value
 * @return {!proto.base.v1.ToControlPoint} returns this
*/
proto.base.v1.ToControlPoint.prototype.setCheckAfterLast = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.base.v1.ToControlPoint} returns this
 */
proto.base.v1.ToControlPoint.prototype.clearCheckAfterLast = function() {
  return this.setCheckAfterLast(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.base.v1.ToControlPoint.prototype.hasCheckAfterLast = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional google.protobuf.Timestamp punchTime = 8;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.base.v1.ToControlPoint.prototype.getPunchtime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 8));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.base.v1.ToControlPoint} returns this
*/
proto.base.v1.ToControlPoint.prototype.setPunchtime = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.base.v1.ToControlPoint} returns this
 */
proto.base.v1.ToControlPoint.prototype.clearPunchtime = function() {
  return this.setPunchtime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.base.v1.ToControlPoint.prototype.hasPunchtime = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional int32 disAfterLast = 9;
 * @return {number}
 */
proto.base.v1.ToControlPoint.prototype.getDisafterlast = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ToControlPoint} returns this
 */
proto.base.v1.ToControlPoint.prototype.setDisafterlast = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int32 disStraightAfterLast = 10;
 * @return {number}
 */
proto.base.v1.ToControlPoint.prototype.getDisstraightafterlast = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ToControlPoint} returns this
 */
proto.base.v1.ToControlPoint.prototype.setDisstraightafterlast = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional int32 paceAfterLast = 11;
 * @return {number}
 */
proto.base.v1.ToControlPoint.prototype.getPaceafterlast = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ToControlPoint} returns this
 */
proto.base.v1.ToControlPoint.prototype.setPaceafterlast = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional int32 paceAfterStart = 12;
 * @return {number}
 */
proto.base.v1.ToControlPoint.prototype.getPaceafterstart = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ToControlPoint} returns this
 */
proto.base.v1.ToControlPoint.prototype.setPaceafterstart = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional google.protobuf.Duration check_after_start = 13;
 * @return {?proto.google.protobuf.Duration}
 */
proto.base.v1.ToControlPoint.prototype.getCheckAfterStart = function() {
  return /** @type{?proto.google.protobuf.Duration} */ (
    jspb.Message.getWrapperField(this, google_protobuf_duration_pb.Duration, 13));
};


/**
 * @param {?proto.google.protobuf.Duration|undefined} value
 * @return {!proto.base.v1.ToControlPoint} returns this
*/
proto.base.v1.ToControlPoint.prototype.setCheckAfterStart = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.base.v1.ToControlPoint} returns this
 */
proto.base.v1.ToControlPoint.prototype.clearCheckAfterStart = function() {
  return this.setCheckAfterStart(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.base.v1.ToControlPoint.prototype.hasCheckAfterStart = function() {
  return jspb.Message.getField(this, 13) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.base.v1.OrienteerGameSaveInfo.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.OrienteerGameSaveInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.OrienteerGameSaveInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.OrienteerGameSaveInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.OrienteerGameSaveInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
startAt: (f = msg.getStartAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
duration: (f = msg.getDuration()) && google_protobuf_duration_pb.Duration.toObject(includeInstance, f),
nextcontrolpoint: (f = msg.getNextcontrolpoint()) && proto.base.v1.GameArriveControlPoint.toObject(includeInstance, f),
checkedSortedListList: jspb.Message.toObjectList(msg.getCheckedSortedListList(),
    proto.base.v1.OrienteerGameSaveControlPoint.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.OrienteerGameSaveInfo}
 */
proto.base.v1.OrienteerGameSaveInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.OrienteerGameSaveInfo;
  return proto.base.v1.OrienteerGameSaveInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.OrienteerGameSaveInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.OrienteerGameSaveInfo}
 */
proto.base.v1.OrienteerGameSaveInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setStartAt(value);
      break;
    case 2:
      var value = new google_protobuf_duration_pb.Duration;
      reader.readMessage(value,google_protobuf_duration_pb.Duration.deserializeBinaryFromReader);
      msg.setDuration(value);
      break;
    case 3:
      var value = new proto.base.v1.GameArriveControlPoint;
      reader.readMessage(value,proto.base.v1.GameArriveControlPoint.deserializeBinaryFromReader);
      msg.setNextcontrolpoint(value);
      break;
    case 4:
      var value = new proto.base.v1.OrienteerGameSaveControlPoint;
      reader.readMessage(value,proto.base.v1.OrienteerGameSaveControlPoint.deserializeBinaryFromReader);
      msg.addCheckedSortedList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.OrienteerGameSaveInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.OrienteerGameSaveInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.OrienteerGameSaveInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.OrienteerGameSaveInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStartAt();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getDuration();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_duration_pb.Duration.serializeBinaryToWriter
    );
  }
  f = message.getNextcontrolpoint();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.base.v1.GameArriveControlPoint.serializeBinaryToWriter
    );
  }
  f = message.getCheckedSortedListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.base.v1.OrienteerGameSaveControlPoint.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Timestamp start_at = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.base.v1.OrienteerGameSaveInfo.prototype.getStartAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.base.v1.OrienteerGameSaveInfo} returns this
*/
proto.base.v1.OrienteerGameSaveInfo.prototype.setStartAt = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.base.v1.OrienteerGameSaveInfo} returns this
 */
proto.base.v1.OrienteerGameSaveInfo.prototype.clearStartAt = function() {
  return this.setStartAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.base.v1.OrienteerGameSaveInfo.prototype.hasStartAt = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.Duration duration = 2;
 * @return {?proto.google.protobuf.Duration}
 */
proto.base.v1.OrienteerGameSaveInfo.prototype.getDuration = function() {
  return /** @type{?proto.google.protobuf.Duration} */ (
    jspb.Message.getWrapperField(this, google_protobuf_duration_pb.Duration, 2));
};


/**
 * @param {?proto.google.protobuf.Duration|undefined} value
 * @return {!proto.base.v1.OrienteerGameSaveInfo} returns this
*/
proto.base.v1.OrienteerGameSaveInfo.prototype.setDuration = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.base.v1.OrienteerGameSaveInfo} returns this
 */
proto.base.v1.OrienteerGameSaveInfo.prototype.clearDuration = function() {
  return this.setDuration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.base.v1.OrienteerGameSaveInfo.prototype.hasDuration = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional GameArriveControlPoint nextControlPoint = 3;
 * @return {?proto.base.v1.GameArriveControlPoint}
 */
proto.base.v1.OrienteerGameSaveInfo.prototype.getNextcontrolpoint = function() {
  return /** @type{?proto.base.v1.GameArriveControlPoint} */ (
    jspb.Message.getWrapperField(this, proto.base.v1.GameArriveControlPoint, 3));
};


/**
 * @param {?proto.base.v1.GameArriveControlPoint|undefined} value
 * @return {!proto.base.v1.OrienteerGameSaveInfo} returns this
*/
proto.base.v1.OrienteerGameSaveInfo.prototype.setNextcontrolpoint = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.base.v1.OrienteerGameSaveInfo} returns this
 */
proto.base.v1.OrienteerGameSaveInfo.prototype.clearNextcontrolpoint = function() {
  return this.setNextcontrolpoint(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.base.v1.OrienteerGameSaveInfo.prototype.hasNextcontrolpoint = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * repeated OrienteerGameSaveControlPoint checked_sorted_list = 4;
 * @return {!Array<!proto.base.v1.OrienteerGameSaveControlPoint>}
 */
proto.base.v1.OrienteerGameSaveInfo.prototype.getCheckedSortedListList = function() {
  return /** @type{!Array<!proto.base.v1.OrienteerGameSaveControlPoint>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.base.v1.OrienteerGameSaveControlPoint, 4));
};


/**
 * @param {!Array<!proto.base.v1.OrienteerGameSaveControlPoint>} value
 * @return {!proto.base.v1.OrienteerGameSaveInfo} returns this
*/
proto.base.v1.OrienteerGameSaveInfo.prototype.setCheckedSortedListList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.base.v1.OrienteerGameSaveControlPoint=} opt_value
 * @param {number=} opt_index
 * @return {!proto.base.v1.OrienteerGameSaveControlPoint}
 */
proto.base.v1.OrienteerGameSaveInfo.prototype.addCheckedSortedList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.base.v1.OrienteerGameSaveControlPoint, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.base.v1.OrienteerGameSaveInfo} returns this
 */
proto.base.v1.OrienteerGameSaveInfo.prototype.clearCheckedSortedListList = function() {
  return this.setCheckedSortedListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.OrienteerGameSaveControlPoint.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.OrienteerGameSaveControlPoint.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.OrienteerGameSaveControlPoint} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.OrienteerGameSaveControlPoint.toObject = function(includeInstance, msg) {
  var f, obj = {
controlPointId: jspb.Message.getFieldWithDefault(msg, 1, 0),
isCheckSuccess: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
checkAfterStart: (f = msg.getCheckAfterStart()) && google_protobuf_duration_pb.Duration.toObject(includeInstance, f),
distinctAfterStart: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
longitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
latitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
altitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.OrienteerGameSaveControlPoint}
 */
proto.base.v1.OrienteerGameSaveControlPoint.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.OrienteerGameSaveControlPoint;
  return proto.base.v1.OrienteerGameSaveControlPoint.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.OrienteerGameSaveControlPoint} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.OrienteerGameSaveControlPoint}
 */
proto.base.v1.OrienteerGameSaveControlPoint.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setControlPointId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsCheckSuccess(value);
      break;
    case 3:
      var value = new google_protobuf_duration_pb.Duration;
      reader.readMessage(value,google_protobuf_duration_pb.Duration.deserializeBinaryFromReader);
      msg.setCheckAfterStart(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setDistinctAfterStart(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLongitude(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLatitude(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAltitude(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.OrienteerGameSaveControlPoint.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.OrienteerGameSaveControlPoint.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.OrienteerGameSaveControlPoint} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.OrienteerGameSaveControlPoint.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getControlPointId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getIsCheckSuccess();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getCheckAfterStart();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_duration_pb.Duration.serializeBinaryToWriter
    );
  }
  f = message.getDistinctAfterStart();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getLongitude();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getLatitude();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
  f = message.getAltitude();
  if (f !== 0.0) {
    writer.writeDouble(
      7,
      f
    );
  }
};


/**
 * optional int64 control_point_id = 1;
 * @return {number}
 */
proto.base.v1.OrienteerGameSaveControlPoint.prototype.getControlPointId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.OrienteerGameSaveControlPoint} returns this
 */
proto.base.v1.OrienteerGameSaveControlPoint.prototype.setControlPointId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool is_check_success = 2;
 * @return {boolean}
 */
proto.base.v1.OrienteerGameSaveControlPoint.prototype.getIsCheckSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.base.v1.OrienteerGameSaveControlPoint} returns this
 */
proto.base.v1.OrienteerGameSaveControlPoint.prototype.setIsCheckSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional google.protobuf.Duration check_after_start = 3;
 * @return {?proto.google.protobuf.Duration}
 */
proto.base.v1.OrienteerGameSaveControlPoint.prototype.getCheckAfterStart = function() {
  return /** @type{?proto.google.protobuf.Duration} */ (
    jspb.Message.getWrapperField(this, google_protobuf_duration_pb.Duration, 3));
};


/**
 * @param {?proto.google.protobuf.Duration|undefined} value
 * @return {!proto.base.v1.OrienteerGameSaveControlPoint} returns this
*/
proto.base.v1.OrienteerGameSaveControlPoint.prototype.setCheckAfterStart = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.base.v1.OrienteerGameSaveControlPoint} returns this
 */
proto.base.v1.OrienteerGameSaveControlPoint.prototype.clearCheckAfterStart = function() {
  return this.setCheckAfterStart(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.base.v1.OrienteerGameSaveControlPoint.prototype.hasCheckAfterStart = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional double distinct_after_start = 4;
 * @return {number}
 */
proto.base.v1.OrienteerGameSaveControlPoint.prototype.getDistinctAfterStart = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.OrienteerGameSaveControlPoint} returns this
 */
proto.base.v1.OrienteerGameSaveControlPoint.prototype.setDistinctAfterStart = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional double longitude = 5;
 * @return {number}
 */
proto.base.v1.OrienteerGameSaveControlPoint.prototype.getLongitude = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.OrienteerGameSaveControlPoint} returns this
 */
proto.base.v1.OrienteerGameSaveControlPoint.prototype.setLongitude = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional double latitude = 6;
 * @return {number}
 */
proto.base.v1.OrienteerGameSaveControlPoint.prototype.getLatitude = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.OrienteerGameSaveControlPoint} returns this
 */
proto.base.v1.OrienteerGameSaveControlPoint.prototype.setLatitude = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional double altitude = 7;
 * @return {number}
 */
proto.base.v1.OrienteerGameSaveControlPoint.prototype.getAltitude = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.OrienteerGameSaveControlPoint} returns this
 */
proto.base.v1.OrienteerGameSaveControlPoint.prototype.setAltitude = function(value) {
  return jspb.Message.setProto3FloatField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.Achievement.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.Achievement.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.Achievement} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.Achievement.toObject = function(includeInstance, msg) {
  var f, obj = {
aiid: jspb.Message.getFieldWithDefault(msg, 1, 0),
ainame: jspb.Message.getFieldWithDefault(msg, 2, ""),
iconurl: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.Achievement}
 */
proto.base.v1.Achievement.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.Achievement;
  return proto.base.v1.Achievement.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.Achievement} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.Achievement}
 */
proto.base.v1.Achievement.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAiid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAiname(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setIconurl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.Achievement.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.Achievement.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.Achievement} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.Achievement.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAiid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getAiname();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getIconurl();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional int32 aiId = 1;
 * @return {number}
 */
proto.base.v1.Achievement.prototype.getAiid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.Achievement} returns this
 */
proto.base.v1.Achievement.prototype.setAiid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string aiName = 2;
 * @return {string}
 */
proto.base.v1.Achievement.prototype.getAiname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.v1.Achievement} returns this
 */
proto.base.v1.Achievement.prototype.setAiname = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string iconUrl = 3;
 * @return {string}
 */
proto.base.v1.Achievement.prototype.getIconurl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.v1.Achievement} returns this
 */
proto.base.v1.Achievement.prototype.setIconurl = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.base.v1.ToMapListReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.ToMapListReply.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.ToMapListReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.ToMapListReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ToMapListReply.toObject = function(includeInstance, msg) {
  var f, obj = {
listList: jspb.Message.toObjectList(msg.getListList(),
    proto.base.v1.ToMapSimple.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.ToMapListReply}
 */
proto.base.v1.ToMapListReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.ToMapListReply;
  return proto.base.v1.ToMapListReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.ToMapListReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.ToMapListReply}
 */
proto.base.v1.ToMapListReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.base.v1.ToMapSimple;
      reader.readMessage(value,proto.base.v1.ToMapSimple.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.ToMapListReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.ToMapListReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.ToMapListReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ToMapListReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.base.v1.ToMapSimple.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ToMapSimple list = 1;
 * @return {!Array<!proto.base.v1.ToMapSimple>}
 */
proto.base.v1.ToMapListReply.prototype.getListList = function() {
  return /** @type{!Array<!proto.base.v1.ToMapSimple>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.base.v1.ToMapSimple, 1));
};


/**
 * @param {!Array<!proto.base.v1.ToMapSimple>} value
 * @return {!proto.base.v1.ToMapListReply} returns this
*/
proto.base.v1.ToMapListReply.prototype.setListList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.base.v1.ToMapSimple=} opt_value
 * @param {number=} opt_index
 * @return {!proto.base.v1.ToMapSimple}
 */
proto.base.v1.ToMapListReply.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.base.v1.ToMapSimple, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.base.v1.ToMapListReply} returns this
 */
proto.base.v1.ToMapListReply.prototype.clearListList = function() {
  return this.setListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.ToMapSimple.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.ToMapSimple.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.ToMapSimple} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ToMapSimple.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
usernum: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.ToMapSimple}
 */
proto.base.v1.ToMapSimple.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.ToMapSimple;
  return proto.base.v1.ToMapSimple.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.ToMapSimple} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.ToMapSimple}
 */
proto.base.v1.ToMapSimple.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUsernum(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.ToMapSimple.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.ToMapSimple.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.ToMapSimple} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ToMapSimple.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getUsernum();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.base.v1.ToMapSimple.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ToMapSimple} returns this
 */
proto.base.v1.ToMapSimple.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.base.v1.ToMapSimple.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.v1.ToMapSimple} returns this
 */
proto.base.v1.ToMapSimple.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 userNum = 3;
 * @return {number}
 */
proto.base.v1.ToMapSimple.prototype.getUsernum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ToMapSimple} returns this
 */
proto.base.v1.ToMapSimple.prototype.setUsernum = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.base.v1.ToMapDetailReply.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.ToMapDetailReply.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.ToMapDetailReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.ToMapDetailReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ToMapDetailReply.toObject = function(includeInstance, msg) {
  var f, obj = {
mapinfo: (f = msg.getMapinfo()) && proto.base.v1.ToMapInfo.toObject(includeInstance, f),
actselectrsList: jspb.Message.toObjectList(msg.getActselectrsList(),
    proto.base.v1.ToActInfoSelect.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.ToMapDetailReply}
 */
proto.base.v1.ToMapDetailReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.ToMapDetailReply;
  return proto.base.v1.ToMapDetailReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.ToMapDetailReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.ToMapDetailReply}
 */
proto.base.v1.ToMapDetailReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.base.v1.ToMapInfo;
      reader.readMessage(value,proto.base.v1.ToMapInfo.deserializeBinaryFromReader);
      msg.setMapinfo(value);
      break;
    case 2:
      var value = new proto.base.v1.ToActInfoSelect;
      reader.readMessage(value,proto.base.v1.ToActInfoSelect.deserializeBinaryFromReader);
      msg.addActselectrs(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.ToMapDetailReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.ToMapDetailReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.ToMapDetailReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ToMapDetailReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMapinfo();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.base.v1.ToMapInfo.serializeBinaryToWriter
    );
  }
  f = message.getActselectrsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.base.v1.ToActInfoSelect.serializeBinaryToWriter
    );
  }
};


/**
 * optional ToMapInfo mapInfo = 1;
 * @return {?proto.base.v1.ToMapInfo}
 */
proto.base.v1.ToMapDetailReply.prototype.getMapinfo = function() {
  return /** @type{?proto.base.v1.ToMapInfo} */ (
    jspb.Message.getWrapperField(this, proto.base.v1.ToMapInfo, 1));
};


/**
 * @param {?proto.base.v1.ToMapInfo|undefined} value
 * @return {!proto.base.v1.ToMapDetailReply} returns this
*/
proto.base.v1.ToMapDetailReply.prototype.setMapinfo = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.base.v1.ToMapDetailReply} returns this
 */
proto.base.v1.ToMapDetailReply.prototype.clearMapinfo = function() {
  return this.setMapinfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.base.v1.ToMapDetailReply.prototype.hasMapinfo = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated ToActInfoSelect actSelectRs = 2;
 * @return {!Array<!proto.base.v1.ToActInfoSelect>}
 */
proto.base.v1.ToMapDetailReply.prototype.getActselectrsList = function() {
  return /** @type{!Array<!proto.base.v1.ToActInfoSelect>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.base.v1.ToActInfoSelect, 2));
};


/**
 * @param {!Array<!proto.base.v1.ToActInfoSelect>} value
 * @return {!proto.base.v1.ToMapDetailReply} returns this
*/
proto.base.v1.ToMapDetailReply.prototype.setActselectrsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.base.v1.ToActInfoSelect=} opt_value
 * @param {number=} opt_index
 * @return {!proto.base.v1.ToActInfoSelect}
 */
proto.base.v1.ToMapDetailReply.prototype.addActselectrs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.base.v1.ToActInfoSelect, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.base.v1.ToMapDetailReply} returns this
 */
proto.base.v1.ToMapDetailReply.prototype.clearActselectrsList = function() {
  return this.setActselectrsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.base.v1.ToActInfoSelect.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.ToActInfoSelect.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.ToActInfoSelect.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.ToActInfoSelect} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ToActInfoSelect.toObject = function(includeInstance, msg) {
  var f, obj = {
actid: jspb.Message.getFieldWithDefault(msg, 1, 0),
actname: jspb.Message.getFieldWithDefault(msg, 2, ""),
courseselectrsList: jspb.Message.toObjectList(msg.getCourseselectrsList(),
    proto.base.v1.ToCourseInfoSelect.toObject, includeInstance),
actusernum: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.ToActInfoSelect}
 */
proto.base.v1.ToActInfoSelect.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.ToActInfoSelect;
  return proto.base.v1.ToActInfoSelect.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.ToActInfoSelect} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.ToActInfoSelect}
 */
proto.base.v1.ToActInfoSelect.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setActid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setActname(value);
      break;
    case 3:
      var value = new proto.base.v1.ToCourseInfoSelect;
      reader.readMessage(value,proto.base.v1.ToCourseInfoSelect.deserializeBinaryFromReader);
      msg.addCourseselectrs(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setActusernum(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.ToActInfoSelect.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.ToActInfoSelect.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.ToActInfoSelect} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ToActInfoSelect.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getActid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getActname();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCourseselectrsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.base.v1.ToCourseInfoSelect.serializeBinaryToWriter
    );
  }
  f = message.getActusernum();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
};


/**
 * optional int32 actId = 1;
 * @return {number}
 */
proto.base.v1.ToActInfoSelect.prototype.getActid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ToActInfoSelect} returns this
 */
proto.base.v1.ToActInfoSelect.prototype.setActid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string actName = 2;
 * @return {string}
 */
proto.base.v1.ToActInfoSelect.prototype.getActname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.v1.ToActInfoSelect} returns this
 */
proto.base.v1.ToActInfoSelect.prototype.setActname = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated ToCourseInfoSelect courseSelectRs = 3;
 * @return {!Array<!proto.base.v1.ToCourseInfoSelect>}
 */
proto.base.v1.ToActInfoSelect.prototype.getCourseselectrsList = function() {
  return /** @type{!Array<!proto.base.v1.ToCourseInfoSelect>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.base.v1.ToCourseInfoSelect, 3));
};


/**
 * @param {!Array<!proto.base.v1.ToCourseInfoSelect>} value
 * @return {!proto.base.v1.ToActInfoSelect} returns this
*/
proto.base.v1.ToActInfoSelect.prototype.setCourseselectrsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.base.v1.ToCourseInfoSelect=} opt_value
 * @param {number=} opt_index
 * @return {!proto.base.v1.ToCourseInfoSelect}
 */
proto.base.v1.ToActInfoSelect.prototype.addCourseselectrs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.base.v1.ToCourseInfoSelect, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.base.v1.ToActInfoSelect} returns this
 */
proto.base.v1.ToActInfoSelect.prototype.clearCourseselectrsList = function() {
  return this.setCourseselectrsList([]);
};


/**
 * optional int32 actUserNum = 5;
 * @return {number}
 */
proto.base.v1.ToActInfoSelect.prototype.getActusernum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ToActInfoSelect} returns this
 */
proto.base.v1.ToActInfoSelect.prototype.setActusernum = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.ToCourseInfoSelect.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.ToCourseInfoSelect.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.ToCourseInfoSelect} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ToCourseInfoSelect.toObject = function(includeInstance, msg) {
  var f, obj = {
courseid: jspb.Message.getFieldWithDefault(msg, 1, 0),
coursename: jspb.Message.getFieldWithDefault(msg, 2, ""),
courseusernum: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.ToCourseInfoSelect}
 */
proto.base.v1.ToCourseInfoSelect.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.ToCourseInfoSelect;
  return proto.base.v1.ToCourseInfoSelect.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.ToCourseInfoSelect} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.ToCourseInfoSelect}
 */
proto.base.v1.ToCourseInfoSelect.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCourseid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCoursename(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCourseusernum(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.ToCourseInfoSelect.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.ToCourseInfoSelect.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.ToCourseInfoSelect} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ToCourseInfoSelect.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCourseid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getCoursename();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCourseusernum();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional int32 courseId = 1;
 * @return {number}
 */
proto.base.v1.ToCourseInfoSelect.prototype.getCourseid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ToCourseInfoSelect} returns this
 */
proto.base.v1.ToCourseInfoSelect.prototype.setCourseid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string courseName = 2;
 * @return {string}
 */
proto.base.v1.ToCourseInfoSelect.prototype.getCoursename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.v1.ToCourseInfoSelect} returns this
 */
proto.base.v1.ToCourseInfoSelect.prototype.setCoursename = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 courseUserNum = 3;
 * @return {number}
 */
proto.base.v1.ToCourseInfoSelect.prototype.getCourseusernum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ToCourseInfoSelect} returns this
 */
proto.base.v1.ToCourseInfoSelect.prototype.setCourseusernum = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.base.v1.ToActionListReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.ToActionListReply.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.ToActionListReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.ToActionListReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ToActionListReply.toObject = function(includeInstance, msg) {
  var f, obj = {
listList: jspb.Message.toObjectList(msg.getListList(),
    proto.base.v1.ToActionSimple.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.ToActionListReply}
 */
proto.base.v1.ToActionListReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.ToActionListReply;
  return proto.base.v1.ToActionListReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.ToActionListReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.ToActionListReply}
 */
proto.base.v1.ToActionListReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.base.v1.ToActionSimple;
      reader.readMessage(value,proto.base.v1.ToActionSimple.deserializeBinaryFromReader);
      msg.addList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.ToActionListReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.ToActionListReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.ToActionListReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ToActionListReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.base.v1.ToActionSimple.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ToActionSimple list = 1;
 * @return {!Array<!proto.base.v1.ToActionSimple>}
 */
proto.base.v1.ToActionListReply.prototype.getListList = function() {
  return /** @type{!Array<!proto.base.v1.ToActionSimple>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.base.v1.ToActionSimple, 1));
};


/**
 * @param {!Array<!proto.base.v1.ToActionSimple>} value
 * @return {!proto.base.v1.ToActionListReply} returns this
*/
proto.base.v1.ToActionListReply.prototype.setListList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.base.v1.ToActionSimple=} opt_value
 * @param {number=} opt_index
 * @return {!proto.base.v1.ToActionSimple}
 */
proto.base.v1.ToActionListReply.prototype.addList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.base.v1.ToActionSimple, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.base.v1.ToActionListReply} returns this
 */
proto.base.v1.ToActionListReply.prototype.clearListList = function() {
  return this.setListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.ToActionSimple.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.ToActionSimple.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.ToActionSimple} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ToActionSimple.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
usernum: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.ToActionSimple}
 */
proto.base.v1.ToActionSimple.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.ToActionSimple;
  return proto.base.v1.ToActionSimple.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.ToActionSimple} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.ToActionSimple}
 */
proto.base.v1.ToActionSimple.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUsernum(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.ToActionSimple.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.ToActionSimple.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.ToActionSimple} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ToActionSimple.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getUsernum();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.base.v1.ToActionSimple.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ToActionSimple} returns this
 */
proto.base.v1.ToActionSimple.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.base.v1.ToActionSimple.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.v1.ToActionSimple} returns this
 */
proto.base.v1.ToActionSimple.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 userNum = 3;
 * @return {number}
 */
proto.base.v1.ToActionSimple.prototype.getUsernum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ToActionSimple} returns this
 */
proto.base.v1.ToActionSimple.prototype.setUsernum = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.base.v1.ToActionDetailReply.repeatedFields_ = [9];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.ToActionDetailReply.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.ToActionDetailReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.ToActionDetailReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ToActionDetailReply.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
content: jspb.Message.getFieldWithDefault(msg, 3, ""),
lockup: jspb.Message.getFieldWithDefault(msg, 4, 0),
forcedendtime: jspb.Message.getFieldWithDefault(msg, 5, 0),
totalcontrolnum: jspb.Message.getFieldWithDefault(msg, 6, 0),
maxrange: jspb.Message.getFieldWithDefault(msg, 7, 0),
mapinfo: (f = msg.getMapinfo()) && proto.base.v1.ToMapInfo.toObject(includeInstance, f),
routesList: jspb.Message.toObjectList(msg.getRoutesList(),
    proto.base.v1.CourseInfo.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.ToActionDetailReply}
 */
proto.base.v1.ToActionDetailReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.ToActionDetailReply;
  return proto.base.v1.ToActionDetailReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.ToActionDetailReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.ToActionDetailReply}
 */
proto.base.v1.ToActionDetailReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setContent(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLockup(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setForcedendtime(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalcontrolnum(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMaxrange(value);
      break;
    case 8:
      var value = new proto.base.v1.ToMapInfo;
      reader.readMessage(value,proto.base.v1.ToMapInfo.deserializeBinaryFromReader);
      msg.setMapinfo(value);
      break;
    case 9:
      var value = new proto.base.v1.CourseInfo;
      reader.readMessage(value,proto.base.v1.CourseInfo.deserializeBinaryFromReader);
      msg.addRoutes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.ToActionDetailReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.ToActionDetailReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.ToActionDetailReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ToActionDetailReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getContent();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getLockup();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getForcedendtime();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getTotalcontrolnum();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getMaxrange();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getMapinfo();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.base.v1.ToMapInfo.serializeBinaryToWriter
    );
  }
  f = message.getRoutesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      9,
      f,
      proto.base.v1.CourseInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.base.v1.ToActionDetailReply.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ToActionDetailReply} returns this
 */
proto.base.v1.ToActionDetailReply.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.base.v1.ToActionDetailReply.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.v1.ToActionDetailReply} returns this
 */
proto.base.v1.ToActionDetailReply.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string content = 3;
 * @return {string}
 */
proto.base.v1.ToActionDetailReply.prototype.getContent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.v1.ToActionDetailReply} returns this
 */
proto.base.v1.ToActionDetailReply.prototype.setContent = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 lockup = 4;
 * @return {number}
 */
proto.base.v1.ToActionDetailReply.prototype.getLockup = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ToActionDetailReply} returns this
 */
proto.base.v1.ToActionDetailReply.prototype.setLockup = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 forcedEndTime = 5;
 * @return {number}
 */
proto.base.v1.ToActionDetailReply.prototype.getForcedendtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ToActionDetailReply} returns this
 */
proto.base.v1.ToActionDetailReply.prototype.setForcedendtime = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 totalControlNum = 6;
 * @return {number}
 */
proto.base.v1.ToActionDetailReply.prototype.getTotalcontrolnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ToActionDetailReply} returns this
 */
proto.base.v1.ToActionDetailReply.prototype.setTotalcontrolnum = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int32 maxRange = 7;
 * @return {number}
 */
proto.base.v1.ToActionDetailReply.prototype.getMaxrange = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ToActionDetailReply} returns this
 */
proto.base.v1.ToActionDetailReply.prototype.setMaxrange = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional ToMapInfo mapInfo = 8;
 * @return {?proto.base.v1.ToMapInfo}
 */
proto.base.v1.ToActionDetailReply.prototype.getMapinfo = function() {
  return /** @type{?proto.base.v1.ToMapInfo} */ (
    jspb.Message.getWrapperField(this, proto.base.v1.ToMapInfo, 8));
};


/**
 * @param {?proto.base.v1.ToMapInfo|undefined} value
 * @return {!proto.base.v1.ToActionDetailReply} returns this
*/
proto.base.v1.ToActionDetailReply.prototype.setMapinfo = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.base.v1.ToActionDetailReply} returns this
 */
proto.base.v1.ToActionDetailReply.prototype.clearMapinfo = function() {
  return this.setMapinfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.base.v1.ToActionDetailReply.prototype.hasMapinfo = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * repeated CourseInfo routes = 9;
 * @return {!Array<!proto.base.v1.CourseInfo>}
 */
proto.base.v1.ToActionDetailReply.prototype.getRoutesList = function() {
  return /** @type{!Array<!proto.base.v1.CourseInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.base.v1.CourseInfo, 9));
};


/**
 * @param {!Array<!proto.base.v1.CourseInfo>} value
 * @return {!proto.base.v1.ToActionDetailReply} returns this
*/
proto.base.v1.ToActionDetailReply.prototype.setRoutesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 9, value);
};


/**
 * @param {!proto.base.v1.CourseInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.base.v1.CourseInfo}
 */
proto.base.v1.ToActionDetailReply.prototype.addRoutes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.base.v1.CourseInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.base.v1.ToActionDetailReply} returns this
 */
proto.base.v1.ToActionDetailReply.prototype.clearRoutesList = function() {
  return this.setRoutesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.base.v1.ToActionUsersDetailReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.ToActionUsersDetailReply.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.ToActionUsersDetailReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.ToActionUsersDetailReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ToActionUsersDetailReply.toObject = function(includeInstance, msg) {
  var f, obj = {
usersList: jspb.Message.toObjectList(msg.getUsersList(),
    proto.base.v1.UserInGameInfo.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.ToActionUsersDetailReply}
 */
proto.base.v1.ToActionUsersDetailReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.ToActionUsersDetailReply;
  return proto.base.v1.ToActionUsersDetailReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.ToActionUsersDetailReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.ToActionUsersDetailReply}
 */
proto.base.v1.ToActionUsersDetailReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.base.v1.UserInGameInfo;
      reader.readMessage(value,proto.base.v1.UserInGameInfo.deserializeBinaryFromReader);
      msg.addUsers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.ToActionUsersDetailReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.ToActionUsersDetailReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.ToActionUsersDetailReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ToActionUsersDetailReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUsersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.base.v1.UserInGameInfo.serializeBinaryToWriter
    );
  }
};


/**
 * repeated UserInGameInfo users = 1;
 * @return {!Array<!proto.base.v1.UserInGameInfo>}
 */
proto.base.v1.ToActionUsersDetailReply.prototype.getUsersList = function() {
  return /** @type{!Array<!proto.base.v1.UserInGameInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.base.v1.UserInGameInfo, 1));
};


/**
 * @param {!Array<!proto.base.v1.UserInGameInfo>} value
 * @return {!proto.base.v1.ToActionUsersDetailReply} returns this
*/
proto.base.v1.ToActionUsersDetailReply.prototype.setUsersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.base.v1.UserInGameInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.base.v1.UserInGameInfo}
 */
proto.base.v1.ToActionUsersDetailReply.prototype.addUsers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.base.v1.UserInGameInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.base.v1.ToActionUsersDetailReply} returns this
 */
proto.base.v1.ToActionUsersDetailReply.prototype.clearUsersList = function() {
  return this.setUsersList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.base.v1.UserInGameInfo.repeatedFields_ = [21];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.UserInGameInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.UserInGameInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.UserInGameInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.UserInGameInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
distance: jspb.Message.getFieldWithDefault(msg, 3, 0),
pace: jspb.Message.getFieldWithDefault(msg, 4, 0),
avghr: jspb.Message.getFieldWithDefault(msg, 5, 0),
maxhr: jspb.Message.getFieldWithDefault(msg, 6, 0),
calorie: jspb.Message.getFieldWithDefault(msg, 7, 0),
ck: jspb.Message.getFieldWithDefault(msg, 8, 0),
ei: jspb.Message.getFloatingPointFieldWithDefault(msg, 9, 0.0),
effectivenum: jspb.Message.getFieldWithDefault(msg, 10, 0),
totalcontrolnum: jspb.Message.getFieldWithDefault(msg, 11, 0),
startsecondstamp: jspb.Message.getFieldWithDefault(msg, 12, 0),
endsecondstamp: jspb.Message.getFieldWithDefault(msg, 13, 0),
mstate: jspb.Message.getFieldWithDefault(msg, 14, 0),
lasthr: jspb.Message.getFieldWithDefault(msg, 15, 0),
phone: jspb.Message.getFieldWithDefault(msg, 16, ""),
nextcontrolpoint: (f = msg.getNextcontrolpoint()) && proto.base.v1.UserArriveControlPoint.toObject(includeInstance, f),
oaid: jspb.Message.getFieldWithDefault(msg, 18, 0),
stepnum: jspb.Message.getFieldWithDefault(msg, 19, 0),
syspoint: jspb.Message.getFieldWithDefault(msg, 20, 0),
controlPointSortedListList: jspb.Message.toObjectList(msg.getControlPointSortedListList(),
    proto.base.v1.UserArriveControlPoint.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.UserInGameInfo}
 */
proto.base.v1.UserInGameInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.UserInGameInfo;
  return proto.base.v1.UserInGameInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.UserInGameInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.UserInGameInfo}
 */
proto.base.v1.UserInGameInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDistance(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPace(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAvghr(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMaxhr(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCalorie(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCk(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setEi(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setEffectivenum(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalcontrolnum(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setStartsecondstamp(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEndsecondstamp(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMstate(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLasthr(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhone(value);
      break;
    case 17:
      var value = new proto.base.v1.UserArriveControlPoint;
      reader.readMessage(value,proto.base.v1.UserArriveControlPoint.deserializeBinaryFromReader);
      msg.setNextcontrolpoint(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOaid(value);
      break;
    case 19:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setStepnum(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSyspoint(value);
      break;
    case 21:
      var value = new proto.base.v1.UserArriveControlPoint;
      reader.readMessage(value,proto.base.v1.UserArriveControlPoint.deserializeBinaryFromReader);
      msg.addControlPointSortedList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.UserInGameInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.UserInGameInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.UserInGameInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.UserInGameInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDistance();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getPace();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getAvghr();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getMaxhr();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getCalorie();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getCk();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getEi();
  if (f !== 0.0) {
    writer.writeFloat(
      9,
      f
    );
  }
  f = message.getEffectivenum();
  if (f !== 0) {
    writer.writeInt32(
      10,
      f
    );
  }
  f = message.getTotalcontrolnum();
  if (f !== 0) {
    writer.writeInt32(
      11,
      f
    );
  }
  f = message.getStartsecondstamp();
  if (f !== 0) {
    writer.writeInt64(
      12,
      f
    );
  }
  f = message.getEndsecondstamp();
  if (f !== 0) {
    writer.writeInt64(
      13,
      f
    );
  }
  f = message.getMstate();
  if (f !== 0) {
    writer.writeInt32(
      14,
      f
    );
  }
  f = message.getLasthr();
  if (f !== 0) {
    writer.writeInt32(
      15,
      f
    );
  }
  f = message.getPhone();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getNextcontrolpoint();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      proto.base.v1.UserArriveControlPoint.serializeBinaryToWriter
    );
  }
  f = message.getOaid();
  if (f !== 0) {
    writer.writeInt32(
      18,
      f
    );
  }
  f = message.getStepnum();
  if (f !== 0) {
    writer.writeInt32(
      19,
      f
    );
  }
  f = message.getSyspoint();
  if (f !== 0) {
    writer.writeInt32(
      20,
      f
    );
  }
  f = message.getControlPointSortedListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      21,
      f,
      proto.base.v1.UserArriveControlPoint.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.base.v1.UserInGameInfo.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.UserInGameInfo} returns this
 */
proto.base.v1.UserInGameInfo.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.base.v1.UserInGameInfo.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.v1.UserInGameInfo} returns this
 */
proto.base.v1.UserInGameInfo.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 distance = 3;
 * @return {number}
 */
proto.base.v1.UserInGameInfo.prototype.getDistance = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.UserInGameInfo} returns this
 */
proto.base.v1.UserInGameInfo.prototype.setDistance = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 pace = 4;
 * @return {number}
 */
proto.base.v1.UserInGameInfo.prototype.getPace = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.UserInGameInfo} returns this
 */
proto.base.v1.UserInGameInfo.prototype.setPace = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 avgHr = 5;
 * @return {number}
 */
proto.base.v1.UserInGameInfo.prototype.getAvghr = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.UserInGameInfo} returns this
 */
proto.base.v1.UserInGameInfo.prototype.setAvghr = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 maxHr = 6;
 * @return {number}
 */
proto.base.v1.UserInGameInfo.prototype.getMaxhr = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.UserInGameInfo} returns this
 */
proto.base.v1.UserInGameInfo.prototype.setMaxhr = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int32 Calorie = 7;
 * @return {number}
 */
proto.base.v1.UserInGameInfo.prototype.getCalorie = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.UserInGameInfo} returns this
 */
proto.base.v1.UserInGameInfo.prototype.setCalorie = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int32 Ck = 8;
 * @return {number}
 */
proto.base.v1.UserInGameInfo.prototype.getCk = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.UserInGameInfo} returns this
 */
proto.base.v1.UserInGameInfo.prototype.setCk = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional float Ei = 9;
 * @return {number}
 */
proto.base.v1.UserInGameInfo.prototype.getEi = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 9, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.UserInGameInfo} returns this
 */
proto.base.v1.UserInGameInfo.prototype.setEi = function(value) {
  return jspb.Message.setProto3FloatField(this, 9, value);
};


/**
 * optional int32 EffectiveNum = 10;
 * @return {number}
 */
proto.base.v1.UserInGameInfo.prototype.getEffectivenum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.UserInGameInfo} returns this
 */
proto.base.v1.UserInGameInfo.prototype.setEffectivenum = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional int32 TotalControlNum = 11;
 * @return {number}
 */
proto.base.v1.UserInGameInfo.prototype.getTotalcontrolnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.UserInGameInfo} returns this
 */
proto.base.v1.UserInGameInfo.prototype.setTotalcontrolnum = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional int64 startSecondStamp = 12;
 * @return {number}
 */
proto.base.v1.UserInGameInfo.prototype.getStartsecondstamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.UserInGameInfo} returns this
 */
proto.base.v1.UserInGameInfo.prototype.setStartsecondstamp = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional int64 endSecondStamp = 13;
 * @return {number}
 */
proto.base.v1.UserInGameInfo.prototype.getEndsecondstamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.UserInGameInfo} returns this
 */
proto.base.v1.UserInGameInfo.prototype.setEndsecondstamp = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional int32 mState = 14;
 * @return {number}
 */
proto.base.v1.UserInGameInfo.prototype.getMstate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.UserInGameInfo} returns this
 */
proto.base.v1.UserInGameInfo.prototype.setMstate = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional int32 lastHr = 15;
 * @return {number}
 */
proto.base.v1.UserInGameInfo.prototype.getLasthr = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.UserInGameInfo} returns this
 */
proto.base.v1.UserInGameInfo.prototype.setLasthr = function(value) {
  return jspb.Message.setProto3IntField(this, 15, value);
};


/**
 * optional string phone = 16;
 * @return {string}
 */
proto.base.v1.UserInGameInfo.prototype.getPhone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.v1.UserInGameInfo} returns this
 */
proto.base.v1.UserInGameInfo.prototype.setPhone = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional UserArriveControlPoint nextControlPoint = 17;
 * @return {?proto.base.v1.UserArriveControlPoint}
 */
proto.base.v1.UserInGameInfo.prototype.getNextcontrolpoint = function() {
  return /** @type{?proto.base.v1.UserArriveControlPoint} */ (
    jspb.Message.getWrapperField(this, proto.base.v1.UserArriveControlPoint, 17));
};


/**
 * @param {?proto.base.v1.UserArriveControlPoint|undefined} value
 * @return {!proto.base.v1.UserInGameInfo} returns this
*/
proto.base.v1.UserInGameInfo.prototype.setNextcontrolpoint = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.base.v1.UserInGameInfo} returns this
 */
proto.base.v1.UserInGameInfo.prototype.clearNextcontrolpoint = function() {
  return this.setNextcontrolpoint(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.base.v1.UserInGameInfo.prototype.hasNextcontrolpoint = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional int32 oaId = 18;
 * @return {number}
 */
proto.base.v1.UserInGameInfo.prototype.getOaid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.UserInGameInfo} returns this
 */
proto.base.v1.UserInGameInfo.prototype.setOaid = function(value) {
  return jspb.Message.setProto3IntField(this, 18, value);
};


/**
 * optional int32 stepNum = 19;
 * @return {number}
 */
proto.base.v1.UserInGameInfo.prototype.getStepnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.UserInGameInfo} returns this
 */
proto.base.v1.UserInGameInfo.prototype.setStepnum = function(value) {
  return jspb.Message.setProto3IntField(this, 19, value);
};


/**
 * optional int32 sysPoint = 20;
 * @return {number}
 */
proto.base.v1.UserInGameInfo.prototype.getSyspoint = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 20, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.UserInGameInfo} returns this
 */
proto.base.v1.UserInGameInfo.prototype.setSyspoint = function(value) {
  return jspb.Message.setProto3IntField(this, 20, value);
};


/**
 * repeated UserArriveControlPoint control_point_sorted_list = 21;
 * @return {!Array<!proto.base.v1.UserArriveControlPoint>}
 */
proto.base.v1.UserInGameInfo.prototype.getControlPointSortedListList = function() {
  return /** @type{!Array<!proto.base.v1.UserArriveControlPoint>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.base.v1.UserArriveControlPoint, 21));
};


/**
 * @param {!Array<!proto.base.v1.UserArriveControlPoint>} value
 * @return {!proto.base.v1.UserInGameInfo} returns this
*/
proto.base.v1.UserInGameInfo.prototype.setControlPointSortedListList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 21, value);
};


/**
 * @param {!proto.base.v1.UserArriveControlPoint=} opt_value
 * @param {number=} opt_index
 * @return {!proto.base.v1.UserArriveControlPoint}
 */
proto.base.v1.UserInGameInfo.prototype.addControlPointSortedList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 21, opt_value, proto.base.v1.UserArriveControlPoint, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.base.v1.UserInGameInfo} returns this
 */
proto.base.v1.UserInGameInfo.prototype.clearControlPointSortedListList = function() {
  return this.setControlPointSortedListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.UserArriveControlPoint.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.UserArriveControlPoint.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.UserArriveControlPoint} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.UserArriveControlPoint.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
sn: jspb.Message.getFieldWithDefault(msg, 2, ""),
punchsecondstamp: jspb.Message.getFieldWithDefault(msg, 3, 0),
category: jspb.Message.getFieldWithDefault(msg, 4, 0),
ciposition: (f = msg.getCiposition()) && proto.base.v1.Position.toObject(includeInstance, f),
isarrive: jspb.Message.getBooleanFieldWithDefault(msg, 6, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.UserArriveControlPoint}
 */
proto.base.v1.UserArriveControlPoint.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.UserArriveControlPoint;
  return proto.base.v1.UserArriveControlPoint.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.UserArriveControlPoint} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.UserArriveControlPoint}
 */
proto.base.v1.UserArriveControlPoint.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSn(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPunchsecondstamp(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCategory(value);
      break;
    case 5:
      var value = new proto.base.v1.Position;
      reader.readMessage(value,proto.base.v1.Position.deserializeBinaryFromReader);
      msg.setCiposition(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsarrive(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.UserArriveControlPoint.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.UserArriveControlPoint.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.UserArriveControlPoint} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.UserArriveControlPoint.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getSn();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPunchsecondstamp();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getCategory();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getCiposition();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.base.v1.Position.serializeBinaryToWriter
    );
  }
  f = message.getIsarrive();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.base.v1.UserArriveControlPoint.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.UserArriveControlPoint} returns this
 */
proto.base.v1.UserArriveControlPoint.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string sn = 2;
 * @return {string}
 */
proto.base.v1.UserArriveControlPoint.prototype.getSn = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.v1.UserArriveControlPoint} returns this
 */
proto.base.v1.UserArriveControlPoint.prototype.setSn = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 PunchSecondStamp = 3;
 * @return {number}
 */
proto.base.v1.UserArriveControlPoint.prototype.getPunchsecondstamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.UserArriveControlPoint} returns this
 */
proto.base.v1.UserArriveControlPoint.prototype.setPunchsecondstamp = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 category = 4;
 * @return {number}
 */
proto.base.v1.UserArriveControlPoint.prototype.getCategory = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.UserArriveControlPoint} returns this
 */
proto.base.v1.UserArriveControlPoint.prototype.setCategory = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional Position ciPosition = 5;
 * @return {?proto.base.v1.Position}
 */
proto.base.v1.UserArriveControlPoint.prototype.getCiposition = function() {
  return /** @type{?proto.base.v1.Position} */ (
    jspb.Message.getWrapperField(this, proto.base.v1.Position, 5));
};


/**
 * @param {?proto.base.v1.Position|undefined} value
 * @return {!proto.base.v1.UserArriveControlPoint} returns this
*/
proto.base.v1.UserArriveControlPoint.prototype.setCiposition = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.base.v1.UserArriveControlPoint} returns this
 */
proto.base.v1.UserArriveControlPoint.prototype.clearCiposition = function() {
  return this.setCiposition(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.base.v1.UserArriveControlPoint.prototype.hasCiposition = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional bool isArrive = 6;
 * @return {boolean}
 */
proto.base.v1.UserArriveControlPoint.prototype.getIsarrive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.base.v1.UserArriveControlPoint} returns this
 */
proto.base.v1.UserArriveControlPoint.prototype.setIsarrive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.base.v1.ToNextControlPointInGameReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.ToNextControlPointInGameReply.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.ToNextControlPointInGameReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.ToNextControlPointInGameReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ToNextControlPointInGameReply.toObject = function(includeInstance, msg) {
  var f, obj = {
nextcontrolpointrsList: jspb.Message.toObjectList(msg.getNextcontrolpointrsList(),
    proto.base.v1.UserArriveControlPoint.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.ToNextControlPointInGameReply}
 */
proto.base.v1.ToNextControlPointInGameReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.ToNextControlPointInGameReply;
  return proto.base.v1.ToNextControlPointInGameReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.ToNextControlPointInGameReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.ToNextControlPointInGameReply}
 */
proto.base.v1.ToNextControlPointInGameReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.base.v1.UserArriveControlPoint;
      reader.readMessage(value,proto.base.v1.UserArriveControlPoint.deserializeBinaryFromReader);
      msg.addNextcontrolpointrs(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.ToNextControlPointInGameReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.ToNextControlPointInGameReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.ToNextControlPointInGameReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ToNextControlPointInGameReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNextcontrolpointrsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.base.v1.UserArriveControlPoint.serializeBinaryToWriter
    );
  }
};


/**
 * repeated UserArriveControlPoint nextControlPointRs = 1;
 * @return {!Array<!proto.base.v1.UserArriveControlPoint>}
 */
proto.base.v1.ToNextControlPointInGameReply.prototype.getNextcontrolpointrsList = function() {
  return /** @type{!Array<!proto.base.v1.UserArriveControlPoint>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.base.v1.UserArriveControlPoint, 1));
};


/**
 * @param {!Array<!proto.base.v1.UserArriveControlPoint>} value
 * @return {!proto.base.v1.ToNextControlPointInGameReply} returns this
*/
proto.base.v1.ToNextControlPointInGameReply.prototype.setNextcontrolpointrsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.base.v1.UserArriveControlPoint=} opt_value
 * @param {number=} opt_index
 * @return {!proto.base.v1.UserArriveControlPoint}
 */
proto.base.v1.ToNextControlPointInGameReply.prototype.addNextcontrolpointrs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.base.v1.UserArriveControlPoint, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.base.v1.ToNextControlPointInGameReply} returns this
 */
proto.base.v1.ToNextControlPointInGameReply.prototype.clearNextcontrolpointrsList = function() {
  return this.setNextcontrolpointrsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.base.v1.ToUserGpsQueryReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.ToUserGpsQueryReply.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.ToUserGpsQueryReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.ToUserGpsQueryReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ToUserGpsQueryReply.toObject = function(includeInstance, msg) {
  var f, obj = {
gpsinfoList: jspb.Message.toObjectList(msg.getGpsinfoList(),
    proto.base.v1.UserGpsInfo.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.ToUserGpsQueryReply}
 */
proto.base.v1.ToUserGpsQueryReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.ToUserGpsQueryReply;
  return proto.base.v1.ToUserGpsQueryReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.ToUserGpsQueryReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.ToUserGpsQueryReply}
 */
proto.base.v1.ToUserGpsQueryReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.base.v1.UserGpsInfo;
      reader.readMessage(value,proto.base.v1.UserGpsInfo.deserializeBinaryFromReader);
      msg.addGpsinfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.ToUserGpsQueryReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.ToUserGpsQueryReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.ToUserGpsQueryReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ToUserGpsQueryReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGpsinfoList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.base.v1.UserGpsInfo.serializeBinaryToWriter
    );
  }
};


/**
 * repeated UserGpsInfo gpsInfo = 1;
 * @return {!Array<!proto.base.v1.UserGpsInfo>}
 */
proto.base.v1.ToUserGpsQueryReply.prototype.getGpsinfoList = function() {
  return /** @type{!Array<!proto.base.v1.UserGpsInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.base.v1.UserGpsInfo, 1));
};


/**
 * @param {!Array<!proto.base.v1.UserGpsInfo>} value
 * @return {!proto.base.v1.ToUserGpsQueryReply} returns this
*/
proto.base.v1.ToUserGpsQueryReply.prototype.setGpsinfoList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.base.v1.UserGpsInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.base.v1.UserGpsInfo}
 */
proto.base.v1.ToUserGpsQueryReply.prototype.addGpsinfo = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.base.v1.UserGpsInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.base.v1.ToUserGpsQueryReply} returns this
 */
proto.base.v1.ToUserGpsQueryReply.prototype.clearGpsinfoList = function() {
  return this.setGpsinfoList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.UserGpsInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.UserGpsInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.UserGpsInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.UserGpsInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
longitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
latitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
directionradian: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
gpstimesecondstamp: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.UserGpsInfo}
 */
proto.base.v1.UserGpsInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.UserGpsInfo;
  return proto.base.v1.UserGpsInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.UserGpsInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.UserGpsInfo}
 */
proto.base.v1.UserGpsInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLongitude(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLatitude(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setDirectionradian(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setGpstimesecondstamp(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.UserGpsInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.UserGpsInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.UserGpsInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.UserGpsInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getLongitude();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getLatitude();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getDirectionradian();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getGpstimesecondstamp();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
};


/**
 * optional int32 Id = 1;
 * @return {number}
 */
proto.base.v1.UserGpsInfo.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.UserGpsInfo} returns this
 */
proto.base.v1.UserGpsInfo.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional double longitude = 2;
 * @return {number}
 */
proto.base.v1.UserGpsInfo.prototype.getLongitude = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.UserGpsInfo} returns this
 */
proto.base.v1.UserGpsInfo.prototype.setLongitude = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional double latitude = 3;
 * @return {number}
 */
proto.base.v1.UserGpsInfo.prototype.getLatitude = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.UserGpsInfo} returns this
 */
proto.base.v1.UserGpsInfo.prototype.setLatitude = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional double directionRadian = 4;
 * @return {number}
 */
proto.base.v1.UserGpsInfo.prototype.getDirectionradian = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.UserGpsInfo} returns this
 */
proto.base.v1.UserGpsInfo.prototype.setDirectionradian = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional int64 gpsTimeSecondStamp = 5;
 * @return {number}
 */
proto.base.v1.UserGpsInfo.prototype.getGpstimesecondstamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.UserGpsInfo} returns this
 */
proto.base.v1.UserGpsInfo.prototype.setGpstimesecondstamp = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.ToMapInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.ToMapInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.ToMapInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ToMapInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
mapid: jspb.Message.getFieldWithDefault(msg, 1, 0),
mapname: jspb.Message.getFieldWithDefault(msg, 2, ""),
defscale: jspb.Message.getFieldWithDefault(msg, 3, 0),
centerlongitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
centerlatitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
mapurl: jspb.Message.getFieldWithDefault(msg, 7, ""),
mapmd5: jspb.Message.getFieldWithDefault(msg, 8, ""),
zipimage: (f = msg.getZipimage()) && proto.base.v1.NetImage.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.ToMapInfo}
 */
proto.base.v1.ToMapInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.ToMapInfo;
  return proto.base.v1.ToMapInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.ToMapInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.ToMapInfo}
 */
proto.base.v1.ToMapInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMapid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMapname(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDefscale(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setCenterlongitude(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setCenterlatitude(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setMapurl(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setMapmd5(value);
      break;
    case 9:
      var value = new proto.base.v1.NetImage;
      reader.readMessage(value,proto.base.v1.NetImage.deserializeBinaryFromReader);
      msg.setZipimage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.ToMapInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.ToMapInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.ToMapInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ToMapInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMapid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getMapname();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDefscale();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getCenterlongitude();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getCenterlatitude();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getMapurl();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getMapmd5();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getZipimage();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.base.v1.NetImage.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 mapId = 1;
 * @return {number}
 */
proto.base.v1.ToMapInfo.prototype.getMapid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ToMapInfo} returns this
 */
proto.base.v1.ToMapInfo.prototype.setMapid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string mapName = 2;
 * @return {string}
 */
proto.base.v1.ToMapInfo.prototype.getMapname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.v1.ToMapInfo} returns this
 */
proto.base.v1.ToMapInfo.prototype.setMapname = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 DefScale = 3;
 * @return {number}
 */
proto.base.v1.ToMapInfo.prototype.getDefscale = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ToMapInfo} returns this
 */
proto.base.v1.ToMapInfo.prototype.setDefscale = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional double CenterLongitude = 4;
 * @return {number}
 */
proto.base.v1.ToMapInfo.prototype.getCenterlongitude = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ToMapInfo} returns this
 */
proto.base.v1.ToMapInfo.prototype.setCenterlongitude = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional double CenterLatitude = 5;
 * @return {number}
 */
proto.base.v1.ToMapInfo.prototype.getCenterlatitude = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ToMapInfo} returns this
 */
proto.base.v1.ToMapInfo.prototype.setCenterlatitude = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional string mapUrl = 7;
 * @return {string}
 */
proto.base.v1.ToMapInfo.prototype.getMapurl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.v1.ToMapInfo} returns this
 */
proto.base.v1.ToMapInfo.prototype.setMapurl = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string mapMd5 = 8;
 * @return {string}
 */
proto.base.v1.ToMapInfo.prototype.getMapmd5 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.v1.ToMapInfo} returns this
 */
proto.base.v1.ToMapInfo.prototype.setMapmd5 = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional NetImage zipImage = 9;
 * @return {?proto.base.v1.NetImage}
 */
proto.base.v1.ToMapInfo.prototype.getZipimage = function() {
  return /** @type{?proto.base.v1.NetImage} */ (
    jspb.Message.getWrapperField(this, proto.base.v1.NetImage, 9));
};


/**
 * @param {?proto.base.v1.NetImage|undefined} value
 * @return {!proto.base.v1.ToMapInfo} returns this
*/
proto.base.v1.ToMapInfo.prototype.setZipimage = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.base.v1.ToMapInfo} returns this
 */
proto.base.v1.ToMapInfo.prototype.clearZipimage = function() {
  return this.setZipimage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.base.v1.ToMapInfo.prototype.hasZipimage = function() {
  return jspb.Message.getField(this, 9) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.base.v1.ActMgtCourseInfo.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.ActMgtCourseInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.ActMgtCourseInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.ActMgtCourseInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ActMgtCourseInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
courseid: jspb.Message.getFieldWithDefault(msg, 1, 0),
coursename: jspb.Message.getFieldWithDefault(msg, 2, ""),
controlpointsortedlistList: jspb.Message.toObjectList(msg.getControlpointsortedlistList(),
    proto.base.v1.ActMgtControlPoint.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.ActMgtCourseInfo}
 */
proto.base.v1.ActMgtCourseInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.ActMgtCourseInfo;
  return proto.base.v1.ActMgtCourseInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.ActMgtCourseInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.ActMgtCourseInfo}
 */
proto.base.v1.ActMgtCourseInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCourseid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCoursename(value);
      break;
    case 3:
      var value = new proto.base.v1.ActMgtControlPoint;
      reader.readMessage(value,proto.base.v1.ActMgtControlPoint.deserializeBinaryFromReader);
      msg.addControlpointsortedlist(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.ActMgtCourseInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.ActMgtCourseInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.ActMgtCourseInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ActMgtCourseInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCourseid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getCoursename();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getControlpointsortedlistList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.base.v1.ActMgtControlPoint.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 courseId = 1;
 * @return {number}
 */
proto.base.v1.ActMgtCourseInfo.prototype.getCourseid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ActMgtCourseInfo} returns this
 */
proto.base.v1.ActMgtCourseInfo.prototype.setCourseid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string courseName = 2;
 * @return {string}
 */
proto.base.v1.ActMgtCourseInfo.prototype.getCoursename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.v1.ActMgtCourseInfo} returns this
 */
proto.base.v1.ActMgtCourseInfo.prototype.setCoursename = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated ActMgtControlPoint controlPointSortedList = 3;
 * @return {!Array<!proto.base.v1.ActMgtControlPoint>}
 */
proto.base.v1.ActMgtCourseInfo.prototype.getControlpointsortedlistList = function() {
  return /** @type{!Array<!proto.base.v1.ActMgtControlPoint>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.base.v1.ActMgtControlPoint, 3));
};


/**
 * @param {!Array<!proto.base.v1.ActMgtControlPoint>} value
 * @return {!proto.base.v1.ActMgtCourseInfo} returns this
*/
proto.base.v1.ActMgtCourseInfo.prototype.setControlpointsortedlistList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.base.v1.ActMgtControlPoint=} opt_value
 * @param {number=} opt_index
 * @return {!proto.base.v1.ActMgtControlPoint}
 */
proto.base.v1.ActMgtCourseInfo.prototype.addControlpointsortedlist = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.base.v1.ActMgtControlPoint, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.base.v1.ActMgtCourseInfo} returns this
 */
proto.base.v1.ActMgtCourseInfo.prototype.clearControlpointsortedlistList = function() {
  return this.setControlpointsortedlistList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.ActMgtControlPoint.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.ActMgtControlPoint.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.ActMgtControlPoint} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ActMgtControlPoint.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
sn: jspb.Message.getFieldWithDefault(msg, 2, ""),
ciposition: (f = msg.getCiposition()) && proto.base.v1.Position.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.ActMgtControlPoint}
 */
proto.base.v1.ActMgtControlPoint.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.ActMgtControlPoint;
  return proto.base.v1.ActMgtControlPoint.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.ActMgtControlPoint} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.ActMgtControlPoint}
 */
proto.base.v1.ActMgtControlPoint.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSn(value);
      break;
    case 3:
      var value = new proto.base.v1.Position;
      reader.readMessage(value,proto.base.v1.Position.deserializeBinaryFromReader);
      msg.setCiposition(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.ActMgtControlPoint.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.ActMgtControlPoint.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.ActMgtControlPoint} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ActMgtControlPoint.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getSn();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCiposition();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.base.v1.Position.serializeBinaryToWriter
    );
  }
};


/**
 * optional int64 id = 1;
 * @return {number}
 */
proto.base.v1.ActMgtControlPoint.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ActMgtControlPoint} returns this
 */
proto.base.v1.ActMgtControlPoint.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string sn = 2;
 * @return {string}
 */
proto.base.v1.ActMgtControlPoint.prototype.getSn = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.v1.ActMgtControlPoint} returns this
 */
proto.base.v1.ActMgtControlPoint.prototype.setSn = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional Position ciPosition = 3;
 * @return {?proto.base.v1.Position}
 */
proto.base.v1.ActMgtControlPoint.prototype.getCiposition = function() {
  return /** @type{?proto.base.v1.Position} */ (
    jspb.Message.getWrapperField(this, proto.base.v1.Position, 3));
};


/**
 * @param {?proto.base.v1.Position|undefined} value
 * @return {!proto.base.v1.ActMgtControlPoint} returns this
*/
proto.base.v1.ActMgtControlPoint.prototype.setCiposition = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.base.v1.ActMgtControlPoint} returns this
 */
proto.base.v1.ActMgtControlPoint.prototype.clearCiposition = function() {
  return this.setCiposition(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.base.v1.ActMgtControlPoint.prototype.hasCiposition = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.base.v1.ActMgtUserInGameInfo.repeatedFields_ = [21];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.base.v1.ActMgtUserInGameInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.base.v1.ActMgtUserInGameInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.base.v1.ActMgtUserInGameInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ActMgtUserInGameInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
distance: jspb.Message.getFieldWithDefault(msg, 3, 0),
pace: jspb.Message.getFieldWithDefault(msg, 4, 0),
effectivenum: jspb.Message.getFieldWithDefault(msg, 10, 0),
totalcontrolnum: jspb.Message.getFieldWithDefault(msg, 11, 0),
startsecondstamp: jspb.Message.getFieldWithDefault(msg, 12, 0),
endsecondstamp: jspb.Message.getFieldWithDefault(msg, 13, 0),
mstate: jspb.Message.getFieldWithDefault(msg, 14, 0),
lasthr: jspb.Message.getFieldWithDefault(msg, 15, 0),
phone: jspb.Message.getFieldWithDefault(msg, 16, ""),
nextcontrolpoint: (f = msg.getNextcontrolpoint()) && proto.base.v1.GameArriveControlPoint.toObject(includeInstance, f),
oaid: jspb.Message.getFieldWithDefault(msg, 18, 0),
stepnum: jspb.Message.getFieldWithDefault(msg, 19, 0),
syspoint: jspb.Message.getFieldWithDefault(msg, 20, 0),
controlpointsortedlistList: jspb.Message.toObjectList(msg.getControlpointsortedlistList(),
    proto.base.v1.ToControlPoint.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.base.v1.ActMgtUserInGameInfo}
 */
proto.base.v1.ActMgtUserInGameInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.base.v1.ActMgtUserInGameInfo;
  return proto.base.v1.ActMgtUserInGameInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.base.v1.ActMgtUserInGameInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.base.v1.ActMgtUserInGameInfo}
 */
proto.base.v1.ActMgtUserInGameInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDistance(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPace(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setEffectivenum(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalcontrolnum(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setStartsecondstamp(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEndsecondstamp(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMstate(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLasthr(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhone(value);
      break;
    case 17:
      var value = new proto.base.v1.GameArriveControlPoint;
      reader.readMessage(value,proto.base.v1.GameArriveControlPoint.deserializeBinaryFromReader);
      msg.setNextcontrolpoint(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOaid(value);
      break;
    case 19:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setStepnum(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSyspoint(value);
      break;
    case 21:
      var value = new proto.base.v1.ToControlPoint;
      reader.readMessage(value,proto.base.v1.ToControlPoint.deserializeBinaryFromReader);
      msg.addControlpointsortedlist(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.base.v1.ActMgtUserInGameInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.base.v1.ActMgtUserInGameInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.base.v1.ActMgtUserInGameInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.base.v1.ActMgtUserInGameInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDistance();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getPace();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getEffectivenum();
  if (f !== 0) {
    writer.writeInt32(
      10,
      f
    );
  }
  f = message.getTotalcontrolnum();
  if (f !== 0) {
    writer.writeInt32(
      11,
      f
    );
  }
  f = message.getStartsecondstamp();
  if (f !== 0) {
    writer.writeInt64(
      12,
      f
    );
  }
  f = message.getEndsecondstamp();
  if (f !== 0) {
    writer.writeInt64(
      13,
      f
    );
  }
  f = message.getMstate();
  if (f !== 0) {
    writer.writeInt32(
      14,
      f
    );
  }
  f = message.getLasthr();
  if (f !== 0) {
    writer.writeInt32(
      15,
      f
    );
  }
  f = message.getPhone();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getNextcontrolpoint();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      proto.base.v1.GameArriveControlPoint.serializeBinaryToWriter
    );
  }
  f = message.getOaid();
  if (f !== 0) {
    writer.writeInt32(
      18,
      f
    );
  }
  f = message.getStepnum();
  if (f !== 0) {
    writer.writeInt32(
      19,
      f
    );
  }
  f = message.getSyspoint();
  if (f !== 0) {
    writer.writeInt32(
      20,
      f
    );
  }
  f = message.getControlpointsortedlistList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      21,
      f,
      proto.base.v1.ToControlPoint.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.base.v1.ActMgtUserInGameInfo.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ActMgtUserInGameInfo} returns this
 */
proto.base.v1.ActMgtUserInGameInfo.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.base.v1.ActMgtUserInGameInfo.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.v1.ActMgtUserInGameInfo} returns this
 */
proto.base.v1.ActMgtUserInGameInfo.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 distance = 3;
 * @return {number}
 */
proto.base.v1.ActMgtUserInGameInfo.prototype.getDistance = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ActMgtUserInGameInfo} returns this
 */
proto.base.v1.ActMgtUserInGameInfo.prototype.setDistance = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 pace = 4;
 * @return {number}
 */
proto.base.v1.ActMgtUserInGameInfo.prototype.getPace = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ActMgtUserInGameInfo} returns this
 */
proto.base.v1.ActMgtUserInGameInfo.prototype.setPace = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 EffectiveNum = 10;
 * @return {number}
 */
proto.base.v1.ActMgtUserInGameInfo.prototype.getEffectivenum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ActMgtUserInGameInfo} returns this
 */
proto.base.v1.ActMgtUserInGameInfo.prototype.setEffectivenum = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional int32 TotalControlNum = 11;
 * @return {number}
 */
proto.base.v1.ActMgtUserInGameInfo.prototype.getTotalcontrolnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ActMgtUserInGameInfo} returns this
 */
proto.base.v1.ActMgtUserInGameInfo.prototype.setTotalcontrolnum = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional int64 startSecondStamp = 12;
 * @return {number}
 */
proto.base.v1.ActMgtUserInGameInfo.prototype.getStartsecondstamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ActMgtUserInGameInfo} returns this
 */
proto.base.v1.ActMgtUserInGameInfo.prototype.setStartsecondstamp = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional int64 endSecondStamp = 13;
 * @return {number}
 */
proto.base.v1.ActMgtUserInGameInfo.prototype.getEndsecondstamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ActMgtUserInGameInfo} returns this
 */
proto.base.v1.ActMgtUserInGameInfo.prototype.setEndsecondstamp = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional int32 mState = 14;
 * @return {number}
 */
proto.base.v1.ActMgtUserInGameInfo.prototype.getMstate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ActMgtUserInGameInfo} returns this
 */
proto.base.v1.ActMgtUserInGameInfo.prototype.setMstate = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional int32 lastHr = 15;
 * @return {number}
 */
proto.base.v1.ActMgtUserInGameInfo.prototype.getLasthr = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ActMgtUserInGameInfo} returns this
 */
proto.base.v1.ActMgtUserInGameInfo.prototype.setLasthr = function(value) {
  return jspb.Message.setProto3IntField(this, 15, value);
};


/**
 * optional string phone = 16;
 * @return {string}
 */
proto.base.v1.ActMgtUserInGameInfo.prototype.getPhone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.base.v1.ActMgtUserInGameInfo} returns this
 */
proto.base.v1.ActMgtUserInGameInfo.prototype.setPhone = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional GameArriveControlPoint nextControlPoint = 17;
 * @return {?proto.base.v1.GameArriveControlPoint}
 */
proto.base.v1.ActMgtUserInGameInfo.prototype.getNextcontrolpoint = function() {
  return /** @type{?proto.base.v1.GameArriveControlPoint} */ (
    jspb.Message.getWrapperField(this, proto.base.v1.GameArriveControlPoint, 17));
};


/**
 * @param {?proto.base.v1.GameArriveControlPoint|undefined} value
 * @return {!proto.base.v1.ActMgtUserInGameInfo} returns this
*/
proto.base.v1.ActMgtUserInGameInfo.prototype.setNextcontrolpoint = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.base.v1.ActMgtUserInGameInfo} returns this
 */
proto.base.v1.ActMgtUserInGameInfo.prototype.clearNextcontrolpoint = function() {
  return this.setNextcontrolpoint(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.base.v1.ActMgtUserInGameInfo.prototype.hasNextcontrolpoint = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional int32 oaId = 18;
 * @return {number}
 */
proto.base.v1.ActMgtUserInGameInfo.prototype.getOaid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ActMgtUserInGameInfo} returns this
 */
proto.base.v1.ActMgtUserInGameInfo.prototype.setOaid = function(value) {
  return jspb.Message.setProto3IntField(this, 18, value);
};


/**
 * optional int32 stepNum = 19;
 * @return {number}
 */
proto.base.v1.ActMgtUserInGameInfo.prototype.getStepnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ActMgtUserInGameInfo} returns this
 */
proto.base.v1.ActMgtUserInGameInfo.prototype.setStepnum = function(value) {
  return jspb.Message.setProto3IntField(this, 19, value);
};


/**
 * optional int32 sysPoint = 20;
 * @return {number}
 */
proto.base.v1.ActMgtUserInGameInfo.prototype.getSyspoint = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 20, 0));
};


/**
 * @param {number} value
 * @return {!proto.base.v1.ActMgtUserInGameInfo} returns this
 */
proto.base.v1.ActMgtUserInGameInfo.prototype.setSyspoint = function(value) {
  return jspb.Message.setProto3IntField(this, 20, value);
};


/**
 * repeated ToControlPoint controlPointSortedList = 21;
 * @return {!Array<!proto.base.v1.ToControlPoint>}
 */
proto.base.v1.ActMgtUserInGameInfo.prototype.getControlpointsortedlistList = function() {
  return /** @type{!Array<!proto.base.v1.ToControlPoint>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.base.v1.ToControlPoint, 21));
};


/**
 * @param {!Array<!proto.base.v1.ToControlPoint>} value
 * @return {!proto.base.v1.ActMgtUserInGameInfo} returns this
*/
proto.base.v1.ActMgtUserInGameInfo.prototype.setControlpointsortedlistList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 21, value);
};


/**
 * @param {!proto.base.v1.ToControlPoint=} opt_value
 * @param {number=} opt_index
 * @return {!proto.base.v1.ToControlPoint}
 */
proto.base.v1.ActMgtUserInGameInfo.prototype.addControlpointsortedlist = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 21, opt_value, proto.base.v1.ToControlPoint, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.base.v1.ActMgtUserInGameInfo} returns this
 */
proto.base.v1.ActMgtUserInGameInfo.prototype.clearControlpointsortedlistList = function() {
  return this.setControlpointsortedlistList([]);
};


/**
 * @enum {number}
 */
proto.base.v1.ErrorCode = {
  OK: 0,
  TOKENEXPIRE: 1000,
  USERBAN: 1001,
  VFCODEEXPIRE: 1002,
  SMSSENDFAIL: 1003,
  USERSTATUSERR: 1008,
  STATUSERR: 1009,
  PHONENOTEXIST: 2001,
  UNKNOWNERR: 2002,
  PARAMERR: 5000,
  HEADSOURCEERR: 5001,
  DATABASE: 9000,
  NORECORD: 9001
};

/**
 * @enum {number}
 */
proto.base.v1.ShopType = {
  UNKNOWSHOP: 0,
  PARKSHOP: 1,
  IPSHOP: 2,
  ADMINSHOP: 3
};

/**
 * @enum {number}
 */
proto.base.v1.UserType = {
  UNDEFINE: 0,
  APPUSER: 1,
  PARKADMIN: 2,
  IPADMIN: 3,
  SYSADMIN: 4,
  TOADMIN: 5,
  COOPTOADMIN: 6
};

/**
 * @enum {number}
 */
proto.base.v1.LoginSource = {
  UNDEF: 0,
  USERAPP: 1,
  WEBADMIN: 2,
  SHOPAPP: 3,
  TOAPP: 4,
  COOPTOWEBADMIN: 5,
  COOPTOAPP: 6,
  VERFADMIN: 7,
  ACTMGTADMIN: 8
};

/**
 * @enum {number}
 */
proto.base.v1.SmsType = {
  UNKNOW: 0,
  LOGIN: 1,
  SIGNUP: 2
};

/**
 * @enum {number}
 */
proto.base.v1.ProjectContentType = {
  TEXT: 0,
  HTML: 1
};

/**
 * @enum {number}
 */
proto.base.v1.CriterionType = {
  CRUNKNOW: 0,
  CRORDER: 1,
  CRNUM: 2
};

/**
 * @enum {number}
 */
proto.base.v1.CType = {
  UNKNOWTYPE: 0,
  BEGINTYPE: 1,
  MIDDLETYPE: 2,
  ENDTYPE: 3
};

/**
 * @enum {number}
 */
proto.base.v1.StatusType = {
  UNKNOWSTATUS: 0,
  NORMALSTATUS: 1,
  DISABLEDSTATUS: 8,
  DELETESTATUS: 9
};

/**
 * @enum {number}
 */
proto.base.v1.HrBandType = {
  UNKNOWHRBAND: 0,
  USEHRBAND: 1,
  NOTUSEHRBAND: 2
};

/**
 * @enum {number}
 */
proto.base.v1.GameState = {
  ALLGAMESTATE: 0,
  NORMALGAMESTATE: 1,
  ABNORMALGAMESTATE: 2
};

/**
 * @enum {number}
 */
proto.base.v1.CState = {
  TOUNSEND: 0,
  TOUNSTART: 1,
  TOSTART: 2,
  TOFINISH: 3,
  TOOTHER: 9
};

/**
 * @enum {number}
 */
proto.base.v1.GameHistorySource = {
  GAMEHISTORYSOURCALL: 0,
  GAMEHISTORYSOURCEORIENTEER: 1,
  GAMEHISTORYSOURCEASS: 2
};

/**
 * @enum {number}
 */
proto.base.v1.BackGroundColor = {
  UNKNOWCOLOR: 0,
  BLUECOLOR: 1,
  GREENCOLOR: 2,
  BROWNCOLOR: 3
};

goog.object.extend(exports, proto.base.v1);
